const EvaBite = [
  {
    "": "0",
    time: "1637709648.893125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-20.5078125",
    c3: "-16.6015625",
    c4: "-65.91796875",
  },
  {
    "": "1",
    time: "1637709648.8970313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-18.5546875",
    c3: "-41.015625",
    c4: "-34.1796875",
  },
  {
    "": "2",
    time: "1637709648.9009376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-21.484375",
    c3: "-34.66796875",
    c4: "14.6484375",
  },
  {
    "": "3",
    time: "1637709648.9048438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-14.6484375",
    c3: "-17.578125",
    c4: "-12.6953125",
  },
  {
    "": "4",
    time: "1637709648.90875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-28.80859375",
    c3: "-23.92578125",
    c4: "-63.4765625",
  },
  {
    "": "5",
    time: "1637709648.9126563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-41.9921875",
    c3: "-67.87109375",
    c4: "-44.43359375",
  },
  {
    "": "6",
    time: "1637709648.9165626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-8.30078125",
    c3: "-75.1953125",
    c4: "16.6015625",
  },
  {
    "": "7",
    time: "1637709648.9204688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-3.90625",
    c3: "-49.8046875",
    c4: "15.13671875",
  },
  {
    "": "8",
    time: "1637709648.924375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-17.578125",
    c3: "-5.37109375",
    c4: "-46.38671875",
  },
  {
    "": "9",
    time: "1637709648.9282813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-22.4609375",
    c3: "-2.44140625",
    c4: "-46.875",
  },
  {
    "": "10",
    time: "1637709648.9321876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-16.6015625",
    c3: "-27.34375",
    c4: "11.23046875",
  },
  {
    "": "11",
    time: "1637709648.9360938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-22.94921875",
    c3: "-15.13671875",
    c4: "9.765625",
  },
  {
    "": "12",
    time: "1637709648.942125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-34.66796875",
    c3: "-0.48828125",
    c4: "-44.921875",
  },
  {
    "": "13",
    time: "1637709648.9460313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-34.1796875",
    c3: "-16.6015625",
    c4: "-68.359375",
  },
  {
    "": "14",
    time: "1637709648.9499376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-24.4140625",
    c3: "-53.7109375",
    c4: "-23.92578125",
  },
  {
    "": "15",
    time: "1637709648.9538438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-29.78515625",
    c3: "-32.71484375",
    c4: "0.48828125",
  },
  {
    "": "16",
    time: "1637709648.95775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-41.50390625",
    c3: "-13.18359375",
    c4: "-44.921875",
  },
  {
    "": "17",
    time: "1637709648.9616563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-57.12890625",
    c3: "-35.64453125",
    c4: "-84.47265625",
  },
  {
    "": "18",
    time: "1637709648.9655626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.75390625",
    c2: "-42.48046875",
    c3: "-62.98828125",
    c4: "-54.6875",
  },
  {
    "": "19",
    time: "1637709648.9694688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-27.83203125",
    c3: "-36.62109375",
    c4: "-12.6953125",
  },
  {
    "": "20",
    time: "1637709648.973375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-30.76171875",
    c3: "-2.9296875",
    c4: "-27.83203125",
  },
  {
    "": "21",
    time: "1637709648.9772813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-22.4609375",
    c3: "-24.4140625",
    c4: "-58.10546875",
  },
  {
    "": "22",
    time: "1637709648.9811876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-31.73828125",
    c3: "-23.4375",
    c4: "-47.36328125",
  },
  {
    "": "23",
    time: "1637709648.9850938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-46.875",
    c3: "-30.2734375",
    c4: "3.41796875",
  },
  {
    "": "24",
    time: "1637709648.983125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-33.203125",
    c3: "-51.7578125",
    c4: "4.8828125",
  },
  {
    "": "25",
    time: "1637709648.9870312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-20.99609375",
    c3: "-26.85546875",
    c4: "-62.98828125",
  },
  {
    "": "26",
    time: "1637709648.9909375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-21.97265625",
    c3: "-3.90625",
    c4: "-69.3359375",
  },
  {
    "": "27",
    time: "1637709648.9948437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-18.5546875",
    c3: "-25.87890625",
    c4: "-18.5546875",
  },
  {
    "": "28",
    time: "1637709648.99875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-20.5078125",
    c3: "-47.36328125",
    c4: "7.32421875",
  },
  {
    "": "29",
    time: "1637709649.0026562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-42.96875",
    c3: "-53.22265625",
    c4: "-13.671875",
  },
  {
    "": "30",
    time: "1637709649.0065625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-52.734375",
    c3: "-92.28515625",
    c4: "-48.828125",
  },
  {
    "": "31",
    time: "1637709649.0104687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-16.11328125",
    c3: "-44.921875",
    c4: "-24.4140625",
  },
  {
    "": "32",
    time: "1637709649.014375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-1.953125",
    c3: "13.671875",
    c4: "14.16015625",
  },
  {
    "": "33",
    time: "1637709649.0182812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-10.7421875",
    c3: "2.44140625",
    c4: "-22.4609375",
  },
  {
    "": "34",
    time: "1637709649.0221875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.1953125",
    c2: "-13.18359375",
    c3: "-0.9765625",
    c4: "-81.54296875",
  },
  {
    "": "35",
    time: "1637709649.0260937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-34.1796875",
    c3: "-12.20703125",
    c4: "-59.08203125",
  },
  {
    "": "36",
    time: "1637709649.043125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-64.94140625",
    c3: "-10.25390625",
    c4: "4.39453125",
  },
  {
    "": "37",
    time: "1637709649.0470312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-69.3359375",
    c3: "-18.5546875",
    c4: "-7.8125",
  },
  {
    "": "38",
    time: "1637709649.0509374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-48.828125",
    c3: "-35.64453125",
    c4: "-54.19921875",
  },
  {
    "": "39",
    time: "1637709649.0548437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-24.4140625",
    c3: "-34.66796875",
    c4: "-56.640625",
  },
  {
    "": "40",
    time: "1637709649.05875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-26.3671875",
    c3: "3.90625",
    c4: "-14.6484375",
  },
  {
    "": "41",
    time: "1637709649.0626562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-34.1796875",
    c3: "-9.765625",
    c4: "-18.06640625",
  },
  {
    "": "42",
    time: "1637709649.0665624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-23.4375",
    c3: "-37.59765625",
    c4: "-64.453125",
  },
  {
    "": "43",
    time: "1637709649.0704687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-20.99609375",
    c3: "-10.7421875",
    c4: "-59.08203125",
  },
  {
    "": "44",
    time: "1637709649.074375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-34.1796875",
    c3: "9.765625",
    c4: "-27.34375",
  },
  {
    "": "45",
    time: "1637709649.0782812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-60.546875",
    c3: "-34.66796875",
    c4: "-21.97265625",
  },
  {
    "": "46",
    time: "1637709649.0821874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-82.03125",
    c3: "-43.9453125",
    c4: "-67.87109375",
  },
  {
    "": "47",
    time: "1637709649.0860937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-58.10546875",
    c3: "-5.37109375",
    c4: "-102.05078125",
  },
  {
    "": "48",
    time: "1637709649.088125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-32.71484375",
    c3: "-13.18359375",
    c4: "-63.4765625",
  },
  {
    "": "49",
    time: "1637709649.0920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-35.15625",
    c3: "-10.25390625",
    c4: "-7.32421875",
  },
  {
    "": "50",
    time: "1637709649.0959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-38.57421875",
    c3: "5.37109375",
    c4: "-17.578125",
  },
  {
    "": "51",
    time: "1637709649.0998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-16.11328125",
    c3: "-20.5078125",
    c4: "-44.43359375",
  },
  {
    "": "52",
    time: "1637709649.10375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-26.3671875",
    c3: "-55.6640625",
    c4: "-41.015625",
  },
  {
    "": "53",
    time: "1637709649.1076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-50.29296875",
    c3: "-39.0625",
    c4: "-25.390625",
  },
  {
    "": "54",
    time: "1637709649.1115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-41.015625",
    c3: "-0.9765625",
    c4: "-25.87890625",
  },
  {
    "": "55",
    time: "1637709649.1154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-44.43359375",
    c3: "-1.46484375",
    c4: "-59.5703125",
  },
  {
    "": "56",
    time: "1637709649.119375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-55.6640625",
    c3: "-18.5546875",
    c4: "-53.7109375",
  },
  {
    "": "57",
    time: "1637709649.1232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-49.31640625",
    c3: "-11.71875",
    c4: "-8.7890625",
  },
  {
    "": "58",
    time: "1637709649.1271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-33.203125",
    c3: "25.390625",
    c4: "-20.01953125",
  },
  {
    "": "59",
    time: "1637709649.1310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-19.53125",
    c3: "18.06640625",
    c4: "-58.59375",
  },
  {
    "": "60",
    time: "1637709649.134125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-24.90234375",
    c3: "-4.8828125",
    c4: "-59.5703125",
  },
  {
    "": "61",
    time: "1637709649.1380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-40.52734375",
    c3: "16.11328125",
    c4: "-20.5078125",
  },
  {
    "": "62",
    time: "1637709649.1419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-61.5234375",
    c3: "24.4140625",
    c4: "7.8125",
  },
  {
    "": "63",
    time: "1637709649.1458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-81.54296875",
    c3: "-1.46484375",
    c4: "-17.578125",
  },
  {
    "": "64",
    time: "1637709649.14975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-57.12890625",
    c3: "-24.4140625",
    c4: "-46.875",
  },
  {
    "": "65",
    time: "1637709649.1536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-27.34375",
    c3: "-53.7109375",
    c4: "-26.3671875",
  },
  {
    "": "66",
    time: "1637709649.1575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-34.66796875",
    c3: "-39.55078125",
    c4: "7.32421875",
  },
  {
    "": "67",
    time: "1637709649.1614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-52.24609375",
    c3: "6.34765625",
    c4: "-13.18359375",
  },
  {
    "": "68",
    time: "1637709649.165375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-48.33984375",
    c3: "6.8359375",
    c4: "-42.48046875",
  },
  {
    "": "69",
    time: "1637709649.1692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-23.4375",
    c3: "9.27734375",
    c4: "-46.38671875",
  },
  {
    "": "70",
    time: "1637709649.1731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-28.3203125",
    c3: "5.37109375",
    c4: "-15.13671875",
  },
  {
    "": "71",
    time: "1637709649.1770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-39.0625",
    c3: "-1.953125",
    c4: "2.44140625",
  },
  {
    "": "72",
    time: "1637709649.179125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-26.3671875",
    c3: "8.30078125",
    c4: "-50.29296875",
  },
  {
    "": "73",
    time: "1637709649.1830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-41.9921875",
    c3: "-24.90234375",
    c4: "-71.77734375",
  },
  {
    "": "74",
    time: "1637709649.1869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-43.9453125",
    c3: "-28.80859375",
    c4: "-23.92578125",
  },
  {
    "": "75",
    time: "1637709649.1908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-60.05859375",
    c3: "-6.8359375",
    c4: "-7.8125",
  },
  {
    "": "76",
    time: "1637709649.19475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-59.5703125",
    c3: "-0.48828125",
    c4: "-58.10546875",
  },
  {
    "": "77",
    time: "1637709649.1986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-30.2734375",
    c3: "-2.9296875",
    c4: "-90.8203125",
  },
  {
    "": "78",
    time: "1637709649.2025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-37.59765625",
    c3: "-24.4140625",
    c4: "-53.7109375",
  },
  {
    "": "79",
    time: "1637709649.2064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-45.8984375",
    c3: "-29.78515625",
    c4: "-8.7890625",
  },
  {
    "": "80",
    time: "1637709649.210375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-36.62109375",
    c3: "-31.25",
    c4: "-42.48046875",
  },
  {
    "": "81",
    time: "1637709649.2142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-25.390625",
    c3: "4.8828125",
    c4: "-91.796875",
  },
  {
    "": "82",
    time: "1637709649.2181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-23.92578125",
    c3: "0.9765625",
    c4: "-64.453125",
  },
  {
    "": "83",
    time: "1637709649.2220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-50.78125",
    c3: "-8.7890625",
    c4: "-16.11328125",
  },
  {
    "": "84",
    time: "1637709649.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-75.1953125",
    c3: "10.7421875",
    c4: "-30.2734375",
  },
  {
    "": "85",
    time: "1637709649.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-85.44921875",
    c2: "-54.6875",
    c3: "10.25390625",
    c4: "-67.3828125",
  },
  {
    "": "86",
    time: "1637709649.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-88.37890625",
    c2: "-29.78515625",
    c3: "-13.18359375",
    c4: "-52.734375",
  },
  {
    "": "87",
    time: "1637709649.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-34.66796875",
    c3: "-9.765625",
    c4: "-10.25390625",
  },
  {
    "": "88",
    time: "1637709649.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-49.8046875",
    c3: "4.39453125",
    c4: "-27.34375",
  },
  {
    "": "89",
    time: "1637709649.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-42.96875",
    c3: "-17.08984375",
    c4: "-86.42578125",
  },
  {
    "": "90",
    time: "1637709649.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.1015625",
    c2: "-30.76171875",
    c3: "-55.17578125",
    c4: "-86.42578125",
  },
  {
    "": "91",
    time: "1637709649.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-41.50390625",
    c3: "-72.75390625",
    c4: "-27.83203125",
  },
  {
    "": "92",
    time: "1637709649.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-56.15234375",
    c3: "-19.53125",
    c4: "-9.765625",
  },
  {
    "": "93",
    time: "1637709649.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-31.25",
    c3: "9.765625",
    c4: "-61.03515625",
  },
  {
    "": "94",
    time: "1637709649.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-20.01953125",
    c3: "-8.7890625",
    c4: "-84.9609375",
  },
  {
    "": "95",
    time: "1637709649.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-44.921875",
    c3: "-12.6953125",
    c4: "-47.8515625",
  },
  {
    "": "96",
    time: "1637709649.268125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-43.9453125",
    c3: "0.9765625",
    c4: "-13.671875",
  },
  {
    "": "97",
    time: "1637709649.2720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-30.76171875",
    c3: "-0.9765625",
    c4: "-58.10546875",
  },
  {
    "": "98",
    time: "1637709649.2759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.1484375",
    c2: "-36.62109375",
    c3: "-46.38671875",
    c4: "-84.9609375",
  },
  {
    "": "99",
    time: "1637709649.2798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-66.89453125",
    c3: "-69.82421875",
    c4: "-41.50390625",
  },
  {
    "": "100",
    time: "1637709649.28375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-61.5234375",
    c3: "-26.3671875",
    c4: "0.0",
  },
  {
    "": "101",
    time: "1637709649.2876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-29.296875",
    c3: "-5.37109375",
    c4: "-25.87890625",
  },
  {
    "": "102",
    time: "1637709649.2915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-29.296875",
    c3: "-9.27734375",
    c4: "-58.10546875",
  },
  {
    "": "103",
    time: "1637709649.2954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-40.52734375",
    c3: "-39.55078125",
    c4: "-43.9453125",
  },
  {
    "": "104",
    time: "1637709649.299375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-38.57421875",
    c3: "13.671875",
    c4: "-27.34375",
  },
  {
    "": "105",
    time: "1637709649.3032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-45.41015625",
    c3: "53.22265625",
    c4: "-27.83203125",
  },
  {
    "": "106",
    time: "1637709649.3071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-62.98828125",
    c3: "8.30078125",
    c4: "-53.7109375",
  },
  {
    "": "107",
    time: "1637709649.3110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.75390625",
    c2: "-47.8515625",
    c3: "-13.671875",
    c4: "-77.63671875",
  },
  {
    "": "108",
    time: "1637709649.315125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-16.11328125",
    c3: "-1.46484375",
    c4: "-26.3671875",
  },
  {
    "": "109",
    time: "1637709649.3190312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-21.97265625",
    c3: "6.8359375",
    c4: "13.18359375",
  },
  {
    "": "110",
    time: "1637709649.3229375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-64.453125",
    c3: "-29.78515625",
    c4: "-24.4140625",
  },
  {
    "": "111",
    time: "1637709649.3268437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-37.59765625",
    c3: "-19.04296875",
    c4: "-65.91796875",
  },
  {
    "": "112",
    time: "1637709649.33075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "5.859375",
    c3: "-12.6953125",
    c4: "-40.0390625",
  },
  {
    "": "113",
    time: "1637709649.3346562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-2.9296875",
    c3: "-42.96875",
    c4: "7.32421875",
  },
  {
    "": "114",
    time: "1637709649.3385625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-16.11328125",
    c3: "-38.0859375",
    c4: "-15.13671875",
  },
  {
    "": "115",
    time: "1637709649.3424687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-13.671875",
    c3: "-2.44140625",
    c4: "-62.01171875",
  },
  {
    "": "116",
    time: "1637709649.346375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-9.27734375",
    c3: "12.20703125",
    c4: "-42.96875",
  },
  {
    "": "117",
    time: "1637709649.3502812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-16.6015625",
    c3: "-21.484375",
    c4: "16.6015625",
  },
  {
    "": "118",
    time: "1637709649.3541875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-30.76171875",
    c3: "-45.41015625",
    c4: "10.7421875",
  },
  {
    "": "119",
    time: "1637709649.3580937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-23.4375",
    c3: "-31.73828125",
    c4: "-49.31640625",
  },
  {
    "": "120",
    time: "1637709649.358125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-23.4375",
    c3: "-18.5546875",
    c4: "-55.6640625",
  },
  {
    "": "121",
    time: "1637709649.3620312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-65.91796875",
    c3: "-25.390625",
    c4: "-1.46484375",
  },
  {
    "": "122",
    time: "1637709649.3659375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-74.21875",
    c3: "-21.97265625",
    c4: "15.13671875",
  },
  {
    "": "123",
    time: "1637709649.3698437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-38.57421875",
    c3: "-20.99609375",
    c4: "-39.0625",
  },
  {
    "": "124",
    time: "1637709649.37375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-16.6015625",
    c3: "-38.57421875",
    c4: "-51.7578125",
  },
  {
    "": "125",
    time: "1637709649.3776562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-27.83203125",
    c3: "-38.57421875",
    c4: "-4.8828125",
  },
  {
    "": "126",
    time: "1637709649.3815625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-49.8046875",
    c3: "-19.04296875",
    c4: "21.97265625",
  },
  {
    "": "127",
    time: "1637709649.3854687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-37.109375",
    c3: "4.8828125",
    c4: "-28.3203125",
  },
  {
    "": "128",
    time: "1637709649.389375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.265625",
    c2: "-10.7421875",
    c3: "-12.20703125",
    c4: "-74.21875",
  },
  {
    "": "129",
    time: "1637709649.3932812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-20.5078125",
    c3: "-17.08984375",
    c4: "-31.73828125",
  },
  {
    "": "130",
    time: "1637709649.3971875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-40.52734375",
    c3: "1.46484375",
    c4: "0.48828125",
  },
  {
    "": "131",
    time: "1637709649.4010937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-35.64453125",
    c3: "1.46484375",
    c4: "-37.109375",
  },
  {
    "": "132",
    time: "1637709649.407125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-22.94921875",
    c3: "-15.13671875",
    c4: "-66.40625",
  },
  {
    "": "133",
    time: "1637709649.4110312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-14.6484375",
    c3: "-28.80859375",
    c4: "-51.26953125",
  },
  {
    "": "134",
    time: "1637709649.4149375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-20.5078125",
    c3: "-18.5546875",
    c4: "-7.32421875",
  },
  {
    "": "135",
    time: "1637709649.4188437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-37.109375",
    c3: "-8.7890625",
    c4: "-5.859375",
  },
  {
    "": "136",
    time: "1637709649.42275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-33.203125",
    c3: "-20.5078125",
    c4: "-38.0859375",
  },
  {
    "": "137",
    time: "1637709649.4266562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-41.015625",
    c3: "-40.52734375",
    c4: "-51.7578125",
  },
  {
    "": "138",
    time: "1637709649.4305625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-48.33984375",
    c3: "-19.04296875",
    c4: "-11.23046875",
  },
  {
    "": "139",
    time: "1637709649.4344687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-22.4609375",
    c3: "6.34765625",
    c4: "20.01953125",
  },
  {
    "": "140",
    time: "1637709649.438375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-27.34375",
    c3: "-20.5078125",
    c4: "-11.23046875",
  },
  {
    "": "141",
    time: "1637709649.4422812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-34.1796875",
    c3: "-37.59765625",
    c4: "-29.78515625",
  },
  {
    "": "142",
    time: "1637709649.4461875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-28.3203125",
    c3: "2.44140625",
    c4: "-12.6953125",
  },
  {
    "": "143",
    time: "1637709649.4500937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-53.22265625",
    c3: "-2.9296875",
    c4: "21.97265625",
  },
  {
    "": "144",
    time: "1637709649.463125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-49.31640625",
    c3: "-51.7578125",
    c4: "-16.11328125",
  },
  {
    "": "145",
    time: "1637709649.4670312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-18.06640625",
    c3: "-48.33984375",
    c4: "-59.08203125",
  },
  {
    "": "146",
    time: "1637709649.4709375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-15.13671875",
    c3: "-25.390625",
    c4: "-33.203125",
  },
  {
    "": "147",
    time: "1637709649.4748437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-40.0390625",
    c3: "2.9296875",
    c4: "20.99609375",
  },
  {
    "": "148",
    time: "1637709649.47875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-45.8984375",
    c3: "-7.8125",
    c4: "-0.48828125",
  },
  {
    "": "149",
    time: "1637709649.4826562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-34.1796875",
    c3: "-33.203125",
    c4: "-49.8046875",
  },
  {
    "": "150",
    time: "1637709649.4865625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-50.78125",
    c3: "-27.83203125",
    c4: "-44.43359375",
  },
  {
    "": "151",
    time: "1637709649.4904687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-33.69140625",
    c3: "-11.23046875",
    c4: "15.625",
  },
  {
    "": "152",
    time: "1637709649.494375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-31.73828125",
    c3: "-11.71875",
    c4: "24.90234375",
  },
  {
    "": "153",
    time: "1637709649.4982812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-54.6875",
    c3: "-20.01953125",
    c4: "-61.03515625",
  },
  {
    "": "154",
    time: "1637709649.5021875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-50.78125",
    c3: "-17.578125",
    c4: "-73.73046875",
  },
  {
    "": "155",
    time: "1637709649.5060937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-26.3671875",
    c3: "-14.16015625",
    c4: "-22.94921875",
  },
  {
    "": "156",
    time: "1637709649.510125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-0.48828125",
    c3: "-6.34765625",
    c4: "-5.37109375",
  },
  {
    "": "157",
    time: "1637709649.5140312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "1.953125",
    c3: "-6.8359375",
    c4: "-26.85546875",
  },
  {
    "": "158",
    time: "1637709649.5179374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-26.3671875",
    c3: "-31.25",
    c4: "-52.734375",
  },
  {
    "": "159",
    time: "1637709649.5218437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-48.828125",
    c3: "-56.640625",
    c4: "-28.80859375",
  },
  {
    "": "160",
    time: "1637709649.52575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-57.6171875",
    c3: "-14.16015625",
    c4: "8.30078125",
  },
  {
    "": "161",
    time: "1637709649.5296562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-56.640625",
    c3: "-4.39453125",
    c4: "-20.01953125",
  },
  {
    "": "162",
    time: "1637709649.5335624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-30.2734375",
    c3: "-32.71484375",
    c4: "-63.96484375",
  },
  {
    "": "163",
    time: "1637709649.5374687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "2.44140625",
    c3: "-29.78515625",
    c4: "-34.66796875",
  },
  {
    "": "164",
    time: "1637709649.541375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-3.41796875",
    c3: "-51.26953125",
    c4: "26.85546875",
  },
  {
    "": "165",
    time: "1637709649.5452812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-37.109375",
    c3: "-33.203125",
    c4: "6.34765625",
  },
  {
    "": "166",
    time: "1637709649.5491874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-49.8046875",
    c3: "-3.90625",
    c4: "-40.52734375",
  },
  {
    "": "167",
    time: "1637709649.5530937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-37.109375",
    c3: "-33.69140625",
    c4: "-39.55078125",
  },
  {
    "": "168",
    time: "1637709649.553125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-17.578125",
    c3: "-29.78515625",
    c4: "1.953125",
  },
  {
    "": "169",
    time: "1637709649.5570312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-12.20703125",
    c3: "5.859375",
    c4: "11.23046875",
  },
  {
    "": "170",
    time: "1637709649.5609374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-16.6015625",
    c3: "-13.18359375",
    c4: "-31.73828125",
  },
  {
    "": "171",
    time: "1637709649.5648437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-43.9453125",
    c3: "-55.17578125",
    c4: "-24.4140625",
  },
  {
    "": "172",
    time: "1637709649.56875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-36.62109375",
    c3: "-37.109375",
    c4: "3.41796875",
  },
  {
    "": "173",
    time: "1637709649.5726562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-5.37109375",
    c3: "-34.1796875",
    c4: "6.34765625",
  },
  {
    "": "174",
    time: "1637709649.5765624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-28.80859375",
    c3: "-59.08203125",
    c4: "-34.66796875",
  },
  {
    "": "175",
    time: "1637709649.5804687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-39.0625",
    c3: "-50.78125",
    c4: "-51.7578125",
  },
  {
    "": "176",
    time: "1637709649.584375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-60.05859375",
    c3: "-45.8984375",
    c4: "-18.06640625",
  },
  {
    "": "177",
    time: "1637709649.5882812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-62.5",
    c3: "-10.25390625",
    c4: "-1.46484375",
  },
  {
    "": "178",
    time: "1637709649.5921874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-31.73828125",
    c3: "-9.765625",
    c4: "-30.2734375",
  },
  {
    "": "179",
    time: "1637709649.5960937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-18.5546875",
    c3: "-49.31640625",
    c4: "-55.17578125",
  },
  {
    "": "180",
    time: "1637709649.600125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-3.41796875",
    c3: "-56.640625",
    c4: "-54.6875",
  },
  {
    "": "181",
    time: "1637709649.6040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-36.1328125",
    c3: "2.44140625",
    c4: "-30.2734375",
  },
  {
    "": "182",
    time: "1637709649.6079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-62.98828125",
    c3: "25.87890625",
    c4: "-6.8359375",
  },
  {
    "": "183",
    time: "1637709649.6118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-48.33984375",
    c3: "-2.44140625",
    c4: "-57.6171875",
  },
  {
    "": "184",
    time: "1637709649.61575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-36.1328125",
    c3: "-20.5078125",
    c4: "-67.3828125",
  },
  {
    "": "185",
    time: "1637709649.6196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-37.59765625",
    c3: "-52.734375",
    c4: "-23.92578125",
  },
  {
    "": "186",
    time: "1637709649.6235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-58.59375",
    c3: "-41.50390625",
    c4: "-20.99609375",
  },
  {
    "": "187",
    time: "1637709649.6274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-59.5703125",
    c3: "-28.3203125",
    c4: "-60.05859375",
  },
  {
    "": "188",
    time: "1637709649.631375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-28.3203125",
    c3: "-58.59375",
    c4: "-88.37890625",
  },
  {
    "": "189",
    time: "1637709649.6352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-8.7890625",
    c3: "-61.5234375",
    c4: "-55.6640625",
  },
  {
    "": "190",
    time: "1637709649.6391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-18.06640625",
    c3: "-37.109375",
    c4: "-15.625",
  },
  {
    "": "191",
    time: "1637709649.6430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-26.3671875",
    c3: "-18.5546875",
    c4: "-30.76171875",
  },
  {
    "": "192",
    time: "1637709649.645125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.265625",
    c2: "-43.9453125",
    c3: "-12.20703125",
    c4: "-75.1953125",
  },
  {
    "": "193",
    time: "1637709649.6490312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-54.6875",
    c3: "-15.13671875",
    c4: "-83.984375",
  },
  {
    "": "194",
    time: "1637709649.6529374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-30.2734375",
    c3: "-24.4140625",
    c4: "-37.59765625",
  },
  {
    "": "195",
    time: "1637709649.6568437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-23.4375",
    c3: "-42.48046875",
    c4: "-44.43359375",
  },
  {
    "": "196",
    time: "1637709649.66075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-58.10546875",
    c3: "-33.203125",
    c4: "-80.078125",
  },
  {
    "": "197",
    time: "1637709649.6646562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-68.84765625",
    c3: "-17.578125",
    c4: "-61.5234375",
  },
  {
    "": "198",
    time: "1637709649.6685624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-41.50390625",
    c3: "-42.48046875",
    c4: "3.90625",
  },
  {
    "": "199",
    time: "1637709649.6724687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-32.2265625",
    c3: "-79.58984375",
    c4: "12.6953125",
  },
  {
    "": "200",
    time: "1637709649.676375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-38.57421875",
    c3: "-29.78515625",
    c4: "-63.4765625",
  },
  {
    "": "201",
    time: "1637709649.6802812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.68359375",
    c2: "-38.0859375",
    c3: "-4.39453125",
    c4: "-88.8671875",
  },
  {
    "": "202",
    time: "1637709649.6841874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-45.41015625",
    c3: "-28.3203125",
    c4: "-28.80859375",
  },
  {
    "": "203",
    time: "1637709649.6880937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-41.50390625",
    c3: "-3.41796875",
    c4: "1.953125",
  },
  {
    "": "204",
    time: "1637709649.690125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-28.80859375",
    c3: "28.80859375",
    c4: "-50.29296875",
  },
  {
    "": "205",
    time: "1637709649.6940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-36.62109375",
    c3: "5.859375",
    c4: "-83.49609375",
  },
  {
    "": "206",
    time: "1637709649.6979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-51.26953125",
    c3: "-27.34375",
    c4: "-34.1796875",
  },
  {
    "": "207",
    time: "1637709649.7018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-44.43359375",
    c3: "-16.6015625",
    c4: "2.9296875",
  },
  {
    "": "208",
    time: "1637709649.70575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-25.390625",
    c3: "-21.484375",
    c4: "-31.25",
  },
  {
    "": "209",
    time: "1637709649.7096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-36.1328125",
    c3: "-26.3671875",
    c4: "-57.6171875",
  },
  {
    "": "210",
    time: "1637709649.7135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-54.19921875",
    c3: "-64.453125",
    c4: "-34.66796875",
  },
  {
    "": "211",
    time: "1637709649.7174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-46.875",
    c3: "-41.50390625",
    c4: "-7.8125",
  },
  {
    "": "212",
    time: "1637709649.721375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-43.9453125",
    c3: "10.7421875",
    c4: "-31.73828125",
  },
  {
    "": "213",
    time: "1637709649.7252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-48.828125",
    c3: "-24.90234375",
    c4: "-63.96484375",
  },
  {
    "": "214",
    time: "1637709649.7291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-20.01953125",
    c3: "-20.5078125",
    c4: "-58.10546875",
  },
  {
    "": "215",
    time: "1637709649.7330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-10.25390625",
    c3: "9.765625",
    c4: "-9.27734375",
  },
  {
    "": "216",
    time: "1637709649.733125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-29.296875",
    c3: "22.94921875",
    c4: "7.32421875",
  },
  {
    "": "217",
    time: "1637709649.7370312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-32.71484375",
    c3: "-9.765625",
    c4: "-46.875",
  },
  {
    "": "218",
    time: "1637709649.7409375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-46.38671875",
    c3: "-48.828125",
    c4: "-73.2421875",
  },
  {
    "": "219",
    time: "1637709649.7448437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-49.8046875",
    c3: "-51.26953125",
    c4: "-33.69140625",
  },
  {
    "": "220",
    time: "1637709649.74875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-16.6015625",
    c3: "-14.16015625",
    c4: "-6.34765625",
  },
  {
    "": "221",
    time: "1637709649.7526562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-10.7421875",
    c3: "-13.671875",
    c4: "-41.9921875",
  },
  {
    "": "222",
    time: "1637709649.7565625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-49.8046875",
    c3: "-57.12890625",
    c4: "-50.29296875",
  },
  {
    "": "223",
    time: "1637709649.7604687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-45.41015625",
    c3: "-20.5078125",
    c4: "-36.62109375",
  },
  {
    "": "224",
    time: "1637709649.764375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-18.06640625",
    c3: "6.34765625",
    c4: "-25.390625",
  },
  {
    "": "225",
    time: "1637709649.7682812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-25.390625",
    c3: "-37.59765625",
    c4: "-40.0390625",
  },
  {
    "": "226",
    time: "1637709649.7721875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.63671875",
    c2: "-41.50390625",
    c3: "-39.55078125",
    c4: "-73.73046875",
  },
  {
    "": "227",
    time: "1637709649.7760937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-26.3671875",
    c3: "-2.44140625",
    c4: "-61.03515625",
  },
  {
    "": "228",
    time: "1637709649.793125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-23.4375",
    c3: "15.625",
    c4: "-16.11328125",
  },
  {
    "": "229",
    time: "1637709649.7970312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-28.80859375",
    c3: "0.9765625",
    c4: "-11.71875",
  },
  {
    "": "230",
    time: "1637709649.8009374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-31.73828125",
    c3: "-10.7421875",
    c4: "-56.15234375",
  },
  {
    "": "231",
    time: "1637709649.8048437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-43.45703125",
    c3: "-12.6953125",
    c4: "-59.5703125",
  },
  {
    "": "232",
    time: "1637709649.80875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-37.109375",
    c3: "-5.37109375",
    c4: "-19.04296875",
  },
  {
    "": "233",
    time: "1637709649.8126562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-38.0859375",
    c3: "-31.25",
    c4: "9.765625",
  },
  {
    "": "234",
    time: "1637709649.8165624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-35.64453125",
    c3: "-61.03515625",
    c4: "-28.80859375",
  },
  {
    "": "235",
    time: "1637709649.8204687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-37.109375",
    c3: "-28.80859375",
    c4: "-69.3359375",
  },
  {
    "": "236",
    time: "1637709649.824375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-44.43359375",
    c3: "-1.46484375",
    c4: "-15.13671875",
  },
  {
    "": "237",
    time: "1637709649.8282812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-35.64453125",
    c3: "-10.25390625",
    c4: "28.3203125",
  },
  {
    "": "238",
    time: "1637709649.8321874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-40.0390625",
    c3: "-11.71875",
    c4: "-31.25",
  },
  {
    "": "239",
    time: "1637709649.8360937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-68.84765625",
    c3: "-18.06640625",
    c4: "-67.3828125",
  },
  {
    "": "240",
    time: "1637709649.838125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-85.9375",
    c3: "-38.57421875",
    c4: "-41.50390625",
  },
  {
    "": "241",
    time: "1637709649.8420312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-48.33984375",
    c3: "-19.04296875",
    c4: "-19.53125",
  },
  {
    "": "242",
    time: "1637709649.8459375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-18.5546875",
    c3: "17.08984375",
    c4: "-34.66796875",
  },
  {
    "": "243",
    time: "1637709649.8498437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-40.52734375",
    c3: "-4.39453125",
    c4: "-81.0546875",
  },
  {
    "": "244",
    time: "1637709649.85375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-40.0390625",
    c3: "-57.12890625",
    c4: "-58.59375",
  },
  {
    "": "245",
    time: "1637709649.8576562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-26.3671875",
    c3: "-45.8984375",
    c4: "0.0",
  },
  {
    "": "246",
    time: "1637709649.8615625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-23.92578125",
    c3: "5.859375",
    c4: "-12.20703125",
  },
  {
    "": "247",
    time: "1637709649.8654687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-21.484375",
    c3: "-4.39453125",
    c4: "-62.01171875",
  },
  {
    "": "248",
    time: "1637709649.869375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-21.97265625",
    c3: "-58.10546875",
    c4: "-60.546875",
  },
  {
    "": "249",
    time: "1637709649.8732812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-20.01953125",
    c3: "-67.3828125",
    c4: "-2.44140625",
  },
  {
    "": "250",
    time: "1637709649.8771875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-33.69140625",
    c3: "-7.8125",
    c4: "4.39453125",
  },
  {
    "": "251",
    time: "1637709649.8810937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-57.12890625",
    c3: "3.90625",
    c4: "-43.45703125",
  },
  {
    "": "252",
    time: "1637709649.883125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-27.34375",
    c3: "-27.83203125",
    c4: "-51.26953125",
  },
  {
    "": "253",
    time: "1637709649.8870313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-5.859375",
    c3: "-16.11328125",
    c4: "-12.6953125",
  },
  {
    "": "254",
    time: "1637709649.8909376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-10.25390625",
    c3: "-3.90625",
    c4: "11.23046875",
  },
  {
    "": "255",
    time: "1637709649.8948438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-10.7421875",
    c3: "-31.73828125",
    c4: "-18.06640625",
  },
  {
    "": "256",
    time: "1637709649.89875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-25.87890625",
    c3: "-47.36328125",
    c4: "-55.6640625",
  },
  {
    "": "257",
    time: "1637709649.9026563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-52.734375",
    c3: "-17.578125",
    c4: "-39.55078125",
  },
  {
    "": "258",
    time: "1637709649.9065626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-50.29296875",
    c3: "-1.953125",
    c4: "9.765625",
  },
  {
    "": "259",
    time: "1637709649.9104688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-30.76171875",
    c3: "-21.97265625",
    c4: "22.4609375",
  },
  {
    "": "260",
    time: "1637709649.914375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-37.59765625",
    c3: "-74.70703125",
    c4: "-22.4609375",
  },
  {
    "": "261",
    time: "1637709649.9182813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-37.59765625",
    c3: "-35.64453125",
    c4: "-50.29296875",
  },
  {
    "": "262",
    time: "1637709649.9221876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-42.48046875",
    c3: "34.66796875",
    c4: "-16.11328125",
  },
  {
    "": "263",
    time: "1637709649.9260938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-44.43359375",
    c3: "35.15625",
    c4: "-24.4140625",
  },
  {
    "": "264",
    time: "1637709649.929125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-40.0390625",
    c3: "13.18359375",
    c4: "-65.4296875",
  },
  {
    "": "265",
    time: "1637709649.9330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-42.48046875",
    c3: "-9.765625",
    c4: "-79.1015625",
  },
  {
    "": "266",
    time: "1637709649.9369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-10.25390625",
    c3: "-9.27734375",
    c4: "-51.7578125",
  },
  {
    "": "267",
    time: "1637709649.9408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-18.5546875",
    c3: "-5.37109375",
    c4: "-2.44140625",
  },
  {
    "": "268",
    time: "1637709649.94475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-19.04296875",
    c3: "-8.30078125",
    c4: "-30.76171875",
  },
  {
    "": "269",
    time: "1637709649.9486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-4.8828125",
    c3: "-4.39453125",
    c4: "-65.91796875",
  },
  {
    "": "270",
    time: "1637709649.9525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-36.62109375",
    c3: "-17.08984375",
    c4: "-25.390625",
  },
  {
    "": "271",
    time: "1637709649.9564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-94.23828125",
    c3: "-26.3671875",
    c4: "11.23046875",
  },
  {
    "": "272",
    time: "1637709649.960375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-69.82421875",
    c3: "-22.4609375",
    c4: "-29.296875",
  },
  {
    "": "273",
    time: "1637709649.9642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-19.04296875",
    c3: "-9.27734375",
    c4: "-87.890625",
  },
  {
    "": "274",
    time: "1637709649.9681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-38.57421875",
    c3: "-19.53125",
    c4: "-65.4296875",
  },
  {
    "": "275",
    time: "1637709649.9720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-34.66796875",
    c3: "-20.01953125",
    c4: "-17.08984375",
  },
  {
    "": "276",
    time: "1637709649.975125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-18.5546875",
    c3: "-9.27734375",
    c4: "-21.484375",
  },
  {
    "": "277",
    time: "1637709649.9790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-19.04296875",
    c3: "1.46484375",
    c4: "-46.38671875",
  },
  {
    "": "278",
    time: "1637709649.9829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-12.20703125",
    c3: "-5.859375",
    c4: "-52.734375",
  },
  {
    "": "279",
    time: "1637709649.9868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-18.5546875",
    c3: "-16.11328125",
    c4: "-31.73828125",
  },
  {
    "": "280",
    time: "1637709649.99075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-33.203125",
    c3: "-34.1796875",
    c4: "-18.06640625",
  },
  {
    "": "281",
    time: "1637709649.9946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-28.3203125",
    c3: "-49.8046875",
    c4: "-42.48046875",
  },
  {
    "": "282",
    time: "1637709649.9985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-41.50390625",
    c3: "-26.85546875",
    c4: "-64.453125",
  },
  {
    "": "283",
    time: "1637709650.0024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-89.84375",
    c3: "-31.73828125",
    c4: "-30.2734375",
  },
  {
    "": "284",
    time: "1637709650.006375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-78.125",
    c3: "-5.859375",
    c4: "12.6953125",
  },
  {
    "": "285",
    time: "1637709650.0102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-36.1328125",
    c3: "24.4140625",
    c4: "-36.1328125",
  },
  {
    "": "286",
    time: "1637709650.0141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-26.3671875",
    c3: "-11.23046875",
    c4: "-79.58984375",
  },
  {
    "": "287",
    time: "1637709650.0180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-27.83203125",
    c3: "-27.83203125",
    c4: "-45.41015625",
  },
  {
    "": "288",
    time: "1637709650.019125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-26.85546875",
    c3: "-29.296875",
    c4: "-8.7890625",
  },
  {
    "": "289",
    time: "1637709650.0230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-34.66796875",
    c3: "-37.109375",
    c4: "-27.34375",
  },
  {
    "": "290",
    time: "1637709650.0269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-44.921875",
    c3: "-41.9921875",
    c4: "-54.19921875",
  },
  {
    "": "291",
    time: "1637709650.0308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-30.76171875",
    c3: "-32.71484375",
    c4: "-39.55078125",
  },
  {
    "": "292",
    time: "1637709650.03475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-28.80859375",
    c3: "-7.32421875",
    c4: "-2.9296875",
  },
  {
    "": "293",
    time: "1637709650.0386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-41.50390625",
    c3: "-17.08984375",
    c4: "15.625",
  },
  {
    "": "294",
    time: "1637709650.0425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-41.015625",
    c3: "-55.17578125",
    c4: "-3.90625",
  },
  {
    "": "295",
    time: "1637709650.0464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-28.80859375",
    c3: "-62.98828125",
    c4: "-37.109375",
  },
  {
    "": "296",
    time: "1637709650.050375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-46.38671875",
    c3: "-17.578125",
    c4: "-8.30078125",
  },
  {
    "": "297",
    time: "1637709650.0542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-66.40625",
    c3: "7.32421875",
    c4: "6.8359375",
  },
  {
    "": "298",
    time: "1637709650.0581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-24.90234375",
    c3: "-21.484375",
    c4: "-45.41015625",
  },
  {
    "": "299",
    time: "1637709650.0620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-19.04296875",
    c3: "-35.15625",
    c4: "-52.734375",
  },
  {
    "": "300",
    time: "1637709650.080125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-41.015625",
    c3: "-1.46484375",
    c4: "-6.8359375",
  },
  {
    "": "301",
    time: "1637709650.0840313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-35.15625",
    c3: "-0.48828125",
    c4: "18.06640625",
  },
  {
    "": "302",
    time: "1637709650.0879376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-17.578125",
    c3: "4.39453125",
    c4: "7.32421875",
  },
  {
    "": "303",
    time: "1637709650.0918438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-6.8359375",
    c3: "13.671875",
    c4: "-34.66796875",
  },
  {
    "": "304",
    time: "1637709650.09575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-3.90625",
    c3: "-2.44140625",
    c4: "-41.015625",
  },
  {
    "": "305",
    time: "1637709650.0996563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-7.8125",
    c3: "-15.625",
    c4: "20.5078125",
  },
  {
    "": "306",
    time: "1637709650.1035626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-6.34765625",
    c3: "-45.8984375",
    c4: "16.6015625",
  },
  {
    "": "307",
    time: "1637709650.1074688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-10.7421875",
    c3: "-45.41015625",
    c4: "-44.921875",
  },
  {
    "": "308",
    time: "1637709650.111375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-36.1328125",
    c3: "-14.16015625",
    c4: "-32.2265625",
  },
  {
    "": "309",
    time: "1637709650.1152813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-44.921875",
    c3: "-20.99609375",
    c4: "19.04296875",
  },
  {
    "": "310",
    time: "1637709650.1191876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-29.296875",
    c3: "-15.625",
    c4: "22.94921875",
  },
  {
    "": "311",
    time: "1637709650.1230938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-17.08984375",
    c3: "-5.37109375",
    c4: "0.48828125",
  },
  {
    "": "312",
    time: "1637709650.110125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-33.203125",
    c3: "-36.1328125",
    c4: "-7.32421875",
  },
  {
    "": "313",
    time: "1637709650.1140313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-60.05859375",
    c3: "-62.01171875",
    c4: "28.3203125",
  },
  {
    "": "314",
    time: "1637709650.1179376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-66.89453125",
    c3: "-39.0625",
    c4: "39.0625",
  },
  {
    "": "315",
    time: "1637709650.1218438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-57.6171875",
    c3: "-23.4375",
    c4: "3.41796875",
  },
  {
    "": "316",
    time: "1637709650.12575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-26.85546875",
    c3: "-21.97265625",
    c4: "-32.2265625",
  },
  {
    "": "317",
    time: "1637709650.1296563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-16.6015625",
    c3: "-9.27734375",
    c4: "47.8515625",
  },
  {
    "": "318",
    time: "1637709650.1335626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.94921875",
    c2: "-32.71484375",
    c3: "-27.83203125",
    c4: "110.3515625",
  },
  {
    "": "319",
    time: "1637709650.1374688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-29.78515625",
    c3: "-23.4375",
    c4: "78.125",
  },
  {
    "": "320",
    time: "1637709650.141375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-13.671875",
    c3: "-2.9296875",
    c4: "35.15625",
  },
  {
    "": "321",
    time: "1637709650.1452813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-44.921875",
    c3: "-23.4375",
    c4: "19.53125",
  },
  {
    "": "322",
    time: "1637709650.1491876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-38.57421875",
    c3: "-31.25",
    c4: "58.59375",
  },
  {
    "": "323",
    time: "1637709650.1530938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-1.46484375",
    c3: "3.41796875",
    c4: "56.640625",
  },
  {
    "": "324",
    time: "1637709650.169125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-17.08984375",
    c3: "7.8125",
    c4: "7.32421875",
  },
  {
    "": "325",
    time: "1637709650.1730313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-28.3203125",
    c3: "8.30078125",
    c4: "-2.9296875",
  },
  {
    "": "326",
    time: "1637709650.1769376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-16.6015625",
    c3: "-1.953125",
    c4: "49.31640625",
  },
  {
    "": "327",
    time: "1637709650.1808438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-14.6484375",
    c3: "-14.6484375",
    c4: "66.40625",
  },
  {
    "": "328",
    time: "1637709650.18475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-21.484375",
    c3: "-24.4140625",
    c4: "-5.859375",
  },
  {
    "": "329",
    time: "1637709650.1886563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.265625",
    c2: "-19.53125",
    c3: "-49.8046875",
    c4: "-38.57421875",
  },
  {
    "": "330",
    time: "1637709650.1925626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-0.9765625",
    c3: "-36.62109375",
    c4: "21.97265625",
  },
  {
    "": "331",
    time: "1637709650.1964688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-16.11328125",
    c3: "-22.4609375",
    c4: "48.33984375",
  },
  {
    "": "332",
    time: "1637709650.200375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-47.8515625",
    c3: "-40.52734375",
    c4: "-9.765625",
  },
  {
    "": "333",
    time: "1637709650.2042813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-52.734375",
    c3: "-41.9921875",
    c4: "-33.69140625",
  },
  {
    "": "334",
    time: "1637709650.2081876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-50.29296875",
    c3: "-14.16015625",
    c4: "14.16015625",
  },
  {
    "": "335",
    time: "1637709650.2120938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-46.875",
    c3: "-4.8828125",
    c4: "54.19921875",
  },
  {
    "": "336",
    time: "1637709650.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-62.5",
    c3: "-21.484375",
    c4: "41.015625",
  },
  {
    "": "337",
    time: "1637709650.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-76.171875",
    c3: "-22.4609375",
    c4: "8.7890625",
  },
  {
    "": "338",
    time: "1637709650.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-50.29296875",
    c3: "-3.41796875",
    c4: "33.69140625",
  },
  {
    "": "339",
    time: "1637709650.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-12.20703125",
    c3: "-24.90234375",
    c4: "78.125",
  },
  {
    "": "340",
    time: "1637709650.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-40.52734375",
    c3: "-79.1015625",
    c4: "77.1484375",
  },
  {
    "": "341",
    time: "1637709650.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-55.17578125",
    c3: "-68.84765625",
    c4: "46.38671875",
  },
  {
    "": "342",
    time: "1637709650.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-90.8203125",
    c2: "-19.04296875",
    c3: "-14.16015625",
    c4: "49.31640625",
  },
  {
    "": "343",
    time: "1637709650.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-91.796875",
    c2: "-16.11328125",
    c3: "-24.90234375",
    c4: "73.73046875",
  },
  {
    "": "344",
    time: "1637709650.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-47.36328125",
    c3: "-30.76171875",
    c4: "61.5234375",
  },
  {
    "": "345",
    time: "1637709650.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.58984375",
    c2: "-52.734375",
    c3: "-20.5078125",
    c4: "21.484375",
  },
  {
    "": "346",
    time: "1637709650.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-101.07421875",
    c2: "-31.25",
    c3: "-14.16015625",
    c4: "-12.6953125",
  },
  {
    "": "347",
    time: "1637709650.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "-35.64453125",
    c3: "-9.765625",
    c4: "16.11328125",
  },
  {
    "": "348",
    time: "1637709650.260125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-25.87890625",
    c3: "-52.734375",
    c4: "59.08203125",
  },
  {
    "": "349",
    time: "1637709650.2640312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-26.85546875",
    c3: "-55.6640625",
    c4: "3.90625",
  },
  {
    "": "350",
    time: "1637709650.2679374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-61.5234375",
    c3: "-11.23046875",
    c4: "-42.48046875",
  },
  {
    "": "351",
    time: "1637709650.2718437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-59.08203125",
    c3: "-23.4375",
    c4: "-3.90625",
  },
  {
    "": "352",
    time: "1637709650.27575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-25.87890625",
    c3: "-35.15625",
    c4: "47.8515625",
  },
  {
    "": "353",
    time: "1637709650.2796562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-49.8046875",
    c3: "-32.71484375",
    c4: "39.55078125",
  },
  {
    "": "354",
    time: "1637709650.2835624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.0078125",
    c2: "-94.7265625",
    c3: "-28.3203125",
    c4: "-25.390625",
  },
  {
    "": "355",
    time: "1637709650.2874687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-98.14453125",
    c2: "-51.7578125",
    c3: "-24.4140625",
    c4: "-41.50390625",
  },
  {
    "": "356",
    time: "1637709650.291375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-11.71875",
    c3: "-30.76171875",
    c4: "33.69140625",
  },
  {
    "": "357",
    time: "1637709650.2952812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-23.4375",
    c3: "-21.484375",
    c4: "-3.90625",
  },
  {
    "": "358",
    time: "1637709650.2991874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "-42.96875",
    c3: "-21.484375",
    c4: "-96.19140625",
  },
  {
    "": "359",
    time: "1637709650.3030937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.65625",
    c2: "-37.109375",
    c3: "-33.69140625",
    c4: "-84.9609375",
  },
  {
    "": "360",
    time: "1637709650.303125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-35.15625",
    c3: "-25.390625",
    c4: "-51.7578125",
  },
  {
    "": "361",
    time: "1637709650.3070312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-37.109375",
    c3: "-5.859375",
    c4: "-14.16015625",
  },
  {
    "": "362",
    time: "1637709650.3109374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-19.53125",
    c3: "2.9296875",
    c4: "-45.8984375",
  },
  {
    "": "363",
    time: "1637709650.3148437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-113.28125",
    c2: "-25.390625",
    c3: "-22.4609375",
    c4: "-97.65625",
  },
  {
    "": "364",
    time: "1637709650.31875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.16796875",
    c2: "-37.109375",
    c3: "-42.96875",
    c4: "-76.171875",
  },
  {
    "": "365",
    time: "1637709650.3226562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-43.45703125",
    c3: "-45.8984375",
    c4: "-30.2734375",
  },
  {
    "": "366",
    time: "1637709650.3265624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-42.96875",
    c3: "-25.390625",
    c4: "-42.96875",
  },
  {
    "": "367",
    time: "1637709650.3304687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.890625",
    c2: "-51.26953125",
    c3: "-24.4140625",
    c4: "-79.1015625",
  },
  {
    "": "368",
    time: "1637709650.334375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.56640625",
    c2: "-36.62109375",
    c3: "-39.55078125",
    c4: "-73.2421875",
  },
  {
    "": "369",
    time: "1637709650.3382812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-15.625",
    c3: "-2.44140625",
    c4: "-48.828125",
  },
  {
    "": "370",
    time: "1637709650.3421874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-21.97265625",
    c3: "5.37109375",
    c4: "-66.89453125",
  },
  {
    "": "371",
    time: "1637709650.3460937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-48.33984375",
    c3: "-36.1328125",
    c4: "-116.2109375",
  },
  {
    "": "372",
    time: "1637709650.352125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-62.98828125",
    c3: "-29.296875",
    c4: "-121.58203125",
  },
  {
    "": "373",
    time: "1637709650.3560312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-30.2734375",
    c3: "13.18359375",
    c4: "-72.265625",
  },
  {
    "": "374",
    time: "1637709650.3599374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-27.83203125",
    c3: "10.25390625",
    c4: "-42.48046875",
  },
  {
    "": "375",
    time: "1637709650.3638437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.078125",
    c2: "-17.578125",
    c3: "4.8828125",
    c4: "-93.75",
  },
  {
    "": "376",
    time: "1637709650.36775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-107.421875",
    c2: "-5.37109375",
    c3: "6.8359375",
    c4: "-145.99609375",
  },
  {
    "": "377",
    time: "1637709650.3716562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.0078125",
    c2: "-19.53125",
    c3: "-16.6015625",
    c4: "-124.0234375",
  },
  {
    "": "378",
    time: "1637709650.3755624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-32.71484375",
    c3: "-20.5078125",
    c4: "-105.95703125",
  },
  {
    "": "379",
    time: "1637709650.3794687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.125",
    c2: "-25.87890625",
    c3: "-33.203125",
    c4: "-159.66796875",
  },
  {
    "": "380",
    time: "1637709650.383375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-100.5859375",
    c2: "-22.94921875",
    c3: "-28.80859375",
    c4: "-198.2421875",
  },
  {
    "": "381",
    time: "1637709650.3872812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-92.7734375",
    c2: "-22.4609375",
    c3: "8.7890625",
    c4: "-153.3203125",
  },
  {
    "": "382",
    time: "1637709650.3911874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-54.6875",
    c3: "-1.953125",
    c4: "-104.00390625",
  },
  {
    "": "383",
    time: "1637709650.3950937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-90.8203125",
    c3: "-36.62109375",
    c4: "-133.30078125",
  },
  {
    "": "384",
    time: "1637709650.393125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-46.38671875",
    c3: "-38.57421875",
    c4: "-189.94140625",
  },
  {
    "": "385",
    time: "1637709650.3970313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-40.52734375",
    c3: "-6.34765625",
    c4: "-189.94140625",
  },
  {
    "": "386",
    time: "1637709650.4009376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-46.875",
    c3: "-4.8828125",
    c4: "-128.90625",
  },
  {
    "": "387",
    time: "1637709650.4048438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-11.71875",
    c3: "-35.64453125",
    c4: "-129.8828125",
  },
  {
    "": "388",
    time: "1637709650.40875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-15.625",
    c3: "-59.08203125",
    c4: "-179.6875",
  },
  {
    "": "389",
    time: "1637709650.4126563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-45.8984375",
    c3: "-38.57421875",
    c4: "-163.0859375",
  },
  {
    "": "390",
    time: "1637709650.4165626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-30.76171875",
    c3: "-29.78515625",
    c4: "-110.83984375",
  },
  {
    "": "391",
    time: "1637709650.4204688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-27.83203125",
    c3: "-43.9453125",
    c4: "-88.8671875",
  },
  {
    "": "392",
    time: "1637709650.424375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-38.57421875",
    c3: "-20.01953125",
    c4: "-116.69921875",
  },
  {
    "": "393",
    time: "1637709650.4282813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.890625",
    c2: "-36.1328125",
    c3: "-8.30078125",
    c4: "-131.34765625",
  },
  {
    "": "394",
    time: "1637709650.4321876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-35.15625",
    c3: "-5.37109375",
    c4: "-98.14453125",
  },
  {
    "": "395",
    time: "1637709650.4360938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-38.57421875",
    c3: "5.859375",
    c4: "-61.03515625",
  },
  {
    "": "396",
    time: "1637709650.440125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-32.71484375",
    c3: "8.7890625",
    c4: "-98.14453125",
  },
  {
    "": "397",
    time: "1637709650.4440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.1953125",
    c2: "-2.44140625",
    c3: "-11.71875",
    c4: "-135.25390625",
  },
  {
    "": "398",
    time: "1637709650.4479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "2.44140625",
    c3: "-39.55078125",
    c4: "-94.23828125",
  },
  {
    "": "399",
    time: "1637709650.4518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-7.32421875",
    c3: "-49.31640625",
    c4: "-48.33984375",
  },
  {
    "": "400",
    time: "1637709650.45575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-28.3203125",
    c3: "-9.765625",
    c4: "-71.2890625",
  },
  {
    "": "401",
    time: "1637709650.4596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-38.57421875",
    c3: "-6.8359375",
    c4: "-109.86328125",
  },
  {
    "": "402",
    time: "1637709650.4635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.1015625",
    c2: "-18.06640625",
    c3: "-43.45703125",
    c4: "-78.61328125",
  },
  {
    "": "403",
    time: "1637709650.4674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-14.6484375",
    c3: "-36.62109375",
    c4: "-94.7265625",
  },
  {
    "": "404",
    time: "1637709650.471375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-26.3671875",
    c3: "-10.7421875",
    c4: "-122.0703125",
  },
  {
    "": "405",
    time: "1637709650.4752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-34.66796875",
    c3: "-23.4375",
    c4: "-151.85546875",
  },
  {
    "": "406",
    time: "1637709650.4791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.078125",
    c2: "-40.52734375",
    c3: "-27.83203125",
    c4: "-216.30859375",
  },
  {
    "": "407",
    time: "1637709650.4830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-92.7734375",
    c2: "-17.08984375",
    c3: "2.44140625",
    c4: "-197.75390625",
  },
  {
    "": "408",
    time: "1637709650.483125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-37.59765625",
    c3: "5.859375",
    c4: "-146.97265625",
  },
  {
    "": "409",
    time: "1637709650.4870312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.8828125",
    c2: "-45.41015625",
    c3: "-4.8828125",
    c4: "-173.828125",
  },
  {
    "": "410",
    time: "1637709650.4909375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-37.59765625",
    c3: "-20.01953125",
    c4: "-264.16015625",
  },
  {
    "": "411",
    time: "1637709650.4948437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-47.36328125",
    c3: "-25.87890625",
    c4: "-235.83984375",
  },
  {
    "": "412",
    time: "1637709650.49875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-31.73828125",
    c3: "-20.5078125",
    c4: "-157.2265625",
  },
  {
    "": "413",
    time: "1637709650.5026562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-32.2265625",
    c3: "-41.015625",
    c4: "-209.9609375",
  },
  {
    "": "414",
    time: "1637709650.5065625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-20.5078125",
    c3: "-59.08203125",
    c4: "-303.7109375",
  },
  {
    "": "415",
    time: "1637709650.5104687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-5.859375",
    c3: "-20.01953125",
    c4: "-261.23046875",
  },
  {
    "": "416",
    time: "1637709650.514375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-30.2734375",
    c3: "24.4140625",
    c4: "-176.7578125",
  },
  {
    "": "417",
    time: "1637709650.5182812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-38.57421875",
    c3: "0.9765625",
    c4: "-236.81640625",
  },
  {
    "": "418",
    time: "1637709650.5221875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-61.5234375",
    c3: "-45.8984375",
    c4: "-239.74609375",
  },
  {
    "": "419",
    time: "1637709650.5260937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "40.52734375",
    c2: "-67.3828125",
    c3: "-17.08984375",
    c4: "-149.4140625",
  },
  {
    "": "420",
    time: "1637709650.543125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "16.6015625",
    c2: "-6.34765625",
    c3: "-0.48828125",
    c4: "-112.3046875",
  },
  {
    "": "421",
    time: "1637709650.5470312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "15.13671875",
    c3: "-0.9765625",
    c4: "-94.7265625",
  },
  {
    "": "422",
    time: "1637709650.5509374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "36.62109375",
    c2: "-30.2734375",
    c3: "13.671875",
    c4: "-108.3984375",
  },
  {
    "": "423",
    time: "1637709650.5548437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-122.55859375",
    c2: "3.90625",
    c3: "3.41796875",
    c4: "-192.3828125",
  },
  {
    "": "424",
    time: "1637709650.55875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-0.9765625",
    c3: "7.8125",
    c4: "-137.20703125",
  },
  {
    "": "425",
    time: "1637709650.5626562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "148.4375",
    c2: "-47.36328125",
    c3: "27.34375",
    c4: "-56.640625",
  },
  {
    "": "426",
    time: "1637709650.5665624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-2.9296875",
    c3: "-21.484375",
    c4: "-117.67578125",
  },
  {
    "": "427",
    time: "1637709650.5704687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-98.14453125",
    c2: "-27.34375",
    c3: "7.32421875",
    c4: "-177.734375",
  },
  {
    "": "428",
    time: "1637709650.574375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "30.2734375",
    c2: "-58.59375",
    c3: "26.3671875",
    c4: "-146.97265625",
  },
  {
    "": "429",
    time: "1637709650.5782812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "77.1484375",
    c2: "-42.48046875",
    c3: "-14.16015625",
    c4: "-59.5703125",
  },
  {
    "": "430",
    time: "1637709650.5821874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "112.3046875",
    c2: "-25.390625",
    c3: "-6.8359375",
    c4: "-24.4140625",
  },
  {
    "": "431",
    time: "1637709650.5860937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "59.08203125",
    c2: "-8.7890625",
    c3: "0.48828125",
    c4: "-107.421875",
  },
  {
    "": "432",
    time: "1637709650.589125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "61.5234375",
    c2: "-4.39453125",
    c3: "-12.6953125",
    c4: "-51.26953125",
  },
  {
    "": "433",
    time: "1637709650.5930312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "83.984375",
    c2: "-2.9296875",
    c3: "18.5546875",
    c4: "-15.625",
  },
  {
    "": "434",
    time: "1637709650.5969374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "41.50390625",
    c2: "-1.46484375",
    c3: "34.1796875",
    c4: "-57.6171875",
  },
  {
    "": "435",
    time: "1637709650.6008437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "20.01953125",
    c3: "-5.859375",
    c4: "-68.84765625",
  },
  {
    "": "436",
    time: "1637709650.60475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-7.8125",
    c3: "-11.23046875",
    c4: "-93.75",
  },
  {
    "": "437",
    time: "1637709650.6086562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "41.9921875",
    c2: "-33.69140625",
    c3: "19.53125",
    c4: "-15.13671875",
  },
  {
    "": "438",
    time: "1637709650.6125624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "122.0703125",
    c2: "-37.109375",
    c3: "62.01171875",
    c4: "51.26953125",
  },
  {
    "": "439",
    time: "1637709650.6164687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "170.8984375",
    c2: "-27.83203125",
    c3: "20.5078125",
    c4: "70.3125",
  },
  {
    "": "440",
    time: "1637709650.620375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "422.36328125",
    c2: "-75.68359375",
    c3: "-89.84375",
    c4: "311.03515625",
  },
  {
    "": "441",
    time: "1637709650.6242812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "449.70703125",
    c2: "-92.28515625",
    c3: "-63.96484375",
    c4: "306.15234375",
  },
  {
    "": "442",
    time: "1637709650.6281874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "295.8984375",
    c2: "-60.546875",
    c3: "-5.859375",
    c4: "201.171875",
  },
  {
    "": "443",
    time: "1637709650.6320937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "220.703125",
    c2: "-61.5234375",
    c3: "-3.90625",
    c4: "196.2890625",
  },
  {
    "": "444",
    time: "1637709650.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "170.41015625",
    c2: "-51.7578125",
    c3: "-8.30078125",
    c4: "219.7265625",
  },
  {
    "": "445",
    time: "1637709650.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "126.46484375",
    c2: "-35.64453125",
    c3: "32.71484375",
    c4: "253.90625",
  },
  {
    "": "446",
    time: "1637709650.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "63.4765625",
    c2: "-3.90625",
    c3: "25.87890625",
    c4: "243.65234375",
  },
  {
    "": "447",
    time: "1637709650.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.1953125",
    c2: "22.94921875",
    c3: "61.5234375",
    c4: "98.6328125",
  },
  {
    "": "448",
    time: "1637709650.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-118.1640625",
    c2: "-11.71875",
    c3: "109.375",
    c4: "-25.390625",
  },
  {
    "": "449",
    time: "1637709650.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "75.1953125",
    c2: "-28.80859375",
    c3: "-31.25",
    c4: "251.953125",
  },
  {
    "": "450",
    time: "1637709650.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "100.5859375",
    c2: "-14.6484375",
    c3: "-39.55078125",
    c4: "431.640625",
  },
  {
    "": "451",
    time: "1637709650.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "84.47265625",
    c2: "-74.21875",
    c3: "25.390625",
    c4: "369.140625",
  },
  {
    "": "452",
    time: "1637709650.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "103.515625",
    c2: "-84.47265625",
    c3: "-19.53125",
    c4: "262.6953125",
  },
  {
    "": "453",
    time: "1637709650.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "78.61328125",
    c2: "-32.2265625",
    c3: "-73.2421875",
    c4: "269.53125",
  },
  {
    "": "454",
    time: "1637709650.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "109.375",
    c2: "-59.08203125",
    c3: "-7.32421875",
    c4: "269.04296875",
  },
  {
    "": "455",
    time: "1637709650.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "75.68359375",
    c2: "-41.9921875",
    c3: "-1.46484375",
    c4: "167.96875",
  },
  {
    "": "456",
    time: "1637709650.678125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "39.55078125",
    c2: "-47.36328125",
    c3: "-29.78515625",
    c4: "190.91796875",
  },
  {
    "": "457",
    time: "1637709650.6820312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "43.9453125",
    c2: "-89.35546875",
    c3: "26.85546875",
    c4: "146.484375",
  },
  {
    "": "458",
    time: "1637709650.6859374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "183.59375",
    c2: "-70.3125",
    c3: "0.48828125",
    c4: "319.82421875",
  },
  {
    "": "459",
    time: "1637709650.6898437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "123.046875",
    c2: "-52.734375",
    c3: "-52.734375",
    c4: "323.2421875",
  },
  {
    "": "460",
    time: "1637709650.69375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "67.3828125",
    c2: "-80.56640625",
    c3: "-22.94921875",
    c4: "254.8828125",
  },
  {
    "": "461",
    time: "1637709650.6976562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "180.6640625",
    c2: "-41.015625",
    c3: "-49.8046875",
    c4: "333.984375",
  },
  {
    "": "462",
    time: "1637709650.7015624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "109.86328125",
    c2: "-9.765625",
    c3: "-39.55078125",
    c4: "298.33984375",
  },
  {
    "": "463",
    time: "1637709650.7054687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "97.16796875",
    c2: "-65.91796875",
    c3: "-31.25",
    c4: "333.0078125",
  },
  {
    "": "464",
    time: "1637709650.709375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "79.1015625",
    c2: "-56.640625",
    c3: "-72.75390625",
    c4: "253.41796875",
  },
  {
    "": "465",
    time: "1637709650.7132812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "53.7109375",
    c2: "-40.0390625",
    c3: "-42.48046875",
    c4: "194.82421875",
  },
  {
    "": "466",
    time: "1637709650.7171874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-23.4375",
    c3: "-15.13671875",
    c4: "187.98828125",
  },
  {
    "": "467",
    time: "1637709650.7210937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "30.76171875",
    c2: "-77.1484375",
    c3: "-10.7421875",
    c4: "199.70703125",
  },
  {
    "": "468",
    time: "1637709650.725125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "108.3984375",
    c2: "-60.05859375",
    c3: "-34.66796875",
    c4: "192.3828125",
  },
  {
    "": "469",
    time: "1637709650.7290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "30.2734375",
    c3: "-32.71484375",
    c4: "130.37109375",
  },
  {
    "": "470",
    time: "1637709650.7329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "25.87890625",
    c2: "-37.59765625",
    c3: "-11.23046875",
    c4: "273.92578125",
  },
  {
    "": "471",
    time: "1637709650.7368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-33.69140625",
    c3: "0.48828125",
    c4: "132.32421875",
  },
  {
    "": "472",
    time: "1637709650.74075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "69.3359375",
    c2: "-33.69140625",
    c3: "-39.55078125",
    c4: "183.59375",
  },
  {
    "": "473",
    time: "1637709650.7446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "179.19921875",
    c2: "-57.12890625",
    c3: "-80.078125",
    c4: "346.6796875",
  },
  {
    "": "474",
    time: "1637709650.7485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "54.19921875",
    c2: "-30.2734375",
    c3: "-26.85546875",
    c4: "111.81640625",
  },
  {
    "": "475",
    time: "1637709650.7524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "17.08984375",
    c2: "-43.9453125",
    c3: "-14.6484375",
    c4: "100.5859375",
  },
  {
    "": "476",
    time: "1637709650.756375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "45.8984375",
    c2: "-65.91796875",
    c3: "-46.875",
    c4: "238.28125",
  },
  {
    "": "477",
    time: "1637709650.7602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "35.15625",
    c2: "-29.78515625",
    c3: "-28.80859375",
    c4: "232.421875",
  },
  {
    "": "478",
    time: "1637709650.7641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-3.41796875",
    c3: "-6.8359375",
    c4: "173.828125",
  },
  {
    "": "479",
    time: "1637709650.7680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "46.38671875",
    c2: "-56.15234375",
    c3: "18.5546875",
    c4: "64.453125",
  },
  {
    "": "480",
    time: "1637709650.768125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "99.609375",
    c2: "-34.1796875",
    c3: "-6.34765625",
    c4: "184.08203125",
  },
  {
    "": "481",
    time: "1637709650.7720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "79.1015625",
    c2: "-13.18359375",
    c3: "-25.87890625",
    c4: "215.8203125",
  },
  {
    "": "482",
    time: "1637709650.7759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "39.0625",
    c2: "-39.55078125",
    c3: "-40.52734375",
    c4: "121.09375",
  },
  {
    "": "483",
    time: "1637709650.7798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "103.02734375",
    c2: "-30.2734375",
    c3: "-81.0546875",
    c4: "227.05078125",
  },
  {
    "": "484",
    time: "1637709650.78375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "32.2265625",
    c2: "-49.8046875",
    c3: "-34.1796875",
    c4: "124.0234375",
  },
  {
    "": "485",
    time: "1637709650.7876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-60.05859375",
    c3: "-0.48828125",
    c4: "79.58984375",
  },
  {
    "": "486",
    time: "1637709650.7915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "107.91015625",
    c2: "-10.25390625",
    c3: "-98.6328125",
    c4: "200.1953125",
  },
  {
    "": "487",
    time: "1637709650.7954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "32.2265625",
    c2: "-29.296875",
    c3: "-166.9921875",
    c4: "162.59765625",
  },
  {
    "": "488",
    time: "1637709650.799375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "-65.4296875",
    c3: "-163.0859375",
    c4: "151.85546875",
  },
  {
    "": "489",
    time: "1637709650.8032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "41.50390625",
    c2: "-45.8984375",
    c3: "-188.4765625",
    c4: "105.95703125",
  },
  {
    "": "490",
    time: "1637709650.8071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "30.2734375",
    c2: "-6.8359375",
    c3: "-216.796875",
    c4: "78.125",
  },
  {
    "": "491",
    time: "1637709650.8110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-16.6015625",
    c3: "-213.37890625",
    c4: "20.5078125",
  },
  {
    "": "492",
    time: "1637709650.817125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-59.08203125",
    c3: "-185.546875",
    c4: "38.0859375",
  },
  {
    "": "493",
    time: "1637709650.8210313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "92.7734375",
    c2: "-38.0859375",
    c3: "-172.8515625",
    c4: "140.625",
  },
  {
    "": "494",
    time: "1637709650.8249376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "35.15625",
    c2: "-30.2734375",
    c3: "-169.43359375",
    c4: "134.27734375",
  },
  {
    "": "495",
    time: "1637709650.8288438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-37.59765625",
    c3: "-107.421875",
    c4: "-6.8359375",
  },
  {
    "": "496",
    time: "1637709650.83275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-21.97265625",
    c3: "-77.1484375",
    c4: "29.78515625",
  },
  {
    "": "497",
    time: "1637709650.8366563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.99609375",
    c2: "-18.5546875",
    c3: "-93.75",
    c4: "186.03515625",
  },
  {
    "": "498",
    time: "1637709650.8405626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.1015625",
    c2: "-14.16015625",
    c3: "-117.1875",
    c4: "95.21484375",
  },
  {
    "": "499",
    time: "1637709650.8444688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-23.4375",
    c3: "-93.75",
    c4: "30.76171875",
  },
  {
    "": "500",
    time: "1637709650.848375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "33.69140625",
    c2: "-4.8828125",
    c3: "-45.41015625",
    c4: "46.38671875",
  },
  {
    "": "501",
    time: "1637709650.8522813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-15.625",
    c3: "-33.69140625",
    c4: "68.84765625",
  },
  {
    "": "502",
    time: "1637709650.8561876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "26.3671875",
    c2: "-52.24609375",
    c3: "-32.71484375",
    c4: "68.359375",
  },
  {
    "": "503",
    time: "1637709650.8600938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-31.73828125",
    c3: "-20.01953125",
    c4: "35.15625",
  },
  {
    "": "504",
    time: "1637709650.874125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-22.94921875",
    c3: "-19.53125",
    c4: "6.34765625",
  },
  {
    "": "505",
    time: "1637709650.8780313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-24.90234375",
    c3: "-47.8515625",
    c4: "49.31640625",
  },
  {
    "": "506",
    time: "1637709650.8819375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "38.57421875",
    c2: "-32.2265625",
    c3: "-72.265625",
    c4: "91.796875",
  },
  {
    "": "507",
    time: "1637709650.8858438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "20.99609375",
    c2: "-34.66796875",
    c3: "-45.8984375",
    c4: "29.78515625",
  },
  {
    "": "508",
    time: "1637709650.88975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-25.390625",
    c3: "-7.8125",
    c4: "6.34765625",
  },
  {
    "": "509",
    time: "1637709650.8936563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-47.36328125",
    c3: "-20.5078125",
    c4: "64.94140625",
  },
  {
    "": "510",
    time: "1637709650.8975625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-39.0625",
    c3: "-62.5",
    c4: "97.65625",
  },
  {
    "": "511",
    time: "1637709650.9014688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-37.59765625",
    c3: "-26.3671875",
    c4: "55.6640625",
  },
  {
    "": "512",
    time: "1637709650.905375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-42.48046875",
    c3: "7.8125",
    c4: "22.4609375",
  },
  {
    "": "513",
    time: "1637709650.9092813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-40.52734375",
    c3: "-23.4375",
    c4: "49.31640625",
  },
  {
    "": "514",
    time: "1637709650.9131875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-34.1796875",
    c3: "-67.87109375",
    c4: "74.21875",
  },
  {
    "": "515",
    time: "1637709650.9170938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-19.53125",
    c3: "-65.4296875",
    c4: "70.80078125",
  },
  {
    "": "516",
    time: "1637709650.905125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-20.5078125",
    c3: "-16.6015625",
    c4: "39.55078125",
  },
  {
    "": "517",
    time: "1637709650.9090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-13.671875",
    c3: "-22.4609375",
    c4: "32.2265625",
  },
  {
    "": "518",
    time: "1637709650.9129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-12.6953125",
    c3: "-41.015625",
    c4: "72.265625",
  },
  {
    "": "519",
    time: "1637709650.9168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-5.859375",
    c3: "-20.99609375",
    c4: "83.0078125",
  },
  {
    "": "520",
    time: "1637709650.92075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-10.7421875",
    c3: "-15.13671875",
    c4: "45.41015625",
  },
  {
    "": "521",
    time: "1637709650.9246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-37.59765625",
    c3: "-40.0390625",
    c4: "26.3671875",
  },
  {
    "": "522",
    time: "1637709650.9285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-20.01953125",
    c3: "-58.10546875",
    c4: "66.40625",
  },
  {
    "": "523",
    time: "1637709650.9324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-5.37109375",
    c3: "-41.015625",
    c4: "78.125",
  },
  {
    "": "524",
    time: "1637709650.936375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-19.53125",
    c3: "-29.296875",
    c4: "30.76171875",
  },
  {
    "": "525",
    time: "1637709650.9402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-27.83203125",
    c3: "-73.2421875",
    c4: "2.44140625",
  },
  {
    "": "526",
    time: "1637709650.9441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-29.296875",
    c3: "-60.546875",
    c4: "18.5546875",
  },
  {
    "": "527",
    time: "1637709650.9480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-13.671875",
    c3: "-21.97265625",
    c4: "71.2890625",
  },
  {
    "": "528",
    time: "1637709650.963125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-24.4140625",
    c3: "-27.34375",
    c4: "88.8671875",
  },
  {
    "": "529",
    time: "1637709650.9670312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.73046875",
    c2: "-42.48046875",
    c3: "-23.4375",
    c4: "43.9453125",
  },
  {
    "": "530",
    time: "1637709650.9709375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-91.796875",
    c2: "-27.83203125",
    c3: "-10.25390625",
    c4: "42.96875",
  },
  {
    "": "531",
    time: "1637709650.9748437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-16.6015625",
    c3: "-25.87890625",
    c4: "92.7734375",
  },
  {
    "": "532",
    time: "1637709650.97875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-25.87890625",
    c3: "-56.15234375",
    c4: "102.5390625",
  },
  {
    "": "533",
    time: "1637709650.9826562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-35.15625",
    c3: "-65.4296875",
    c4: "65.91796875",
  },
  {
    "": "534",
    time: "1637709650.9865625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-99.609375",
    c2: "-33.203125",
    c3: "-35.15625",
    c4: "63.4765625",
  },
  {
    "": "535",
    time: "1637709650.9904687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.58984375",
    c2: "-52.734375",
    c3: "-14.6484375",
    c4: "90.8203125",
  },
  {
    "": "536",
    time: "1637709650.994375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-50.78125",
    c3: "-41.015625",
    c4: "109.375",
  },
  {
    "": "537",
    time: "1637709650.9982812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-44.921875",
    c3: "-50.29296875",
    c4: "100.5859375",
  },
  {
    "": "538",
    time: "1637709651.0021875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.65625",
    c2: "-34.1796875",
    c3: "-22.94921875",
    c4: "53.22265625",
  },
  {
    "": "539",
    time: "1637709651.0060937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.984375",
    c2: "-8.7890625",
    c3: "-43.45703125",
    c4: "81.0546875",
  },
  {
    "": "540",
    time: "1637709651.009125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-15.13671875",
    c3: "-66.89453125",
    c4: "169.921875",
  },
  {
    "": "541",
    time: "1637709651.0130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-93.75",
    c2: "-40.0390625",
    c3: "-66.89453125",
    c4: "137.20703125",
  },
  {
    "": "542",
    time: "1637709651.0169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-119.62890625",
    c2: "-37.59765625",
    c3: "-45.41015625",
    c4: "70.3125",
  },
  {
    "": "543",
    time: "1637709651.0208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-114.74609375",
    c2: "-51.7578125",
    c3: "-29.78515625",
    c4: "108.3984375",
  },
  {
    "": "544",
    time: "1637709651.02475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-96.19140625",
    c2: "-59.5703125",
    c3: "-30.76171875",
    c4: "162.59765625",
  },
  {
    "": "545",
    time: "1637709651.0286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-94.7265625",
    c2: "-33.69140625",
    c3: "-45.8984375",
    c4: "104.98046875",
  },
  {
    "": "546",
    time: "1637709651.0325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-118.1640625",
    c2: "-31.25",
    c3: "-54.6875",
    c4: "21.484375",
  },
  {
    "": "547",
    time: "1637709651.0364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-119.140625",
    c2: "-40.0390625",
    c3: "-46.875",
    c4: "43.45703125",
  },
  {
    "": "548",
    time: "1637709651.040375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-98.6328125",
    c2: "-55.17578125",
    c3: "-46.38671875",
    c4: "115.234375",
  },
  {
    "": "549",
    time: "1637709651.0442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-85.9375",
    c2: "-44.921875",
    c3: "-15.625",
    c4: "113.76953125",
  },
  {
    "": "550",
    time: "1637709651.0481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.61328125",
    c2: "-26.3671875",
    c3: "-9.765625",
    c4: "37.59765625",
  },
  {
    "": "551",
    time: "1637709651.0520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-98.14453125",
    c2: "-27.34375",
    c3: "-52.24609375",
    c4: "16.6015625",
  },
  {
    "": "552",
    time: "1637709651.053125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-98.6328125",
    c2: "-32.2265625",
    c3: "-62.98828125",
    c4: "32.71484375",
  },
  {
    "": "553",
    time: "1637709651.0570312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "-40.52734375",
    c3: "-18.06640625",
    c4: "26.85546875",
  },
  {
    "": "554",
    time: "1637709651.0609374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-103.02734375",
    c2: "-41.015625",
    c3: "-17.08984375",
    c4: "-36.62109375",
  },
  {
    "": "555",
    time: "1637709651.0648437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-109.375",
    c2: "-31.73828125",
    c3: "-57.12890625",
    c4: "-92.7734375",
  },
  {
    "": "556",
    time: "1637709651.06875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-99.609375",
    c2: "-21.97265625",
    c3: "-69.82421875",
    c4: "-84.47265625",
  },
  {
    "": "557",
    time: "1637709651.0726562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.0078125",
    c2: "-24.4140625",
    c3: "-63.96484375",
    c4: "-68.359375",
  },
  {
    "": "558",
    time: "1637709651.0765624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.61328125",
    c2: "-36.1328125",
    c3: "-43.45703125",
    c4: "-84.9609375",
  },
  {
    "": "559",
    time: "1637709651.0804687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-91.796875",
    c2: "-36.62109375",
    c3: "-53.7109375",
    c4: "-107.91015625",
  },
  {
    "": "560",
    time: "1637709651.084375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-89.84375",
    c2: "-43.45703125",
    c3: "-64.94140625",
    c4: "-87.890625",
  },
  {
    "": "561",
    time: "1637709651.0882812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.125",
    c2: "-55.6640625",
    c3: "-18.5546875",
    c4: "-49.31640625",
  },
  {
    "": "562",
    time: "1637709651.0921874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-84.47265625",
    c2: "-31.25",
    c3: "-17.578125",
    c4: "-67.87109375",
  },
  {
    "": "563",
    time: "1637709651.0960937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-113.28125",
    c2: "-22.4609375",
    c3: "-47.36328125",
    c4: "-149.4140625",
  },
  {
    "": "564",
    time: "1637709651.102125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-110.3515625",
    c2: "-34.66796875",
    c3: "-43.9453125",
    c4: "-180.17578125",
  },
  {
    "": "565",
    time: "1637709651.1060312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-90.33203125",
    c2: "-28.3203125",
    c3: "-35.64453125",
    c4: "-127.9296875",
  },
  {
    "": "566",
    time: "1637709651.1099374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.125",
    c2: "-33.69140625",
    c3: "-41.50390625",
    c4: "-100.5859375",
  },
  {
    "": "567",
    time: "1637709651.1138437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-38.57421875",
    c3: "-47.36328125",
    c4: "-128.41796875",
  },
  {
    "": "568",
    time: "1637709651.11775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.16796875",
    c2: "-31.25",
    c3: "-35.64453125",
    c4: "-159.66796875",
  },
  {
    "": "569",
    time: "1637709651.1216562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-88.37890625",
    c2: "-25.87890625",
    c3: "-39.0625",
    c4: "-126.46484375",
  },
  {
    "": "570",
    time: "1637709651.1255624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-27.83203125",
    c3: "-54.6875",
    c4: "-87.40234375",
  },
  {
    "": "571",
    time: "1637709651.1294687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-27.83203125",
    c3: "-75.68359375",
    c4: "-110.83984375",
  },
  {
    "": "572",
    time: "1637709651.133375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.65625",
    c2: "-33.203125",
    c3: "-47.36328125",
    c4: "-149.4140625",
  },
  {
    "": "573",
    time: "1637709651.1372812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-93.26171875",
    c2: "-66.40625",
    c3: "-6.34765625",
    c4: "-127.9296875",
  },
  {
    "": "574",
    time: "1637709651.1411874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-49.8046875",
    c3: "-44.921875",
    c4: "-81.54296875",
  },
  {
    "": "575",
    time: "1637709651.1450937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-17.578125",
    c3: "-50.78125",
    c4: "-103.02734375",
  },
  {
    "": "576",
    time: "1637709651.143125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-106.4453125",
    c2: "-19.04296875",
    c3: "-13.671875",
    c4: "-152.83203125",
  },
  {
    "": "577",
    time: "1637709651.1470313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.984375",
    c2: "-18.06640625",
    c3: "-20.01953125",
    c4: "-161.1328125",
  },
  {
    "": "578",
    time: "1637709651.1509376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-22.4609375",
    c3: "-35.15625",
    c4: "-129.8828125",
  },
  {
    "": "579",
    time: "1637709651.1548438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-36.62109375",
    c3: "-50.78125",
    c4: "-125.48828125",
  },
  {
    "": "580",
    time: "1637709651.15875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.890625",
    c2: "-51.26953125",
    c3: "-54.6875",
    c4: "-176.26953125",
  },
  {
    "": "581",
    time: "1637709651.1626563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.65625",
    c2: "-45.41015625",
    c3: "-61.5234375",
    c4: "-178.7109375",
  },
  {
    "": "582",
    time: "1637709651.1665626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-40.52734375",
    c3: "-63.4765625",
    c4: "-134.765625",
  },
  {
    "": "583",
    time: "1637709651.1704688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-41.9921875",
    c3: "-71.77734375",
    c4: "-112.79296875",
  },
  {
    "": "584",
    time: "1637709651.174375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-26.3671875",
    c3: "-37.109375",
    c4: "-136.23046875",
  },
  {
    "": "585",
    time: "1637709651.1782813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.1484375",
    c2: "-37.59765625",
    c3: "-12.20703125",
    c4: "-166.50390625",
  },
  {
    "": "586",
    time: "1637709651.1821876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-62.5",
    c3: "-19.53125",
    c4: "-125.9765625",
  },
  {
    "": "587",
    time: "1637709651.1860938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-62.01171875",
    c3: "-20.5078125",
    c4: "-88.37890625",
  },
  {
    "": "588",
    time: "1637709651.190125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-36.62109375",
    c3: "-25.390625",
    c4: "-114.74609375",
  },
  {
    "": "589",
    time: "1637709651.1940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-16.11328125",
    c3: "-31.25",
    c4: "-154.78515625",
  },
  {
    "": "590",
    time: "1637709651.1979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-14.6484375",
    c3: "-44.43359375",
    c4: "-150.87890625",
  },
  {
    "": "591",
    time: "1637709651.2018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "0.9765625",
    c3: "-43.9453125",
    c4: "-113.28125",
  },
  {
    "": "592",
    time: "1637709651.20575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-11.71875",
    c3: "-28.3203125",
    c4: "-127.9296875",
  },
  {
    "": "593",
    time: "1637709651.2096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-82.03125",
    c2: "-41.9921875",
    c3: "-33.203125",
    c4: "-191.89453125",
  },
  {
    "": "594",
    time: "1637709651.2135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.9140625",
    c2: "-27.83203125",
    c3: "-45.8984375",
    c4: "-172.36328125",
  },
  {
    "": "595",
    time: "1637709651.2174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-13.671875",
    c3: "-31.25",
    c4: "-100.09765625",
  },
  {
    "": "596",
    time: "1637709651.221375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-20.99609375",
    c3: "-11.23046875",
    c4: "-97.16796875",
  },
  {
    "": "597",
    time: "1637709651.2252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-12.20703125",
    c3: "-46.38671875",
    c4: "-149.4140625",
  },
  {
    "": "598",
    time: "1637709651.2291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-0.9765625",
    c3: "-69.3359375",
    c4: "-161.62109375",
  },
  {
    "": "599",
    time: "1637709651.2330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-24.4140625",
    c3: "-16.6015625",
    c4: "-107.91015625",
  },
  {
    "": "600",
    time: "1637709651.233125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-42.48046875",
    c3: "-19.04296875",
    c4: "-108.3984375",
  },
  {
    "": "601",
    time: "1637709651.2370312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-20.01953125",
    c3: "-31.25",
    c4: "-140.13671875",
  },
  {
    "": "602",
    time: "1637709651.2409375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.890625",
    c2: "-11.71875",
    c3: "-15.625",
    c4: "-142.578125",
  },
  {
    "": "603",
    time: "1637709651.2448437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-17.08984375",
    c3: "-32.71484375",
    c4: "-117.67578125",
  },
  {
    "": "604",
    time: "1637709651.24875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-13.671875",
    c3: "-39.0625",
    c4: "-72.265625",
  },
  {
    "": "605",
    time: "1637709651.2526562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-14.16015625",
    c3: "-38.57421875",
    c4: "-84.9609375",
  },
  {
    "": "606",
    time: "1637709651.2565625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-81.0546875",
    c2: "-13.671875",
    c3: "-51.7578125",
    c4: "-123.046875",
  },
  {
    "": "607",
    time: "1637709651.2604687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-81.54296875",
    c2: "-21.484375",
    c3: "-3.90625",
    c4: "-112.3046875",
  },
  {
    "": "608",
    time: "1637709651.264375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-41.015625",
    c3: "10.25390625",
    c4: "-61.5234375",
  },
  {
    "": "609",
    time: "1637709651.2682812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-37.59765625",
    c3: "-24.4140625",
    c4: "-74.70703125",
  },
  {
    "": "610",
    time: "1637709651.2721875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-15.625",
    c3: "-36.62109375",
    c4: "-117.67578125",
  },
  {
    "": "611",
    time: "1637709651.2760937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-17.08984375",
    c3: "-19.04296875",
    c4: "-114.2578125",
  },
  {
    "": "612",
    time: "1637709651.282125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-41.50390625",
    c3: "-15.13671875",
    c4: "-74.21875",
  },
  {
    "": "613",
    time: "1637709651.2860312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-52.734375",
    c3: "-16.11328125",
    c4: "-74.70703125",
  },
  {
    "": "614",
    time: "1637709651.2899375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-24.90234375",
    c3: "-26.85546875",
    c4: "-134.765625",
  },
  {
    "": "615",
    time: "1637709651.2938437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-14.16015625",
    c3: "-53.7109375",
    c4: "-147.94921875",
  },
  {
    "": "616",
    time: "1637709651.29775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-7.8125",
    c3: "-30.2734375",
    c4: "-96.19140625",
  },
  {
    "": "617",
    time: "1637709651.3016562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-5.859375",
    c3: "-8.7890625",
    c4: "-64.94140625",
  },
  {
    "": "618",
    time: "1637709651.3055625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-25.390625",
    c3: "-7.8125",
    c4: "-114.74609375",
  },
  {
    "": "619",
    time: "1637709651.3094687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-19.53125",
    c3: "-3.90625",
    c4: "-155.2734375",
  },
  {
    "": "620",
    time: "1637709651.313375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-9.27734375",
    c3: "-6.34765625",
    c4: "-111.81640625",
  },
  {
    "": "621",
    time: "1637709651.3172812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-14.6484375",
    c3: "-17.578125",
    c4: "-55.17578125",
  },
  {
    "": "622",
    time: "1637709651.3211875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-17.578125",
    c3: "-8.30078125",
    c4: "-83.0078125",
  },
  {
    "": "623",
    time: "1637709651.3250937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-13.671875",
    c3: "-5.37109375",
    c4: "-140.13671875",
  },
  {
    "": "624",
    time: "1637709651.339125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-24.90234375",
    c3: "-31.25",
    c4: "-147.4609375",
  },
  {
    "": "625",
    time: "1637709651.3430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-52.24609375",
    c3: "-33.203125",
    c4: "-108.3984375",
  },
  {
    "": "626",
    time: "1637709651.3469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-44.43359375",
    c3: "-15.13671875",
    c4: "-108.88671875",
  },
  {
    "": "627",
    time: "1637709651.3508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-32.71484375",
    c3: "-25.87890625",
    c4: "-147.4609375",
  },
  {
    "": "628",
    time: "1637709651.35475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-32.2265625",
    c3: "-54.6875",
    c4: "-149.90234375",
  },
  {
    "": "629",
    time: "1637709651.3586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-29.296875",
    c3: "-68.84765625",
    c4: "-95.21484375",
  },
  {
    "": "630",
    time: "1637709651.3625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-25.390625",
    c3: "-30.76171875",
    c4: "-78.125",
  },
  {
    "": "631",
    time: "1637709651.3664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.73046875",
    c2: "-19.04296875",
    c3: "-19.04296875",
    c4: "-119.62890625",
  },
  {
    "": "632",
    time: "1637709651.370375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-110.83984375",
    c2: "-22.4609375",
    c3: "-48.33984375",
    c4: "-125.0",
  },
  {
    "": "633",
    time: "1637709651.3742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-89.84375",
    c2: "-43.45703125",
    c3: "-44.921875",
    c4: "-83.0078125",
  },
  {
    "": "634",
    time: "1637709651.3781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-50.29296875",
    c3: "-53.22265625",
    c4: "-54.6875",
  },
  {
    "": "635",
    time: "1637709651.3820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.68359375",
    c2: "-18.5546875",
    c3: "-24.90234375",
    c4: "-78.61328125",
  },
  {
    "": "636",
    time: "1637709651.385125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "-28.3203125",
    c3: "19.53125",
    c4: "-121.58203125",
  },
  {
    "": "637",
    time: "1637709651.3890312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-47.36328125",
    c3: "17.08984375",
    c4: "-109.375",
  },
  {
    "": "638",
    time: "1637709651.3929374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-28.80859375",
    c3: "3.90625",
    c4: "-49.31640625",
  },
  {
    "": "639",
    time: "1637709651.3968437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-11.23046875",
    c3: "-17.08984375",
    c4: "-56.15234375",
  },
  {
    "": "640",
    time: "1637709651.40075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-83.49609375",
    c2: "-31.73828125",
    c3: "-34.66796875",
    c4: "-99.609375",
  },
  {
    "": "641",
    time: "1637709651.4046562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.75390625",
    c2: "-47.8515625",
    c3: "-32.2265625",
    c4: "-94.23828125",
  },
  {
    "": "642",
    time: "1637709651.4085624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-34.66796875",
    c3: "-25.390625",
    c4: "-41.50390625",
  },
  {
    "": "643",
    time: "1637709651.4124687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-32.71484375",
    c3: "-27.34375",
    c4: "-46.875",
  },
  {
    "": "644",
    time: "1637709651.416375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-40.52734375",
    c3: "-67.3828125",
    c4: "-83.49609375",
  },
  {
    "": "645",
    time: "1637709651.4202812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-44.921875",
    c3: "-72.265625",
    c4: "-99.609375",
  },
  {
    "": "646",
    time: "1637709651.4241874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-27.83203125",
    c3: "-25.87890625",
    c4: "-58.59375",
  },
  {
    "": "647",
    time: "1637709651.4280937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-6.34765625",
    c3: "-11.23046875",
    c4: "-4.39453125",
  },
  {
    "": "648",
    time: "1637709651.429125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-31.25",
    c3: "-15.13671875",
    c4: "-46.875",
  },
  {
    "": "649",
    time: "1637709651.4330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-49.8046875",
    c3: "-17.08984375",
    c4: "-89.35546875",
  },
  {
    "": "650",
    time: "1637709651.4369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-36.62109375",
    c3: "-19.53125",
    c4: "-50.78125",
  },
  {
    "": "651",
    time: "1637709651.4408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-35.64453125",
    c3: "-36.62109375",
    c4: "-12.20703125",
  },
  {
    "": "652",
    time: "1637709651.44475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-39.55078125",
    c3: "-18.06640625",
    c4: "-50.29296875",
  },
  {
    "": "653",
    time: "1637709651.4486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-53.7109375",
    c3: "-20.99609375",
    c4: "-109.375",
  },
  {
    "": "654",
    time: "1637709651.4525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-49.8046875",
    c3: "-33.69140625",
    c4: "-101.07421875",
  },
  {
    "": "655",
    time: "1637709651.4564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-36.1328125",
    c3: "-21.484375",
    c4: "-54.6875",
  },
  {
    "": "656",
    time: "1637709651.460375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-35.15625",
    c3: "-44.921875",
    c4: "-49.8046875",
  },
  {
    "": "657",
    time: "1637709651.4642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-35.64453125",
    c3: "-17.08984375",
    c4: "-96.6796875",
  },
  {
    "": "658",
    time: "1637709651.4681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-41.50390625",
    c3: "-6.8359375",
    c4: "-98.6328125",
  },
  {
    "": "659",
    time: "1637709651.4720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-41.9921875",
    c3: "-31.73828125",
    c4: "-44.921875",
  },
  {
    "": "660",
    time: "1637709651.475125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-33.203125",
    c3: "-17.578125",
    c4: "-53.7109375",
  },
  {
    "": "661",
    time: "1637709651.4790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-43.9453125",
    c3: "-7.8125",
    c4: "-106.4453125",
  },
  {
    "": "662",
    time: "1637709651.4829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-49.31640625",
    c3: "-16.6015625",
    c4: "-124.0234375",
  },
  {
    "": "663",
    time: "1637709651.4868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-28.3203125",
    c3: "-17.08984375",
    c4: "-77.63671875",
  },
  {
    "": "664",
    time: "1637709651.49075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-29.296875",
    c3: "-15.13671875",
    c4: "-55.6640625",
  },
  {
    "": "665",
    time: "1637709651.4946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-20.01953125",
    c3: "-37.109375",
    c4: "-90.33203125",
  },
  {
    "": "666",
    time: "1637709651.4985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-42.48046875",
    c3: "-47.8515625",
    c4: "-115.234375",
  },
  {
    "": "667",
    time: "1637709651.5024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-58.10546875",
    c3: "-51.7578125",
    c4: "-83.49609375",
  },
  {
    "": "668",
    time: "1637709651.506375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-33.69140625",
    c3: "-22.94921875",
    c4: "-32.2265625",
  },
  {
    "": "669",
    time: "1637709651.5102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-29.296875",
    c3: "-12.20703125",
    c4: "-73.2421875",
  },
  {
    "": "670",
    time: "1637709651.5141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-81.0546875",
    c2: "-37.59765625",
    c3: "-39.0625",
    c4: "-127.9296875",
  },
  {
    "": "671",
    time: "1637709651.5180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-35.64453125",
    c3: "-57.12890625",
    c4: "-88.8671875",
  },
  {
    "": "672",
    time: "1637709651.518125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-20.5078125",
    c3: "-38.0859375",
    c4: "-32.71484375",
  },
  {
    "": "673",
    time: "1637709651.5220313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-16.11328125",
    c3: "-16.6015625",
    c4: "-46.875",
  },
  {
    "": "674",
    time: "1637709651.5259376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-14.16015625",
    c3: "-72.75390625",
    c4: "-94.23828125",
  },
  {
    "": "675",
    time: "1637709651.5298438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-19.04296875",
    c3: "-61.03515625",
    c4: "-78.125",
  },
  {
    "": "676",
    time: "1637709651.53375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-22.4609375",
    c3: "5.859375",
    c4: "-19.04296875",
  },
  {
    "": "677",
    time: "1637709651.5376563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-42.48046875",
    c3: "0.0",
    c4: "-13.671875",
  },
  {
    "": "678",
    time: "1637709651.5415626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-58.59375",
    c3: "-33.69140625",
    c4: "-59.5703125",
  },
  {
    "": "679",
    time: "1637709651.5454688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-34.1796875",
    c3: "-57.12890625",
    c4: "-81.0546875",
  },
  {
    "": "680",
    time: "1637709651.549375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-30.2734375",
    c3: "-9.765625",
    c4: "-57.6171875",
  },
  {
    "": "681",
    time: "1637709651.5532813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-40.0390625",
    c3: "7.32421875",
    c4: "-21.97265625",
  },
  {
    "": "682",
    time: "1637709651.5571876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-17.08984375",
    c3: "-7.8125",
    c4: "-54.6875",
  },
  {
    "": "683",
    time: "1637709651.5610938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-45.8984375",
    c3: "-12.6953125",
    c4: "-108.3984375",
  },
  {
    "": "684",
    time: "1637709651.567125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-61.03515625",
    c3: "-16.11328125",
    c4: "-71.2890625",
  },
  {
    "": "685",
    time: "1637709651.5710313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-41.50390625",
    c3: "-44.921875",
    c4: "-12.6953125",
  },
  {
    "": "686",
    time: "1637709651.5749376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-21.484375",
    c3: "-56.640625",
    c4: "-24.90234375",
  },
  {
    "": "687",
    time: "1637709651.5788438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "7.32421875",
    c3: "-10.7421875",
    c4: "-69.82421875",
  },
  {
    "": "688",
    time: "1637709651.58275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "3.90625",
    c3: "-4.39453125",
    c4: "-74.21875",
  },
  {
    "": "689",
    time: "1637709651.5866563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-14.6484375",
    c3: "-48.33984375",
    c4: "-35.15625",
  },
  {
    "": "690",
    time: "1637709651.5905626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-29.78515625",
    c3: "-66.89453125",
    c4: "-31.25",
  },
  {
    "": "691",
    time: "1637709651.5944688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-25.390625",
    c3: "-15.625",
    c4: "-76.66015625",
  },
  {
    "": "692",
    time: "1637709651.598375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-55.17578125",
    c3: "6.34765625",
    c4: "-85.9375",
  },
  {
    "": "693",
    time: "1637709651.6022813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-72.265625",
    c3: "-11.71875",
    c4: "-38.0859375",
  },
  {
    "": "694",
    time: "1637709651.6061876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-43.45703125",
    c3: "-14.16015625",
    c4: "-18.5546875",
  },
  {
    "": "695",
    time: "1637709651.6100938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-27.34375",
    c3: "-22.4609375",
    c4: "-72.265625",
  },
  {
    "": "696",
    time: "1637709651.608125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-25.87890625",
    c3: "-27.34375",
    c4: "-98.14453125",
  },
  {
    "": "697",
    time: "1637709651.6120312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-26.85546875",
    c3: "-26.3671875",
    c4: "-58.10546875",
  },
  {
    "": "698",
    time: "1637709651.6159375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-28.3203125",
    c3: "-29.78515625",
    c4: "-29.78515625",
  },
  {
    "": "699",
    time: "1637709651.6198437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-26.85546875",
    c3: "-35.64453125",
    c4: "-59.08203125",
  },
  {
    "": "700",
    time: "1637709651.62375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-41.015625",
    c3: "-45.41015625",
    c4: "-86.42578125",
  },
  {
    "": "701",
    time: "1637709651.6276562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-54.19921875",
    c3: "-53.7109375",
    c4: "-62.5",
  },
  {
    "": "702",
    time: "1637709651.6315625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-46.875",
    c3: "-66.40625",
    c4: "-18.5546875",
  },
  {
    "": "703",
    time: "1637709651.6354687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "25.390625",
    c2: "-49.31640625",
    c3: "-27.83203125",
    c4: "-36.62109375",
  },
  {
    "": "704",
    time: "1637709651.639375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "12.6953125",
    c2: "-54.6875",
    c3: "-5.37109375",
    c4: "-83.0078125",
  },
  {
    "": "705",
    time: "1637709651.6432812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-49.31640625",
    c3: "-38.0859375",
    c4: "-77.1484375",
  },
  {
    "": "706",
    time: "1637709651.6471875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-25.390625",
    c3: "-38.57421875",
    c4: "-34.66796875",
  },
  {
    "": "707",
    time: "1637709651.6510937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.4609375",
    c2: "-22.94921875",
    c3: "-35.15625",
    c4: "-21.97265625",
  },
  {
    "": "708",
    time: "1637709651.655125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-42.96875",
    c3: "-33.203125",
    c4: "-77.63671875",
  },
  {
    "": "709",
    time: "1637709651.6590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-25.87890625",
    c3: "-17.08984375",
    c4: "-100.09765625",
  },
  {
    "": "710",
    time: "1637709651.6629374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-11.23046875",
    c3: "-8.7890625",
    c4: "-48.828125",
  },
  {
    "": "711",
    time: "1637709651.6668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-36.62109375",
    c3: "-13.18359375",
    c4: "-15.625",
  },
  {
    "": "712",
    time: "1637709651.67075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-32.2265625",
    c3: "-38.0859375",
    c4: "-61.03515625",
  },
  {
    "": "713",
    time: "1637709651.6746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-7.8125",
    c3: "-62.5",
    c4: "-89.84375",
  },
  {
    "": "714",
    time: "1637709651.6785624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-11.71875",
    c3: "-55.6640625",
    c4: "-45.8984375",
  },
  {
    "": "715",
    time: "1637709651.6824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-26.85546875",
    c3: "-51.7578125",
    c4: "-18.06640625",
  },
  {
    "": "716",
    time: "1637709651.686375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-39.0625",
    c3: "-40.52734375",
    c4: "-40.52734375",
  },
  {
    "": "717",
    time: "1637709651.6902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-39.0625",
    c3: "-42.48046875",
    c4: "-79.58984375",
  },
  {
    "": "718",
    time: "1637709651.6941874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-27.83203125",
    c3: "-21.97265625",
    c4: "-85.44921875",
  },
  {
    "": "719",
    time: "1637709651.6980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-28.80859375",
    c3: "-1.953125",
    c4: "-38.0859375",
  },
  {
    "": "720",
    time: "1637709651.713125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-42.96875",
    c3: "-29.78515625",
    c4: "-50.29296875",
  },
  {
    "": "721",
    time: "1637709651.7170312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-39.55078125",
    c3: "-33.69140625",
    c4: "-98.6328125",
  },
  {
    "": "722",
    time: "1637709651.7209375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-46.38671875",
    c3: "-33.203125",
    c4: "-91.30859375",
  },
  {
    "": "723",
    time: "1637709651.7248437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-46.875",
    c3: "-51.26953125",
    c4: "-33.203125",
  },
  {
    "": "724",
    time: "1637709651.72875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-34.1796875",
    c3: "-54.6875",
    c4: "-16.11328125",
  },
  {
    "": "725",
    time: "1637709651.7326562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-42.96875",
    c3: "-69.3359375",
    c4: "-74.21875",
  },
  {
    "": "726",
    time: "1637709651.7365625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-36.1328125",
    c3: "-70.3125",
    c4: "-99.12109375",
  },
  {
    "": "727",
    time: "1637709651.7404687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-31.73828125",
    c3: "-24.4140625",
    c4: "-52.24609375",
  },
  {
    "": "728",
    time: "1637709651.744375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-35.15625",
    c3: "-13.18359375",
    c4: "-5.37109375",
  },
  {
    "": "729",
    time: "1637709651.7482812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-27.83203125",
    c3: "-29.78515625",
    c4: "-46.38671875",
  },
  {
    "": "730",
    time: "1637709651.7521875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "-19.53125",
    c3: "-33.203125",
    c4: "-100.5859375",
  },
  {
    "": "731",
    time: "1637709651.7560937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-35.64453125",
    c3: "-35.64453125",
    c4: "-63.4765625",
  },
  {
    "": "732",
    time: "1637709651.775125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-39.55078125",
    c3: "-40.52734375",
    c4: "-7.8125",
  },
  {
    "": "733",
    time: "1637709651.7790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-33.203125",
    c3: "-27.34375",
    c4: "-40.52734375",
  },
  {
    "": "734",
    time: "1637709651.7829375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-49.8046875",
    c3: "-1.953125",
    c4: "-91.796875",
  },
  {
    "": "735",
    time: "1637709651.7868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-47.8515625",
    c3: "-37.109375",
    c4: "-71.2890625",
  },
  {
    "": "736",
    time: "1637709651.79075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-38.0859375",
    c3: "-62.01171875",
    c4: "-15.13671875",
  },
  {
    "": "737",
    time: "1637709651.7946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-63.96484375",
    c3: "-60.546875",
    c4: "-6.34765625",
  },
  {
    "": "738",
    time: "1637709651.7985625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-55.17578125",
    c3: "-58.10546875",
    c4: "-61.03515625",
  },
  {
    "": "739",
    time: "1637709651.8024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-34.1796875",
    c3: "-35.64453125",
    c4: "-96.19140625",
  },
  {
    "": "740",
    time: "1637709651.806375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-38.0859375",
    c3: "-52.734375",
    c4: "-42.96875",
  },
  {
    "": "741",
    time: "1637709651.8102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-25.390625",
    c3: "-46.38671875",
    c4: "-16.6015625",
  },
  {
    "": "742",
    time: "1637709651.8141875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-3.41796875",
    c3: "-19.53125",
    c4: "-47.36328125",
  },
  {
    "": "743",
    time: "1637709651.8180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-15.625",
    c3: "-47.36328125",
    c4: "-64.94140625",
  },
  {
    "": "744",
    time: "1637709651.805125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-38.57421875",
    c3: "-71.77734375",
    c4: "-41.015625",
  },
  {
    "": "745",
    time: "1637709651.8090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-22.4609375",
    c3: "-44.43359375",
    c4: "-20.99609375",
  },
  {
    "": "746",
    time: "1637709651.8129375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-8.30078125",
    c3: "-26.85546875",
    c4: "-58.10546875",
  },
  {
    "": "747",
    time: "1637709651.8168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-13.18359375",
    c3: "-43.9453125",
    c4: "-90.33203125",
  },
  {
    "": "748",
    time: "1637709651.82075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-25.87890625",
    c3: "-55.17578125",
    c4: "-53.7109375",
  },
  {
    "": "749",
    time: "1637709651.8246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-35.64453125",
    c3: "-40.0390625",
    c4: "-15.13671875",
  },
  {
    "": "750",
    time: "1637709651.8285625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-33.203125",
    c3: "-35.64453125",
    c4: "-43.9453125",
  },
  {
    "": "751",
    time: "1637709651.8324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-43.9453125",
    c3: "-46.875",
    c4: "-77.1484375",
  },
  {
    "": "752",
    time: "1637709651.836375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-61.03515625",
    c3: "-64.94140625",
    c4: "-72.75390625",
  },
  {
    "": "753",
    time: "1637709651.8402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-44.43359375",
    c3: "-26.85546875",
    c4: "-38.0859375",
  },
  {
    "": "754",
    time: "1637709651.8441875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-46.875",
    c3: "-13.671875",
    c4: "-32.2265625",
  },
  {
    "": "755",
    time: "1637709651.8480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-38.57421875",
    c3: "-29.296875",
    c4: "-60.05859375",
  },
  {
    "": "756",
    time: "1637709651.850125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-17.578125",
    c3: "-27.83203125",
    c4: "-86.9140625",
  },
  {
    "": "757",
    time: "1637709651.8540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-20.5078125",
    c3: "-5.859375",
    c4: "-55.6640625",
  },
  {
    "": "758",
    time: "1637709651.8579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-18.06640625",
    c3: "-1.953125",
    c4: "-32.2265625",
  },
  {
    "": "759",
    time: "1637709651.8618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-29.78515625",
    c3: "-23.92578125",
    c4: "-76.66015625",
  },
  {
    "": "760",
    time: "1637709651.86575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-46.875",
    c3: "-37.109375",
    c4: "-96.19140625",
  },
  {
    "": "761",
    time: "1637709651.8696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-54.19921875",
    c3: "-42.48046875",
    c4: "-56.640625",
  },
  {
    "": "762",
    time: "1637709651.8735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-57.6171875",
    c3: "-58.59375",
    c4: "-13.671875",
  },
  {
    "": "763",
    time: "1637709651.8774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-44.43359375",
    c3: "-91.30859375",
    c4: "-40.0390625",
  },
  {
    "": "764",
    time: "1637709651.881375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-23.4375",
    c3: "-60.05859375",
    c4: "-89.84375",
  },
  {
    "": "765",
    time: "1637709651.8852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-16.11328125",
    c3: "-19.53125",
    c4: "-60.05859375",
  },
  {
    "": "766",
    time: "1637709651.8891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-15.13671875",
    c3: "-24.4140625",
    c4: "-13.671875",
  },
  {
    "": "767",
    time: "1637709651.8930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-21.97265625",
    c3: "-33.203125",
    c4: "-59.08203125",
  },
  {
    "": "768",
    time: "1637709651.893125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-41.015625",
    c3: "-25.390625",
    c4: "-92.28515625",
  },
  {
    "": "769",
    time: "1637709651.8970313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-57.12890625",
    c3: "-11.23046875",
    c4: "-65.91796875",
  },
  {
    "": "770",
    time: "1637709651.9009376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-31.25",
    c3: "-25.87890625",
    c4: "-34.66796875",
  },
  {
    "": "771",
    time: "1637709651.9048438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-15.13671875",
    c3: "-25.87890625",
    c4: "-17.578125",
  },
  {
    "": "772",
    time: "1637709651.90875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-18.06640625",
    c3: "-21.484375",
    c4: "-62.5",
  },
  {
    "": "773",
    time: "1637709651.9126563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-41.015625",
    c3: "-35.64453125",
    c4: "-90.8203125",
  },
  {
    "": "774",
    time: "1637709651.9165626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-62.98828125",
    c3: "-61.5234375",
    c4: "-34.66796875",
  },
  {
    "": "775",
    time: "1637709651.9204688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-40.0390625",
    c3: "-86.42578125",
    c4: "-1.953125",
  },
  {
    "": "776",
    time: "1637709651.924375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-31.25",
    c3: "-54.6875",
    c4: "-65.91796875",
  },
  {
    "": "777",
    time: "1637709651.9282813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-33.203125",
    c3: "-13.18359375",
    c4: "-105.46875",
  },
  {
    "": "778",
    time: "1637709651.9321876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-36.1328125",
    c3: "-24.4140625",
    c4: "-66.89453125",
  },
  {
    "": "779",
    time: "1637709651.9360938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-42.48046875",
    c3: "-30.2734375",
    c4: "-13.18359375",
  },
  {
    "": "780",
    time: "1637709651.940125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-37.109375",
    c3: "-2.9296875",
    c4: "-13.671875",
  },
  {
    "": "781",
    time: "1637709651.9440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-22.94921875",
    c3: "-24.90234375",
    c4: "-70.80078125",
  },
  {
    "": "782",
    time: "1637709651.9479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-19.53125",
    c3: "-76.171875",
    c4: "-74.70703125",
  },
  {
    "": "783",
    time: "1637709651.9518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-29.296875",
    c3: "-47.8515625",
    c4: "-23.4375",
  },
  {
    "": "784",
    time: "1637709651.95575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-15.13671875",
    c3: "-7.8125",
    c4: "-41.015625",
  },
  {
    "": "785",
    time: "1637709651.9596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-0.9765625",
    c3: "-30.76171875",
    c4: "-67.3828125",
  },
  {
    "": "786",
    time: "1637709651.9635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-47.8515625",
    c3: "-61.03515625",
    c4: "-55.17578125",
  },
  {
    "": "787",
    time: "1637709651.9674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-61.03515625",
    c3: "-31.25",
    c4: "-15.13671875",
  },
  {
    "": "788",
    time: "1637709651.971375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-32.2265625",
    c3: "-8.7890625",
    c4: "13.18359375",
  },
  {
    "": "789",
    time: "1637709651.9752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-24.90234375",
    c3: "-42.48046875",
    c4: "-42.96875",
  },
  {
    "": "790",
    time: "1637709651.9791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-51.7578125",
    c3: "-60.546875",
    c4: "-93.75",
  },
  {
    "": "791",
    time: "1637709651.9830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-52.24609375",
    c3: "-55.6640625",
    c4: "-46.38671875",
  },
  {
    "": "792",
    time: "1637709651.985125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-20.01953125",
    c3: "-28.80859375",
    c4: "-9.765625",
  },
  {
    "": "793",
    time: "1637709651.9890313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-40.0390625",
    c3: "-34.66796875",
    c4: "-51.7578125",
  },
  {
    "": "794",
    time: "1637709651.9929376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-50.29296875",
    c3: "-50.78125",
    c4: "-86.9140625",
  },
  {
    "": "795",
    time: "1637709651.9968438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-31.25",
    c3: "-47.36328125",
    c4: "-63.4765625",
  },
  {
    "": "796",
    time: "1637709652.00075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-19.53125",
    c3: "-46.875",
    c4: "-20.99609375",
  },
  {
    "": "797",
    time: "1637709652.0046563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-25.87890625",
    c3: "-54.6875",
    c4: "-38.57421875",
  },
  {
    "": "798",
    time: "1637709652.0085626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-47.8515625",
    c3: "-78.125",
    c4: "-83.49609375",
  },
  {
    "": "799",
    time: "1637709652.0124688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-41.50390625",
    c3: "-72.265625",
    c4: "-64.453125",
  },
  {
    "": "800",
    time: "1637709652.016375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-33.203125",
    c3: "-37.109375",
    c4: "-16.11328125",
  },
  {
    "": "801",
    time: "1637709652.0202813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-38.0859375",
    c3: "-23.92578125",
    c4: "-43.45703125",
  },
  {
    "": "802",
    time: "1637709652.0241876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-28.3203125",
    c3: "-20.5078125",
    c4: "-84.47265625",
  },
  {
    "": "803",
    time: "1637709652.0280938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-28.80859375",
    c3: "-19.53125",
    c4: "-80.078125",
  },
  {
    "": "804",
    time: "1637709652.032125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-35.64453125",
    c3: "-32.71484375",
    c4: "-35.15625",
  },
  {
    "": "805",
    time: "1637709652.0360312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-41.9921875",
    c3: "-46.38671875",
    c4: "-12.20703125",
  },
  {
    "": "806",
    time: "1637709652.0399375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-53.7109375",
    c3: "-48.828125",
    c4: "-53.7109375",
  },
  {
    "": "807",
    time: "1637709652.0438437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-55.6640625",
    c3: "-29.78515625",
    c4: "-90.33203125",
  },
  {
    "": "808",
    time: "1637709652.04775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-49.8046875",
    c3: "-12.6953125",
    c4: "-52.24609375",
  },
  {
    "": "809",
    time: "1637709652.0516562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-40.0390625",
    c3: "-41.9921875",
    c4: "2.44140625",
  },
  {
    "": "810",
    time: "1637709652.0555625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-35.64453125",
    c3: "-54.6875",
    c4: "-38.0859375",
  },
  {
    "": "811",
    time: "1637709652.0594687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-47.8515625",
    c3: "-27.83203125",
    c4: "-70.80078125",
  },
  {
    "": "812",
    time: "1637709652.063375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-33.69140625",
    c3: "-35.64453125",
    c4: "-54.6875",
  },
  {
    "": "813",
    time: "1637709652.0672812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-6.34765625",
    c3: "-56.640625",
    c4: "-21.484375",
  },
  {
    "": "814",
    time: "1637709652.0711875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-17.08984375",
    c3: "-38.57421875",
    c4: "-34.1796875",
  },
  {
    "": "815",
    time: "1637709652.0750937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-47.36328125",
    c3: "-32.2265625",
    c4: "-91.796875",
  },
  {
    "": "816",
    time: "1637709652.088125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-47.8515625",
    c3: "-48.33984375",
    c4: "-86.9140625",
  },
  {
    "": "817",
    time: "1637709652.0920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-55.6640625",
    c3: "-29.296875",
    c4: "-21.484375",
  },
  {
    "": "818",
    time: "1637709652.0959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-63.96484375",
    c3: "-19.04296875",
    c4: "0.0",
  },
  {
    "": "819",
    time: "1637709652.0998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-31.25",
    c3: "-60.546875",
    c4: "-53.22265625",
  },
  {
    "": "820",
    time: "1637709652.10375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-20.5078125",
    c3: "-83.0078125",
    c4: "-66.89453125",
  },
  {
    "": "821",
    time: "1637709652.1076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-32.2265625",
    c3: "-69.82421875",
    c4: "-13.671875",
  },
  {
    "": "822",
    time: "1637709652.1115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-20.5078125",
    c3: "-22.4609375",
    c4: "5.859375",
  },
  {
    "": "823",
    time: "1637709652.1154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-32.2265625",
    c3: "12.6953125",
    c4: "-46.875",
  },
  {
    "": "824",
    time: "1637709652.119375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-53.7109375",
    c3: "-42.48046875",
    c4: "-80.56640625",
  },
  {
    "": "825",
    time: "1637709652.1232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-35.64453125",
    c3: "-67.87109375",
    c4: "-50.29296875",
  },
  {
    "": "826",
    time: "1637709652.1271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-44.921875",
    c3: "-20.01953125",
    c4: "-16.11328125",
  },
  {
    "": "827",
    time: "1637709652.1310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-70.80078125",
    c3: "-9.765625",
    c4: "-40.0390625",
  },
  {
    "": "828",
    time: "1637709652.135125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-47.36328125",
    c3: "-24.4140625",
    c4: "-80.078125",
  },
  {
    "": "829",
    time: "1637709652.1390312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-21.484375",
    c3: "-23.4375",
    c4: "-64.453125",
  },
  {
    "": "830",
    time: "1637709652.1429374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-37.109375",
    c3: "-6.34765625",
    c4: "-1.953125",
  },
  {
    "": "831",
    time: "1637709652.1468437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-55.6640625",
    c3: "-17.578125",
    c4: "-25.390625",
  },
  {
    "": "832",
    time: "1637709652.15075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-53.7109375",
    c3: "-52.734375",
    c4: "-78.61328125",
  },
  {
    "": "833",
    time: "1637709652.1546562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-38.57421875",
    c3: "-51.7578125",
    c4: "-39.0625",
  },
  {
    "": "834",
    time: "1637709652.1585624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-19.04296875",
    c3: "-31.73828125",
    c4: "8.30078125",
  },
  {
    "": "835",
    time: "1637709652.1624687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-34.66796875",
    c3: "-36.62109375",
    c4: "-2.44140625",
  },
  {
    "": "836",
    time: "1637709652.166375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-38.0859375",
    c3: "-79.58984375",
    c4: "-47.8515625",
  },
  {
    "": "837",
    time: "1637709652.1702812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-29.296875",
    c3: "-87.40234375",
    c4: "-71.2890625",
  },
  {
    "": "838",
    time: "1637709652.1741874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-23.92578125",
    c3: "-53.7109375",
    c4: "-50.78125",
  },
  {
    "": "839",
    time: "1637709652.1780937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-27.34375",
    c3: "-35.64453125",
    c4: "-30.76171875",
  },
  {
    "": "840",
    time: "1637709652.178125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-45.41015625",
    c3: "-30.2734375",
    c4: "-76.171875",
  },
  {
    "": "841",
    time: "1637709652.1820312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-55.17578125",
    c3: "-27.83203125",
    c4: "-95.21484375",
  },
  {
    "": "842",
    time: "1637709652.1859374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-53.7109375",
    c3: "-20.99609375",
    c4: "-40.52734375",
  },
  {
    "": "843",
    time: "1637709652.1898437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-48.828125",
    c3: "-22.94921875",
    c4: "-16.11328125",
  },
  {
    "": "844",
    time: "1637709652.19375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-49.31640625",
    c3: "-39.0625",
    c4: "-53.22265625",
  },
  {
    "": "845",
    time: "1637709652.1976562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-38.0859375",
    c3: "-37.109375",
    c4: "-75.68359375",
  },
  {
    "": "846",
    time: "1637709652.2015624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-41.015625",
    c3: "-42.96875",
    c4: "-54.19921875",
  },
  {
    "": "847",
    time: "1637709652.2054687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-39.55078125",
    c3: "-53.22265625",
    c4: "6.8359375",
  },
  {
    "": "848",
    time: "1637709652.209375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-31.25",
    c3: "-41.015625",
    c4: "5.37109375",
  },
  {
    "": "849",
    time: "1637709652.2132812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-46.38671875",
    c3: "-21.484375",
    c4: "-62.01171875",
  },
  {
    "": "850",
    time: "1637709652.2171874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-48.33984375",
    c3: "-42.48046875",
    c4: "-62.01171875",
  },
  {
    "": "851",
    time: "1637709652.2210937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-31.25",
    c3: "-67.87109375",
    c4: "-9.27734375",
  },
  {
    "": "852",
    time: "1637709652.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-40.52734375",
    c3: "-49.8046875",
    c4: "-3.41796875",
  },
  {
    "": "853",
    time: "1637709652.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-57.12890625",
    c3: "-16.6015625",
    c4: "-55.6640625",
  },
  {
    "": "854",
    time: "1637709652.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-41.50390625",
    c3: "-28.3203125",
    c4: "-72.75390625",
  },
  {
    "": "855",
    time: "1637709652.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-7.32421875",
    c3: "-28.80859375",
    c4: "-35.64453125",
  },
  {
    "": "856",
    time: "1637709652.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "0.0",
    c3: "-33.203125",
    c4: "-15.625",
  },
  {
    "": "857",
    time: "1637709652.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-8.7890625",
    c3: "-51.26953125",
    c4: "-35.64453125",
  },
  {
    "": "858",
    time: "1637709652.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-20.5078125",
    c3: "-30.76171875",
    c4: "-52.734375",
  },
  {
    "": "859",
    time: "1637709652.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-29.296875",
    c3: "-51.26953125",
    c4: "-35.15625",
  },
  {
    "": "860",
    time: "1637709652.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-35.64453125",
    c3: "-30.2734375",
    c4: "3.90625",
  },
  {
    "": "861",
    time: "1637709652.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-43.45703125",
    c3: "10.25390625",
    c4: "-15.13671875",
  },
  {
    "": "862",
    time: "1637709652.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-35.15625",
    c3: "-18.06640625",
    c4: "-79.58984375",
  },
  {
    "": "863",
    time: "1637709652.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-34.66796875",
    c3: "-60.546875",
    c4: "-82.51953125",
  },
  {
    "": "864",
    time: "1637709652.270125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-39.0625",
    c3: "-48.33984375",
    c4: "-25.390625",
  },
  {
    "": "865",
    time: "1637709652.2740312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-43.45703125",
    c3: "-18.5546875",
    c4: "-5.859375",
  },
  {
    "": "866",
    time: "1637709652.2779374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-27.34375",
    c3: "-41.015625",
    c4: "-49.31640625",
  },
  {
    "": "867",
    time: "1637709652.2818437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-15.13671875",
    c3: "-49.8046875",
    c4: "-74.70703125",
  },
  {
    "": "868",
    time: "1637709652.28575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-23.92578125",
    c3: "-26.3671875",
    c4: "-25.87890625",
  },
  {
    "": "869",
    time: "1637709652.2896562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-30.2734375",
    c3: "-32.71484375",
    c4: "14.16015625",
  },
  {
    "": "870",
    time: "1637709652.2935624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-28.3203125",
    c3: "-47.8515625",
    c4: "-27.34375",
  },
  {
    "": "871",
    time: "1637709652.2974687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-42.96875",
    c3: "-81.54296875",
    c4: "-55.17578125",
  },
  {
    "": "872",
    time: "1637709652.301375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-48.33984375",
    c3: "-51.7578125",
    c4: "-37.109375",
  },
  {
    "": "873",
    time: "1637709652.3052812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-32.2265625",
    c3: "-0.48828125",
    c4: "-20.99609375",
  },
  {
    "": "874",
    time: "1637709652.3091874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-33.69140625",
    c3: "-4.8828125",
    c4: "-47.8515625",
  },
  {
    "": "875",
    time: "1637709652.3130937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-28.80859375",
    c3: "-21.484375",
    c4: "-90.33203125",
  },
  {
    "": "876",
    time: "1637709652.315125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-19.04296875",
    c3: "-44.43359375",
    c4: "-64.94140625",
  },
  {
    "": "877",
    time: "1637709652.3190312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-50.78125",
    c3: "-52.24609375",
    c4: "-11.23046875",
  },
  {
    "": "878",
    time: "1637709652.3229375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-65.4296875",
    c3: "-37.59765625",
    c4: "-27.34375",
  },
  {
    "": "879",
    time: "1637709652.3268437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "-30.2734375",
    c3: "-34.1796875",
    c4: "-92.28515625",
  },
  {
    "": "880",
    time: "1637709652.33075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.078125",
    c2: "-21.484375",
    c3: "-27.34375",
    c4: "-88.37890625",
  },
  {
    "": "881",
    time: "1637709652.3346562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-30.2734375",
    c3: "-13.18359375",
    c4: "-36.1328125",
  },
  {
    "": "882",
    time: "1637709652.3385625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-53.7109375",
    c3: "-45.8984375",
    c4: "-24.90234375",
  },
  {
    "": "883",
    time: "1637709652.3424687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-45.41015625",
    c3: "-58.59375",
    c4: "-68.359375",
  },
  {
    "": "884",
    time: "1637709652.346375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-29.296875",
    c3: "-20.5078125",
    c4: "-104.00390625",
  },
  {
    "": "885",
    time: "1637709652.3502812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-33.69140625",
    c3: "-24.4140625",
    c4: "-51.7578125",
  },
  {
    "": "886",
    time: "1637709652.3541875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-26.85546875",
    c3: "-25.87890625",
    c4: "-20.99609375",
  },
  {
    "": "887",
    time: "1637709652.3580937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-33.203125",
    c3: "-10.25390625",
    c4: "-51.26953125",
  },
  {
    "": "888",
    time: "1637709652.358125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-31.25",
    c3: "-17.578125",
    c4: "-77.63671875",
  },
  {
    "": "889",
    time: "1637709652.3620312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-25.390625",
    c3: "-44.43359375",
    c4: "-47.36328125",
  },
  {
    "": "890",
    time: "1637709652.3659375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-27.34375",
    c3: "-50.78125",
    c4: "12.6953125",
  },
  {
    "": "891",
    time: "1637709652.3698437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-41.50390625",
    c3: "-40.52734375",
    c4: "-7.32421875",
  },
  {
    "": "892",
    time: "1637709652.37375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-45.41015625",
    c3: "-37.109375",
    c4: "-71.77734375",
  },
  {
    "": "893",
    time: "1637709652.3776562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-29.296875",
    c3: "-62.98828125",
    c4: "-60.05859375",
  },
  {
    "": "894",
    time: "1637709652.3815625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-29.296875",
    c3: "-82.03125",
    c4: "-13.18359375",
  },
  {
    "": "895",
    time: "1637709652.3854687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-34.66796875",
    c3: "-24.4140625",
    c4: "-35.15625",
  },
  {
    "": "896",
    time: "1637709652.389375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-32.2265625",
    c3: "-13.18359375",
    c4: "-85.44921875",
  },
  {
    "": "897",
    time: "1637709652.3932812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-26.85546875",
    c3: "-59.08203125",
    c4: "-83.0078125",
  },
  {
    "": "898",
    time: "1637709652.3971875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-24.4140625",
    c3: "-51.26953125",
    c4: "-46.38671875",
  },
  {
    "": "899",
    time: "1637709652.4010937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-35.64453125",
    c3: "-48.33984375",
    c4: "-43.45703125",
  },
  {
    "": "900",
    time: "1637709652.420125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-41.015625",
    c3: "-80.56640625",
    c4: "-65.91796875",
  },
  {
    "": "901",
    time: "1637709652.4240313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-26.3671875",
    c3: "-86.9140625",
    c4: "-79.58984375",
  },
  {
    "": "902",
    time: "1637709652.4279375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-31.73828125",
    c3: "-67.87109375",
    c4: "-50.78125",
  },
  {
    "": "903",
    time: "1637709652.4318438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-58.10546875",
    c3: "-63.4765625",
    c4: "-23.4375",
  },
  {
    "": "904",
    time: "1637709652.43575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-63.96484375",
    c3: "-103.02734375",
    c4: "-31.25",
  },
  {
    "": "905",
    time: "1637709652.4396563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-37.59765625",
    c3: "-130.37109375",
    c4: "-51.26953125",
  },
  {
    "": "906",
    time: "1637709652.4435625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-16.6015625",
    c3: "-126.953125",
    c4: "-52.734375",
  },
  {
    "": "907",
    time: "1637709652.4474688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-27.83203125",
    c3: "-111.328125",
    c4: "-17.08984375",
  },
  {
    "": "908",
    time: "1637709652.451375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-40.52734375",
    c3: "-95.21484375",
    c4: "-30.76171875",
  },
  {
    "": "909",
    time: "1637709652.4552813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-39.0625",
    c3: "-113.28125",
    c4: "-71.77734375",
  },
  {
    "": "910",
    time: "1637709652.4591875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-31.73828125",
    c3: "-107.91015625",
    c4: "-66.40625",
  },
  {
    "": "911",
    time: "1637709652.4630938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-20.01953125",
    c3: "-70.3125",
    c4: "-18.06640625",
  },
  {
    "": "912",
    time: "1637709652.464125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-55.17578125",
    c3: "-78.125",
    c4: "-12.6953125",
  },
  {
    "": "913",
    time: "1637709652.4680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-50.78125",
    c3: "-89.35546875",
    c4: "-59.08203125",
  },
  {
    "": "914",
    time: "1637709652.4719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-13.671875",
    c3: "-97.65625",
    c4: "-74.70703125",
  },
  {
    "": "915",
    time: "1637709652.4758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-29.78515625",
    c3: "-112.79296875",
    c4: "-21.97265625",
  },
  {
    "": "916",
    time: "1637709652.47975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-58.10546875",
    c3: "-81.0546875",
    c4: "12.6953125",
  },
  {
    "": "917",
    time: "1637709652.4836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-82.03125",
    c3: "-68.84765625",
    c4: "-37.59765625",
  },
  {
    "": "918",
    time: "1637709652.4875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-39.55078125",
    c3: "-65.91796875",
    c4: "-75.1953125",
  },
  {
    "": "919",
    time: "1637709652.4914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-6.8359375",
    c3: "-42.96875",
    c4: "-41.015625",
  },
  {
    "": "920",
    time: "1637709652.495375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-19.04296875",
    c3: "-40.52734375",
    c4: "-5.859375",
  },
  {
    "": "921",
    time: "1637709652.4992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-22.4609375",
    c3: "-55.17578125",
    c4: "-26.85546875",
  },
  {
    "": "922",
    time: "1637709652.5031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-20.01953125",
    c3: "-41.9921875",
    c4: "-70.3125",
  },
  {
    "": "923",
    time: "1637709652.5070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-27.83203125",
    c3: "-42.48046875",
    c4: "-53.7109375",
  },
  {
    "": "924",
    time: "1637709652.510125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-32.71484375",
    c3: "-35.15625",
    c4: "-7.8125",
  },
  {
    "": "925",
    time: "1637709652.5140312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-56.15234375",
    c3: "-49.31640625",
    c4: "-20.99609375",
  },
  {
    "": "926",
    time: "1637709652.5179374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-41.015625",
    c3: "-56.15234375",
    c4: "-50.29296875",
  },
  {
    "": "927",
    time: "1637709652.5218437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.265625",
    c2: "-16.6015625",
    c3: "-41.50390625",
    c4: "-53.22265625",
  },
  {
    "": "928",
    time: "1637709652.52575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-26.85546875",
    c3: "-48.828125",
    c4: "-16.11328125",
  },
  {
    "": "929",
    time: "1637709652.5296562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-36.1328125",
    c3: "-44.921875",
    c4: "-2.9296875",
  },
  {
    "": "930",
    time: "1637709652.5335624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-38.0859375",
    c3: "-33.203125",
    c4: "-60.05859375",
  },
  {
    "": "931",
    time: "1637709652.5374687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-52.24609375",
    c3: "-32.71484375",
    c4: "-77.63671875",
  },
  {
    "": "932",
    time: "1637709652.541375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-47.36328125",
    c3: "-44.921875",
    c4: "-19.53125",
  },
  {
    "": "933",
    time: "1637709652.5452812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-40.0390625",
    c3: "-34.66796875",
    c4: "0.48828125",
  },
  {
    "": "934",
    time: "1637709652.5491874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-53.7109375",
    c3: "-24.90234375",
    c4: "-50.78125",
  },
  {
    "": "935",
    time: "1637709652.5530937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-41.9921875",
    c3: "-58.59375",
    c4: "-74.70703125",
  },
  {
    "": "936",
    time: "1637709652.553125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-40.52734375",
    c3: "-68.84765625",
    c4: "-51.7578125",
  },
  {
    "": "937",
    time: "1637709652.5570312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-72.265625",
    c3: "-24.90234375",
    c4: "-11.71875",
  },
  {
    "": "938",
    time: "1637709652.5609374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-62.01171875",
    c3: "-5.859375",
    c4: "-30.76171875",
  },
  {
    "": "939",
    time: "1637709652.5648437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-43.45703125",
    c3: "-49.8046875",
    c4: "-81.54296875",
  },
  {
    "": "940",
    time: "1637709652.56875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-32.2265625",
    c3: "-84.47265625",
    c4: "-68.359375",
  },
  {
    "": "941",
    time: "1637709652.5726562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-9.27734375",
    c3: "-48.828125",
    c4: "-24.90234375",
  },
  {
    "": "942",
    time: "1637709652.5765624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-15.13671875",
    c3: "-25.87890625",
    c4: "-29.296875",
  },
  {
    "": "943",
    time: "1637709652.5804687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-44.43359375",
    c3: "-55.17578125",
    c4: "-65.4296875",
  },
  {
    "": "944",
    time: "1637709652.584375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-78.61328125",
    c3: "-71.2890625",
    c4: "-63.4765625",
  },
  {
    "": "945",
    time: "1637709652.5882812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-50.78125",
    c3: "-12.20703125",
    c4: "-18.5546875",
  },
  {
    "": "946",
    time: "1637709652.5921874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-23.4375",
    c3: "-10.7421875",
    c4: "-5.37109375",
  },
  {
    "": "947",
    time: "1637709652.5960937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-44.921875",
    c3: "-35.15625",
    c4: "-46.875",
  },
  {
    "": "948",
    time: "1637709652.600125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-44.921875",
    c3: "-22.4609375",
    c4: "-60.05859375",
  },
  {
    "": "949",
    time: "1637709652.6040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-28.3203125",
    c3: "-26.85546875",
    c4: "-25.390625",
  },
  {
    "": "950",
    time: "1637709652.6079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-35.64453125",
    c3: "-32.71484375",
    c4: "-2.44140625",
  },
  {
    "": "951",
    time: "1637709652.6118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-43.45703125",
    c3: "-60.546875",
    c4: "-36.62109375",
  },
  {
    "": "952",
    time: "1637709652.61575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-19.04296875",
    c3: "-40.0390625",
    c4: "-59.5703125",
  },
  {
    "": "953",
    time: "1637709652.6196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-23.4375",
    c3: "-38.0859375",
    c4: "-34.1796875",
  },
  {
    "": "954",
    time: "1637709652.6235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-41.015625",
    c3: "-62.98828125",
    c4: "-8.30078125",
  },
  {
    "": "955",
    time: "1637709652.6274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-29.78515625",
    c3: "-61.5234375",
    c4: "-16.11328125",
  },
  {
    "": "956",
    time: "1637709652.631375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-37.59765625",
    c3: "-39.55078125",
    c4: "-51.7578125",
  },
  {
    "": "957",
    time: "1637709652.6352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-34.1796875",
    c3: "7.32421875",
    c4: "-53.22265625",
  },
  {
    "": "958",
    time: "1637709652.6391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-17.08984375",
    c3: "-6.34765625",
    c4: "-22.94921875",
  },
  {
    "": "959",
    time: "1637709652.6430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-24.90234375",
    c3: "-32.71484375",
    c4: "-28.3203125",
  },
  {
    "": "960",
    time: "1637709652.643125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-38.57421875",
    c3: "-18.5546875",
    c4: "-70.80078125",
  },
  {
    "": "961",
    time: "1637709652.6470313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-40.0390625",
    c3: "-33.69140625",
    c4: "-83.984375",
  },
  {
    "": "962",
    time: "1637709652.6509376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-50.78125",
    c3: "-68.84765625",
    c4: "-42.96875",
  },
  {
    "": "963",
    time: "1637709652.6548438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-61.5234375",
    c3: "-65.4296875",
    c4: "-17.08984375",
  },
  {
    "": "964",
    time: "1637709652.65875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-59.08203125",
    c3: "-43.45703125",
    c4: "-60.05859375",
  },
  {
    "": "965",
    time: "1637709652.6626563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-52.24609375",
    c3: "-56.640625",
    c4: "-85.44921875",
  },
  {
    "": "966",
    time: "1637709652.6665626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-41.50390625",
    c3: "-74.70703125",
    c4: "-23.92578125",
  },
  {
    "": "967",
    time: "1637709652.6704688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-27.83203125",
    c3: "-57.6171875",
    c4: "25.87890625",
  },
  {
    "": "968",
    time: "1637709652.674375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-25.390625",
    c3: "-28.3203125",
    c4: "-30.2734375",
  },
  {
    "": "969",
    time: "1637709652.6782813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-26.85546875",
    c3: "-32.71484375",
    c4: "-95.21484375",
  },
  {
    "": "970",
    time: "1637709652.6821876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-19.53125",
    c3: "-49.31640625",
    c4: "-67.87109375",
  },
  {
    "": "971",
    time: "1637709652.6860938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-14.6484375",
    c3: "-21.97265625",
    c4: "-8.30078125",
  },
  {
    "": "972",
    time: "1637709652.691125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-23.92578125",
    c3: "10.25390625",
    c4: "-22.94921875",
  },
  {
    "": "973",
    time: "1637709652.6950312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-29.78515625",
    c3: "-20.99609375",
    c4: "-72.265625",
  },
  {
    "": "974",
    time: "1637709652.6989374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "-46.38671875",
    c3: "-49.31640625",
    c4: "-58.10546875",
  },
  {
    "": "975",
    time: "1637709652.7028437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-41.50390625",
    c3: "-35.15625",
    c4: "-10.25390625",
  },
  {
    "": "976",
    time: "1637709652.70675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-29.78515625",
    c3: "-25.390625",
    c4: "-16.11328125",
  },
  {
    "": "977",
    time: "1637709652.7106562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-43.45703125",
    c3: "-39.55078125",
    c4: "-54.19921875",
  },
  {
    "": "978",
    time: "1637709652.7145624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-39.0625",
    c3: "-71.77734375",
    c4: "-62.98828125",
  },
  {
    "": "979",
    time: "1637709652.7184687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-21.484375",
    c3: "-62.98828125",
    c4: "-18.5546875",
  },
  {
    "": "980",
    time: "1637709652.722375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-27.34375",
    c3: "-21.484375",
    c4: "11.71875",
  },
  {
    "": "981",
    time: "1637709652.7262812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-46.875",
    c3: "-24.90234375",
    c4: "-36.1328125",
  },
  {
    "": "982",
    time: "1637709652.7301874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-37.109375",
    c3: "-66.40625",
    c4: "-80.56640625",
  },
  {
    "": "983",
    time: "1637709652.7340937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-30.76171875",
    c3: "-40.0390625",
    c4: "-37.109375",
  },
  {
    "": "984",
    time: "1637709652.735125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-39.0625",
    c3: "6.34765625",
    c4: "5.859375",
  },
  {
    "": "985",
    time: "1637709652.7390313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-35.64453125",
    c3: "-27.83203125",
    c4: "-31.73828125",
  },
  {
    "": "986",
    time: "1637709652.7429376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-34.66796875",
    c3: "-54.6875",
    c4: "-83.0078125",
  },
  {
    "": "987",
    time: "1637709652.7468438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-72.75390625",
    c3: "-48.828125",
    c4: "-61.5234375",
  },
  {
    "": "988",
    time: "1637709652.75075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-81.54296875",
    c3: "-40.0390625",
    c4: "7.32421875",
  },
  {
    "": "989",
    time: "1637709652.7546563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-55.17578125",
    c3: "-62.5",
    c4: "-11.23046875",
  },
  {
    "": "990",
    time: "1637709652.7585626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-43.9453125",
    c3: "-102.5390625",
    c4: "-61.03515625",
  },
  {
    "": "991",
    time: "1637709652.7624688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-33.69140625",
    c3: "-55.17578125",
    c4: "-56.15234375",
  },
  {
    "": "992",
    time: "1637709652.766375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-37.59765625",
    c3: "-21.97265625",
    c4: "-32.2265625",
  },
  {
    "": "993",
    time: "1637709652.7702813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-50.78125",
    c3: "-21.97265625",
    c4: "-39.0625",
  },
  {
    "": "994",
    time: "1637709652.7741876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-54.19921875",
    c3: "-13.671875",
    c4: "-86.42578125",
  },
  {
    "": "995",
    time: "1637709652.7780938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.1015625",
    c2: "-37.109375",
    c3: "-17.578125",
    c4: "-90.33203125",
  },
  {
    "": "996",
    time: "1637709652.780125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-58.59375",
    c3: "-27.34375",
    c4: "-20.01953125",
  },
  {
    "": "997",
    time: "1637709652.7840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-53.22265625",
    c3: "-28.80859375",
    c4: "28.3203125",
  },
  {
    "": "998",
    time: "1637709652.7879374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-22.4609375",
    c3: "-42.48046875",
    c4: "-25.390625",
  },
  {
    "": "999",
    time: "1637709652.7918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-88.8671875",
    c2: "-26.85546875",
    c3: "-67.3828125",
    c4: "-58.10546875",
  },
  {
    "": "1000",
    time: "1637709652.79575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-23.4375",
    c3: "-54.6875",
    c4: "-32.2265625",
  },
  {
    "": "1001",
    time: "1637709652.7996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-21.484375",
    c3: "-83.49609375",
    c4: "-8.30078125",
  },
  {
    "": "1002",
    time: "1637709652.8035624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-21.97265625",
    c3: "-74.21875",
    c4: "-28.3203125",
  },
  {
    "": "1003",
    time: "1637709652.8074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-42.48046875",
    c3: "-15.13671875",
    c4: "-77.63671875",
  },
  {
    "": "1004",
    time: "1637709652.811375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-61.5234375",
    c3: "-24.90234375",
    c4: "-61.5234375",
  },
  {
    "": "1005",
    time: "1637709652.8152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-37.109375",
    c3: "-37.109375",
    c4: "-11.23046875",
  },
  {
    "": "1006",
    time: "1637709652.8191874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-53.22265625",
    c3: "-10.7421875",
    c4: "-24.90234375",
  },
  {
    "": "1007",
    time: "1637709652.8230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-55.17578125",
    c3: "-20.01953125",
    c4: "-74.21875",
  },
  {
    "": "1008",
    time: "1637709652.838125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-20.5078125",
    c3: "-55.6640625",
    c4: "-85.44921875",
  },
  {
    "": "1009",
    time: "1637709652.8420312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-17.578125",
    c3: "-42.96875",
    c4: "-41.50390625",
  },
  {
    "": "1010",
    time: "1637709652.8459375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-14.16015625",
    c3: "-41.015625",
    c4: "-16.11328125",
  },
  {
    "": "1011",
    time: "1637709652.8498437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-35.15625",
    c3: "-56.15234375",
    c4: "-45.8984375",
  },
  {
    "": "1012",
    time: "1637709652.85375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-51.26953125",
    c3: "-76.171875",
    c4: "-71.77734375",
  },
  {
    "": "1013",
    time: "1637709652.8576562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-37.59765625",
    c3: "-78.61328125",
    c4: "-20.01953125",
  },
  {
    "": "1014",
    time: "1637709652.8615625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-37.59765625",
    c3: "-23.92578125",
    c4: "15.13671875",
  },
  {
    "": "1015",
    time: "1637709652.8654687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-36.62109375",
    c3: "-25.390625",
    c4: "-28.80859375",
  },
  {
    "": "1016",
    time: "1637709652.869375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-40.52734375",
    c3: "-73.73046875",
    c4: "-67.3828125",
  },
  {
    "": "1017",
    time: "1637709652.8732812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-69.3359375",
    c3: "-79.58984375",
    c4: "-38.0859375",
  },
  {
    "": "1018",
    time: "1637709652.8771875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-56.640625",
    c3: "-22.4609375",
    c4: "-11.71875",
  },
  {
    "": "1019",
    time: "1637709652.8810937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-20.99609375",
    c3: "-11.23046875",
    c4: "-28.3203125",
  },
  {
    "": "1020",
    time: "1637709652.884125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-25.87890625",
    c3: "-28.80859375",
    c4: "-60.05859375",
  },
  {
    "": "1021",
    time: "1637709652.8880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-49.31640625",
    c3: "-36.1328125",
    c4: "-52.734375",
  },
  {
    "": "1022",
    time: "1637709652.8919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-29.296875",
    c3: "-41.015625",
    c4: "-11.71875",
  },
  {
    "": "1023",
    time: "1637709652.8958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-10.7421875",
    c3: "-11.71875",
    c4: "-8.30078125",
  },
  {
    "": "1024",
    time: "1637709652.89975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-18.06640625",
    c3: "-8.7890625",
    c4: "-58.10546875",
  },
  {
    "": "1025",
    time: "1637709652.9036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-28.3203125",
    c3: "-50.29296875",
    c4: "-73.2421875",
  },
  {
    "": "1026",
    time: "1637709652.9075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-43.9453125",
    c3: "-66.89453125",
    c4: "-29.78515625",
  },
  {
    "": "1027",
    time: "1637709652.9114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-33.69140625",
    c3: "-27.83203125",
    c4: "-8.7890625",
  },
  {
    "": "1028",
    time: "1637709652.915375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-20.5078125",
    c3: "-22.94921875",
    c4: "-45.41015625",
  },
  {
    "": "1029",
    time: "1637709652.9192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-38.57421875",
    c3: "-12.20703125",
    c4: "-94.23828125",
  },
  {
    "": "1030",
    time: "1637709652.9231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-41.015625",
    c3: "-13.671875",
    c4: "-54.6875",
  },
  {
    "": "1031",
    time: "1637709652.9270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-24.4140625",
    c3: "-41.015625",
    c4: "-0.9765625",
  },
  {
    "": "1032",
    time: "1637709652.928125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-32.71484375",
    c3: "-42.96875",
    c4: "-27.83203125",
  },
  {
    "": "1033",
    time: "1637709652.9320312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-42.48046875",
    c3: "-48.828125",
    c4: "-71.2890625",
  },
  {
    "": "1034",
    time: "1637709652.9359374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-32.71484375",
    c3: "-40.52734375",
    c4: "-40.0390625",
  },
  {
    "": "1035",
    time: "1637709652.9398437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-28.80859375",
    c3: "-41.9921875",
    c4: "8.30078125",
  },
  {
    "": "1036",
    time: "1637709652.94375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-33.203125",
    c3: "-40.52734375",
    c4: "-14.16015625",
  },
  {
    "": "1037",
    time: "1637709652.9476562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-46.875",
    c3: "-30.2734375",
    c4: "-57.12890625",
  },
  {
    "": "1038",
    time: "1637709652.9515624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-50.29296875",
    c3: "-35.64453125",
    c4: "-64.94140625",
  },
  {
    "": "1039",
    time: "1637709652.9554687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-24.4140625",
    c3: "-66.40625",
    c4: "-16.6015625",
  },
  {
    "": "1040",
    time: "1637709652.959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-24.90234375",
    c3: "-72.75390625",
    c4: "-14.16015625",
  },
  {
    "": "1041",
    time: "1637709652.9632812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-44.43359375",
    c3: "-24.90234375",
    c4: "-66.40625",
  },
  {
    "": "1042",
    time: "1637709652.9671874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-58.59375",
    c3: "-28.80859375",
    c4: "-65.91796875",
  },
  {
    "": "1043",
    time: "1637709652.9710937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-38.0859375",
    c3: "-29.296875",
    c4: "-24.4140625",
  },
  {
    "": "1044",
    time: "1637709652.977125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-35.64453125",
    c3: "-5.859375",
    c4: "-2.44140625",
  },
  {
    "": "1045",
    time: "1637709652.9810312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-36.62109375",
    c3: "-33.69140625",
    c4: "-40.0390625",
  },
  {
    "": "1046",
    time: "1637709652.9849374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-9.765625",
    c3: "-68.359375",
    c4: "-75.1953125",
  },
  {
    "": "1047",
    time: "1637709652.9888437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-18.06640625",
    c3: "-49.8046875",
    c4: "-31.25",
  },
  {
    "": "1048",
    time: "1637709652.99275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-24.90234375",
    c3: "-22.94921875",
    c4: "8.30078125",
  },
  {
    "": "1049",
    time: "1637709652.9966562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-32.2265625",
    c3: "-23.4375",
    c4: "-30.2734375",
  },
  {
    "": "1050",
    time: "1637709653.0005624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-56.15234375",
    c3: "-45.41015625",
    c4: "-74.70703125",
  },
  {
    "": "1051",
    time: "1637709653.0044687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-44.43359375",
    c3: "-73.73046875",
    c4: "-37.109375",
  },
  {
    "": "1052",
    time: "1637709653.008375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-2.9296875",
    c3: "-29.78515625",
    c4: "10.7421875",
  },
  {
    "": "1053",
    time: "1637709653.0122812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-14.6484375",
    c3: "-3.41796875",
    c4: "-10.25390625",
  },
  {
    "": "1054",
    time: "1637709653.0161874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-56.15234375",
    c3: "-43.45703125",
    c4: "-60.05859375",
  },
  {
    "": "1055",
    time: "1637709653.0200937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-48.828125",
    c3: "-44.43359375",
    c4: "-60.546875",
  },
  {
    "": "1056",
    time: "1637709653.018125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-31.25",
    c3: "-17.578125",
    c4: "3.90625",
  },
  {
    "": "1057",
    time: "1637709653.0220313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-40.0390625",
    c3: "-11.71875",
    c4: "18.5546875",
  },
  {
    "": "1058",
    time: "1637709653.0259376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-52.734375",
    c3: "-32.71484375",
    c4: "-41.9921875",
  },
  {
    "": "1059",
    time: "1637709653.0298438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-36.1328125",
    c3: "-53.22265625",
    c4: "-72.75390625",
  },
  {
    "": "1060",
    time: "1637709653.03375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-28.80859375",
    c3: "-53.7109375",
    c4: "-30.2734375",
  },
  {
    "": "1061",
    time: "1637709653.0376563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-27.34375",
    c3: "-38.0859375",
    c4: "-3.41796875",
  },
  {
    "": "1062",
    time: "1637709653.0415626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-24.90234375",
    c3: "-56.640625",
    c4: "-33.203125",
  },
  {
    "": "1063",
    time: "1637709653.0454688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-28.3203125",
    c3: "-86.9140625",
    c4: "-62.98828125",
  },
  {
    "": "1064",
    time: "1637709653.049375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-27.83203125",
    c3: "-49.8046875",
    c4: "-51.7578125",
  },
  {
    "": "1065",
    time: "1637709653.0532813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-24.4140625",
    c3: "-16.11328125",
    c4: "-19.04296875",
  },
  {
    "": "1066",
    time: "1637709653.0571876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-36.62109375",
    c3: "-22.4609375",
    c4: "-21.484375",
  },
  {
    "": "1067",
    time: "1637709653.0610938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-55.6640625",
    c3: "-23.4375",
    c4: "-61.5234375",
  },
  {
    "": "1068",
    time: "1637709653.065125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-54.19921875",
    c3: "-19.04296875",
    c4: "-66.40625",
  },
  {
    "": "1069",
    time: "1637709653.0690312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-37.109375",
    c3: "-41.9921875",
    c4: "-9.765625",
  },
  {
    "": "1070",
    time: "1637709653.0729375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-19.53125",
    c3: "-39.0625",
    c4: "-7.8125",
  },
  {
    "": "1071",
    time: "1637709653.0768437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-5.859375",
    c3: "-18.06640625",
    c4: "-56.15234375",
  },
  {
    "": "1072",
    time: "1637709653.08075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-26.3671875",
    c3: "-37.59765625",
    c4: "-59.5703125",
  },
  {
    "": "1073",
    time: "1637709653.0846562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-51.7578125",
    c3: "-50.78125",
    c4: "-40.0390625",
  },
  {
    "": "1074",
    time: "1637709653.0885625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-57.12890625",
    c3: "-57.12890625",
    c4: "-23.4375",
  },
  {
    "": "1075",
    time: "1637709653.0924687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-59.5703125",
    c3: "-41.9921875",
    c4: "-62.5",
  },
  {
    "": "1076",
    time: "1637709653.096375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-38.57421875",
    c3: "-14.6484375",
    c4: "-87.40234375",
  },
  {
    "": "1077",
    time: "1637709653.1002812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-19.04296875",
    c3: "-16.11328125",
    c4: "-30.76171875",
  },
  {
    "": "1078",
    time: "1637709653.1041875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-33.203125",
    c3: "-19.53125",
    c4: "0.0",
  },
  {
    "": "1079",
    time: "1637709653.1080937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-42.48046875",
    c3: "-9.27734375",
    c4: "-30.2734375",
  },
  {
    "": "1080",
    time: "1637709653.108125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-42.48046875",
    c3: "-19.04296875",
    c4: "-54.19921875",
  },
  {
    "": "1081",
    time: "1637709653.1120312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-34.1796875",
    c3: "-47.8515625",
    c4: "-49.31640625",
  },
  {
    "": "1082",
    time: "1637709653.1159375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-17.578125",
    c3: "-39.55078125",
    c4: "-1.953125",
  },
  {
    "": "1083",
    time: "1637709653.1198437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-14.16015625",
    c3: "-26.85546875",
    c4: "-22.94921875",
  },
  {
    "": "1084",
    time: "1637709653.12375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-21.97265625",
    c3: "-23.4375",
    c4: "-70.80078125",
  },
  {
    "": "1085",
    time: "1637709653.1276562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-38.0859375",
    c3: "-44.921875",
    c4: "-53.7109375",
  },
  {
    "": "1086",
    time: "1637709653.1315625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-50.78125",
    c3: "-88.8671875",
    c4: "-1.953125",
  },
  {
    "": "1087",
    time: "1637709653.1354687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-40.52734375",
    c3: "-38.57421875",
    c4: "9.27734375",
  },
  {
    "": "1088",
    time: "1637709653.139375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-28.3203125",
    c3: "-30.76171875",
    c4: "-60.05859375",
  },
  {
    "": "1089",
    time: "1637709653.1432812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-38.0859375",
    c3: "-70.3125",
    c4: "-84.47265625",
  },
  {
    "": "1090",
    time: "1637709653.1471875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-49.8046875",
    c3: "-14.16015625",
    c4: "-28.80859375",
  },
  {
    "": "1091",
    time: "1637709653.1510937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-21.97265625",
    c3: "14.16015625",
    c4: "-17.08984375",
  },
  {
    "": "1092",
    time: "1637709653.157125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "1.46484375",
    c3: "-12.20703125",
    c4: "-56.640625",
  },
  {
    "": "1093",
    time: "1637709653.1610312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-10.7421875",
    c3: "-34.66796875",
    c4: "-83.49609375",
  },
  {
    "": "1094",
    time: "1637709653.1649375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-28.80859375",
    c3: "-31.25",
    c4: "-34.66796875",
  },
  {
    "": "1095",
    time: "1637709653.1688437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-36.1328125",
    c3: "3.90625",
    c4: "22.94921875",
  },
  {
    "": "1096",
    time: "1637709653.17275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-46.875",
    c3: "8.30078125",
    c4: "-13.671875",
  },
  {
    "": "1097",
    time: "1637709653.1766562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-45.41015625",
    c3: "-24.90234375",
    c4: "-62.98828125",
  },
  {
    "": "1098",
    time: "1637709653.1805625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-40.52734375",
    c3: "-30.2734375",
    c4: "-51.7578125",
  },
  {
    "": "1099",
    time: "1637709653.1844687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-58.10546875",
    c3: "-9.765625",
    c4: "4.39453125",
  },
  {
    "": "1100",
    time: "1637709653.188375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-43.45703125",
    c3: "-14.16015625",
    c4: "7.8125",
  },
  {
    "": "1101",
    time: "1637709653.1922812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-15.625",
    c3: "-45.41015625",
    c4: "-62.98828125",
  },
  {
    "": "1102",
    time: "1637709653.1961875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-37.59765625",
    c3: "-29.296875",
    c4: "-94.23828125",
  },
  {
    "": "1103",
    time: "1637709653.2000937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-44.43359375",
    c3: "-14.6484375",
    c4: "-27.34375",
  },
  {
    "": "1104",
    time: "1637709653.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-13.671875",
    c3: "-44.43359375",
    c4: "5.37109375",
  },
  {
    "": "1105",
    time: "1637709653.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-19.04296875",
    c3: "-83.0078125",
    c4: "-56.640625",
  },
  {
    "": "1106",
    time: "1637709653.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-45.8984375",
    c3: "-70.80078125",
    c4: "-79.1015625",
  },
  {
    "": "1107",
    time: "1637709653.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-46.875",
    c3: "-33.69140625",
    c4: "-21.97265625",
  },
  {
    "": "1108",
    time: "1637709653.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-25.87890625",
    c3: "-27.83203125",
    c4: "12.20703125",
  },
  {
    "": "1109",
    time: "1637709653.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-54.19921875",
    c3: "-69.3359375",
    c4: "-14.16015625",
  },
  {
    "": "1110",
    time: "1637709653.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-79.1015625",
    c3: "-62.01171875",
    c4: "-57.6171875",
  },
  {
    "": "1111",
    time: "1637709653.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-53.7109375",
    c3: "0.0",
    c4: "-38.57421875",
  },
  {
    "": "1112",
    time: "1637709653.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-26.3671875",
    c3: "9.27734375",
    c4: "18.06640625",
  },
  {
    "": "1113",
    time: "1637709653.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-18.5546875",
    c3: "-8.30078125",
    c4: "-10.7421875",
  },
  {
    "": "1114",
    time: "1637709653.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-30.2734375",
    c3: "-20.5078125",
    c4: "-64.94140625",
  },
  {
    "": "1115",
    time: "1637709653.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-25.87890625",
    c3: "-24.4140625",
    c4: "-62.5",
  },
  {
    "": "1116",
    time: "1637709653.259125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-18.06640625",
    c3: "-23.4375",
    c4: "-8.7890625",
  },
  {
    "": "1117",
    time: "1637709653.2630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-35.15625",
    c3: "-32.71484375",
    c4: "-5.859375",
  },
  {
    "": "1118",
    time: "1637709653.2669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-57.12890625",
    c3: "-39.55078125",
    c4: "-53.22265625",
  },
  {
    "": "1119",
    time: "1637709653.2708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-39.55078125",
    c3: "-39.55078125",
    c4: "-69.82421875",
  },
  {
    "": "1120",
    time: "1637709653.27475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-9.765625",
    c3: "-46.875",
    c4: "-31.25",
  },
  {
    "": "1121",
    time: "1637709653.2786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-10.25390625",
    c3: "-49.8046875",
    c4: "-10.25390625",
  },
  {
    "": "1122",
    time: "1637709653.2825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-17.578125",
    c3: "-41.9921875",
    c4: "-47.36328125",
  },
  {
    "": "1123",
    time: "1637709653.2864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-26.85546875",
    c3: "-40.0390625",
    c4: "-75.68359375",
  },
  {
    "": "1124",
    time: "1637709653.290375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-61.5234375",
    c3: "-79.58984375",
    c4: "-25.87890625",
  },
  {
    "": "1125",
    time: "1637709653.2942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-64.453125",
    c3: "-38.57421875",
    c4: "17.578125",
  },
  {
    "": "1126",
    time: "1637709653.2981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-50.29296875",
    c3: "-8.7890625",
    c4: "-31.25",
  },
  {
    "": "1127",
    time: "1637709653.3020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-30.76171875",
    c3: "-24.90234375",
    c4: "-65.91796875",
  },
  {
    "": "1128",
    time: "1637709653.319125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-19.53125",
    c3: "-4.8828125",
    c4: "-60.05859375",
  },
  {
    "": "1129",
    time: "1637709653.3230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-19.04296875",
    c3: "-11.23046875",
    c4: "-15.13671875",
  },
  {
    "": "1130",
    time: "1637709653.3269374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-18.06640625",
    c3: "-27.83203125",
    c4: "-22.4609375",
  },
  {
    "": "1131",
    time: "1637709653.3308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-36.1328125",
    c3: "-46.875",
    c4: "-63.96484375",
  },
  {
    "": "1132",
    time: "1637709653.33475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-34.1796875",
    c3: "-42.96875",
    c4: "-48.828125",
  },
  {
    "": "1133",
    time: "1637709653.3386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-27.34375",
    c3: "-30.2734375",
    c4: "-6.34765625",
  },
  {
    "": "1134",
    time: "1637709653.3425624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-23.92578125",
    c3: "-23.4375",
    c4: "-8.7890625",
  },
  {
    "": "1135",
    time: "1637709653.3464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-27.34375",
    c3: "-35.64453125",
    c4: "-64.94140625",
  },
  {
    "": "1136",
    time: "1637709653.350375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-40.52734375",
    c3: "-59.08203125",
    c4: "-73.73046875",
  },
  {
    "": "1137",
    time: "1637709653.3542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-30.76171875",
    c3: "-20.5078125",
    c4: "-27.83203125",
  },
  {
    "": "1138",
    time: "1637709653.3581874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-14.6484375",
    c3: "-7.32421875",
    c4: "0.9765625",
  },
  {
    "": "1139",
    time: "1637709653.3620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-30.2734375",
    c3: "-25.390625",
    c4: "-41.50390625",
  },
  {
    "": "1140",
    time: "1637709653.350125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-38.0859375",
    c3: "-26.85546875",
    c4: "-76.171875",
  },
  {
    "": "1141",
    time: "1637709653.3540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-27.83203125",
    c3: "-30.76171875",
    c4: "-35.15625",
  },
  {
    "": "1142",
    time: "1637709653.3579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-45.41015625",
    c3: "-43.9453125",
    c4: "-12.6953125",
  },
  {
    "": "1143",
    time: "1637709653.3618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-47.36328125",
    c3: "-48.33984375",
    c4: "-55.6640625",
  },
  {
    "": "1144",
    time: "1637709653.36575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-37.59765625",
    c3: "-48.828125",
    c4: "-84.47265625",
  },
  {
    "": "1145",
    time: "1637709653.3696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-37.59765625",
    c3: "-20.5078125",
    c4: "-63.4765625",
  },
  {
    "": "1146",
    time: "1637709653.3735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-24.90234375",
    c3: "-0.9765625",
    c4: "-14.16015625",
  },
  {
    "": "1147",
    time: "1637709653.3774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-33.203125",
    c3: "-28.3203125",
    c4: "-5.859375",
  },
  {
    "": "1148",
    time: "1637709653.381375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-27.34375",
    c3: "-33.69140625",
    c4: "-59.08203125",
  },
  {
    "": "1149",
    time: "1637709653.3852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-25.87890625",
    c3: "-42.48046875",
    c4: "-70.3125",
  },
  {
    "": "1150",
    time: "1637709653.3891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-37.109375",
    c3: "-41.015625",
    c4: "9.765625",
  },
  {
    "": "1151",
    time: "1637709653.3930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-16.6015625",
    c3: "-32.2265625",
    c4: "14.6484375",
  },
  {
    "": "1152",
    time: "1637709653.393125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-22.4609375",
    c3: "-25.87890625",
    c4: "-51.7578125",
  },
  {
    "": "1153",
    time: "1637709653.3970313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-49.8046875",
    c3: "-10.25390625",
    c4: "-69.82421875",
  },
  {
    "": "1154",
    time: "1637709653.4009376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-43.45703125",
    c3: "-16.11328125",
    c4: "-30.2734375",
  },
  {
    "": "1155",
    time: "1637709653.4048438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-34.66796875",
    c3: "-27.83203125",
    c4: "1.46484375",
  },
  {
    "": "1156",
    time: "1637709653.40875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-64.94140625",
    c3: "-18.5546875",
    c4: "-29.296875",
  },
  {
    "": "1157",
    time: "1637709653.4126563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-57.6171875",
    c3: "-29.78515625",
    c4: "-58.10546875",
  },
  {
    "": "1158",
    time: "1637709653.4165626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-29.78515625",
    c3: "-79.58984375",
    c4: "-37.59765625",
  },
  {
    "": "1159",
    time: "1637709653.4204688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-51.7578125",
    c3: "-108.3984375",
    c4: "12.20703125",
  },
  {
    "": "1160",
    time: "1637709653.424375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-46.875",
    c3: "-42.96875",
    c4: "-7.32421875",
  },
  {
    "": "1161",
    time: "1637709653.4282813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-29.296875",
    c3: "6.34765625",
    c4: "-62.98828125",
  },
  {
    "": "1162",
    time: "1637709653.4321876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-29.78515625",
    c3: "-26.3671875",
    c4: "-57.12890625",
  },
  {
    "": "1163",
    time: "1637709653.4360938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-42.48046875",
    c3: "-32.71484375",
    c4: "-11.23046875",
  },
  {
    "": "1164",
    time: "1637709653.442125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-39.0625",
    c3: "-5.37109375",
    c4: "-19.04296875",
  },
  {
    "": "1165",
    time: "1637709653.4460313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-19.53125",
    c3: "-24.4140625",
    c4: "-64.453125",
  },
  {
    "": "1166",
    time: "1637709653.4499376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-37.59765625",
    c3: "-54.19921875",
    c4: "-57.12890625",
  },
  {
    "": "1167",
    time: "1637709653.4538438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-53.22265625",
    c3: "-49.8046875",
    c4: "-13.671875",
  },
  {
    "": "1168",
    time: "1637709653.45775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-37.59765625",
    c3: "-39.0625",
    c4: "-4.8828125",
  },
  {
    "": "1169",
    time: "1637709653.4616563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-43.9453125",
    c3: "-42.48046875",
    c4: "-43.9453125",
  },
  {
    "": "1170",
    time: "1637709653.4655626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-44.921875",
    c3: "-67.87109375",
    c4: "-69.3359375",
  },
  {
    "": "1171",
    time: "1637709653.4694688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-51.26953125",
    c3: "-49.31640625",
    c4: "-49.31640625",
  },
  {
    "": "1172",
    time: "1637709653.473375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-95.21484375",
    c3: "-19.53125",
    c4: "-16.11328125",
  },
  {
    "": "1173",
    time: "1637709653.4772813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-73.2421875",
    c3: "-41.50390625",
    c4: "-21.97265625",
  },
  {
    "": "1174",
    time: "1637709653.4811876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-23.4375",
    c3: "-66.89453125",
    c4: "-53.22265625",
  },
  {
    "": "1175",
    time: "1637709653.4850938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-31.25",
    c3: "-56.15234375",
    c4: "-37.59765625",
  },
  {
    "": "1176",
    time: "1637709653.483125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-32.71484375",
    c3: "-36.62109375",
    c4: "-18.5546875",
  },
  {
    "": "1177",
    time: "1637709653.4870312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-17.08984375",
    c3: "-24.4140625",
    c4: "-35.64453125",
  },
  {
    "": "1178",
    time: "1637709653.4909375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-21.484375",
    c3: "-31.25",
    c4: "-68.359375",
  },
  {
    "": "1179",
    time: "1637709653.4948437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-24.4140625",
    c3: "-41.50390625",
    c4: "-69.3359375",
  },
  {
    "": "1180",
    time: "1637709653.49875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-21.484375",
    c3: "-32.71484375",
    c4: "-10.25390625",
  },
  {
    "": "1181",
    time: "1637709653.5026562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-34.66796875",
    c3: "-30.2734375",
    c4: "-1.953125",
  },
  {
    "": "1182",
    time: "1637709653.5065625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-57.12890625",
    c3: "-68.84765625",
    c4: "-50.78125",
  },
  {
    "": "1183",
    time: "1637709653.5104687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-57.6171875",
    c3: "-36.1328125",
    c4: "-58.10546875",
  },
  {
    "": "1184",
    time: "1637709653.514375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-30.76171875",
    c3: "6.34765625",
    c4: "-19.53125",
  },
  {
    "": "1185",
    time: "1637709653.5182812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-16.11328125",
    c3: "-18.06640625",
    c4: "-7.32421875",
  },
  {
    "": "1186",
    time: "1637709653.5221875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-34.1796875",
    c3: "-41.50390625",
    c4: "-43.9453125",
  },
  {
    "": "1187",
    time: "1637709653.5260937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-39.55078125",
    c3: "-18.5546875",
    c4: "-64.453125",
  },
  {
    "": "1188",
    time: "1637709653.531125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-33.69140625",
    c3: "11.71875",
    c4: "-38.0859375",
  },
  {
    "": "1189",
    time: "1637709653.5350313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-30.76171875",
    c3: "-32.71484375",
    c4: "3.41796875",
  },
  {
    "": "1190",
    time: "1637709653.5389376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-7.8125",
    c3: "-39.0625",
    c4: "-14.16015625",
  },
  {
    "": "1191",
    time: "1637709653.5428438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-11.71875",
    c3: "-23.92578125",
    c4: "-69.82421875",
  },
  {
    "": "1192",
    time: "1637709653.54675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-40.52734375",
    c3: "-30.76171875",
    c4: "-50.29296875",
  },
  {
    "": "1193",
    time: "1637709653.5506563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-47.8515625",
    c3: "-20.99609375",
    c4: "6.34765625",
  },
  {
    "": "1194",
    time: "1637709653.5545626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-55.17578125",
    c3: "-19.53125",
    c4: "-11.71875",
  },
  {
    "": "1195",
    time: "1637709653.5584688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-47.8515625",
    c3: "-13.671875",
    c4: "-67.87109375",
  },
  {
    "": "1196",
    time: "1637709653.562375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-28.80859375",
    c3: "-22.4609375",
    c4: "-72.75390625",
  },
  {
    "": "1197",
    time: "1637709653.5662813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-32.2265625",
    c3: "-56.640625",
    c4: "-6.8359375",
  },
  {
    "": "1198",
    time: "1637709653.5701876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-33.69140625",
    c3: "-41.9921875",
    c4: "14.16015625",
  },
  {
    "": "1199",
    time: "1637709653.5740938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-27.34375",
    c3: "-26.85546875",
    c4: "-44.43359375",
  },
  {
    "": "1200",
    time: "1637709653.588125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-44.43359375",
    c3: "-42.48046875",
    c4: "-72.75390625",
  },
  {
    "": "1201",
    time: "1637709653.5920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-64.453125",
    c3: "-25.87890625",
    c4: "-28.80859375",
  },
  {
    "": "1202",
    time: "1637709653.5959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-52.734375",
    c3: "-14.6484375",
    c4: "0.0",
  },
  {
    "": "1203",
    time: "1637709653.5998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-53.7109375",
    c3: "-25.390625",
    c4: "-39.55078125",
  },
  {
    "": "1204",
    time: "1637709653.60375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-49.31640625",
    c3: "-45.8984375",
    c4: "-69.82421875",
  },
  {
    "": "1205",
    time: "1637709653.6076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-27.34375",
    c3: "-55.6640625",
    c4: "-24.90234375",
  },
  {
    "": "1206",
    time: "1637709653.6115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-21.97265625",
    c3: "-53.7109375",
    c4: "12.20703125",
  },
  {
    "": "1207",
    time: "1637709653.6154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-46.875",
    c3: "-53.7109375",
    c4: "-38.0859375",
  },
  {
    "": "1208",
    time: "1637709653.619375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-66.40625",
    c3: "-48.33984375",
    c4: "-82.03125",
  },
  {
    "": "1209",
    time: "1637709653.6232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-53.7109375",
    c3: "-26.85546875",
    c4: "-63.4765625",
  },
  {
    "": "1210",
    time: "1637709653.6271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-38.57421875",
    c3: "1.46484375",
    c4: "-10.25390625",
  },
  {
    "": "1211",
    time: "1637709653.6310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-19.53125",
    c3: "-12.20703125",
    c4: "-7.8125",
  },
  {
    "": "1212",
    time: "1637709653.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-5.859375",
    c3: "-27.83203125",
    c4: "-63.96484375",
  },
  {
    "": "1213",
    time: "1637709653.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-22.4609375",
    c3: "-20.5078125",
    c4: "-84.9609375",
  },
  {
    "": "1214",
    time: "1637709653.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-30.2734375",
    c3: "-16.6015625",
    c4: "-30.2734375",
  },
  {
    "": "1215",
    time: "1637709653.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-27.83203125",
    c3: "-40.0390625",
    c4: "-17.08984375",
  },
  {
    "": "1216",
    time: "1637709653.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-30.76171875",
    c3: "-57.6171875",
    c4: "-72.265625",
  },
  {
    "": "1217",
    time: "1637709653.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-43.9453125",
    c3: "-53.22265625",
    c4: "-81.0546875",
  },
  {
    "": "1218",
    time: "1637709653.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-35.15625",
    c3: "-40.0390625",
    c4: "-37.109375",
  },
  {
    "": "1219",
    time: "1637709653.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-24.90234375",
    c3: "-38.0859375",
    c4: "1.953125",
  },
  {
    "": "1220",
    time: "1637709653.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-43.45703125",
    c3: "-68.84765625",
    c4: "-32.2265625",
  },
  {
    "": "1221",
    time: "1637709653.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-49.31640625",
    c3: "-53.22265625",
    c4: "-83.49609375",
  },
  {
    "": "1222",
    time: "1637709653.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-52.24609375",
    c3: "-14.16015625",
    c4: "-63.4765625",
  },
  {
    "": "1223",
    time: "1637709653.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-30.76171875",
    c3: "-25.87890625",
    c4: "-19.04296875",
  },
  {
    "": "1224",
    time: "1637709653.680125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-20.5078125",
    c3: "-47.8515625",
    c4: "-29.296875",
  },
  {
    "": "1225",
    time: "1637709653.6840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-25.87890625",
    c3: "-37.109375",
    c4: "-72.75390625",
  },
  {
    "": "1226",
    time: "1637709653.6879375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-34.66796875",
    c3: "-29.78515625",
    c4: "-72.265625",
  },
  {
    "": "1227",
    time: "1637709653.6918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-53.22265625",
    c3: "-45.41015625",
    c4: "-9.765625",
  },
  {
    "": "1228",
    time: "1637709653.69575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-73.73046875",
    c3: "-46.38671875",
    c4: "-5.37109375",
  },
  {
    "": "1229",
    time: "1637709653.6996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-63.4765625",
    c3: "-42.96875",
    c4: "-66.89453125",
  },
  {
    "": "1230",
    time: "1637709653.7035625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-20.5078125",
    c3: "-28.80859375",
    c4: "-57.12890625",
  },
  {
    "": "1231",
    time: "1637709653.7074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-13.18359375",
    c3: "-15.625",
    c4: "9.765625",
  },
  {
    "": "1232",
    time: "1637709653.711375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-29.296875",
    c3: "-33.69140625",
    c4: "24.90234375",
  },
  {
    "": "1233",
    time: "1637709653.7152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-36.62109375",
    c3: "-15.13671875",
    c4: "-35.15625",
  },
  {
    "": "1234",
    time: "1637709653.7191875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-24.90234375",
    c3: "-11.71875",
    c4: "-63.4765625",
  },
  {
    "": "1235",
    time: "1637709653.7230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-9.27734375",
    c3: "-5.37109375",
    c4: "-19.53125",
  },
  {
    "": "1236",
    time: "1637709653.725125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-13.18359375",
    c3: "17.08984375",
    c4: "28.3203125",
  },
  {
    "": "1237",
    time: "1637709653.7290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-7.32421875",
    c3: "-7.8125",
    c4: "6.8359375",
  },
  {
    "": "1238",
    time: "1637709653.7329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-7.32421875",
    c3: "-35.15625",
    c4: "-56.15234375",
  },
  {
    "": "1239",
    time: "1637709653.7368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-31.25",
    c3: "-36.1328125",
    c4: "-44.921875",
  },
  {
    "": "1240",
    time: "1637709653.74075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-34.1796875",
    c3: "0.9765625",
    c4: "13.671875",
  },
  {
    "": "1241",
    time: "1637709653.7446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-40.52734375",
    c3: "0.0",
    c4: "-6.34765625",
  },
  {
    "": "1242",
    time: "1637709653.7485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-47.36328125",
    c3: "-63.96484375",
    c4: "-57.12890625",
  },
  {
    "": "1243",
    time: "1637709653.7524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-30.2734375",
    c3: "-84.47265625",
    c4: "-30.76171875",
  },
  {
    "": "1244",
    time: "1637709653.756375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-30.2734375",
    c3: "-39.0625",
    c4: "-5.37109375",
  },
  {
    "": "1245",
    time: "1637709653.7602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-25.87890625",
    c3: "6.34765625",
    c4: "-22.94921875",
  },
  {
    "": "1246",
    time: "1637709653.7641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-16.6015625",
    c3: "-1.46484375",
    c4: "-44.921875",
  },
  {
    "": "1247",
    time: "1637709653.7680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-46.38671875",
    c3: "-12.20703125",
    c4: "-58.10546875",
  },
  {
    "": "1248",
    time: "1637709653.768125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-58.10546875",
    c3: "-21.484375",
    c4: "-22.94921875",
  },
  {
    "": "1249",
    time: "1637709653.7720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-26.85546875",
    c3: "-22.94921875",
    c4: "2.9296875",
  },
  {
    "": "1250",
    time: "1637709653.7759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-41.015625",
    c3: "-29.78515625",
    c4: "-36.1328125",
  },
  {
    "": "1251",
    time: "1637709653.7798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-44.43359375",
    c3: "-49.8046875",
    c4: "-62.01171875",
  },
  {
    "": "1252",
    time: "1637709653.78375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-27.83203125",
    c3: "-52.734375",
    c4: "-32.71484375",
  },
  {
    "": "1253",
    time: "1637709653.7876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-19.04296875",
    c3: "-49.31640625",
    c4: "14.16015625",
  },
  {
    "": "1254",
    time: "1637709653.7915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-44.921875",
    c3: "-56.15234375",
    c4: "1.46484375",
  },
  {
    "": "1255",
    time: "1637709653.7954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-58.10546875",
    c3: "-74.70703125",
    c4: "-47.8515625",
  },
  {
    "": "1256",
    time: "1637709653.799375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-34.1796875",
    c3: "-62.98828125",
    c4: "-53.7109375",
  },
  {
    "": "1257",
    time: "1637709653.8032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-38.57421875",
    c3: "-25.390625",
    c4: "-18.5546875",
  },
  {
    "": "1258",
    time: "1637709653.8071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-63.96484375",
    c3: "-8.7890625",
    c4: "-23.92578125",
  },
  {
    "": "1259",
    time: "1637709653.8110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-58.10546875",
    c3: "-28.3203125",
    c4: "-64.453125",
  },
  {
    "": "1260",
    time: "1637709653.815125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-41.50390625",
    c3: "-38.57421875",
    c4: "-61.03515625",
  },
  {
    "": "1261",
    time: "1637709653.8190312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-41.9921875",
    c3: "-22.4609375",
    c4: "-19.04296875",
  },
  {
    "": "1262",
    time: "1637709653.8229375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-47.8515625",
    c3: "-9.765625",
    c4: "-17.578125",
  },
  {
    "": "1263",
    time: "1637709653.8268437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-49.31640625",
    c3: "-9.27734375",
    c4: "-50.29296875",
  },
  {
    "": "1264",
    time: "1637709653.83075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-46.38671875",
    c3: "-24.90234375",
    c4: "-71.77734375",
  },
  {
    "": "1265",
    time: "1637709653.8346562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-34.1796875",
    c3: "-21.484375",
    c4: "-33.69140625",
  },
  {
    "": "1266",
    time: "1637709653.8385625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-33.203125",
    c3: "-38.57421875",
    c4: "6.8359375",
  },
  {
    "": "1267",
    time: "1637709653.8424687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-19.53125",
    c3: "-37.59765625",
    c4: "-30.76171875",
  },
  {
    "": "1268",
    time: "1637709653.846375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-3.41796875",
    c3: "-1.46484375",
    c4: "-56.640625",
  },
  {
    "": "1269",
    time: "1637709653.8502812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-19.04296875",
    c3: "-20.01953125",
    c4: "-32.2265625",
  },
  {
    "": "1270",
    time: "1637709653.8541875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-26.3671875",
    c3: "-36.1328125",
    c4: "-0.48828125",
  },
  {
    "": "1271",
    time: "1637709653.8580937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-48.828125",
    c3: "-7.32421875",
    c4: "-27.34375",
  },
  {
    "": "1272",
    time: "1637709653.858125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-69.82421875",
    c3: "-23.4375",
    c4: "-68.359375",
  },
  {
    "": "1273",
    time: "1637709653.8620312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-62.5",
    c3: "-54.19921875",
    c4: "-55.17578125",
  },
  {
    "": "1274",
    time: "1637709653.8659375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-66.40625",
    c3: "-34.1796875",
    c4: "-9.765625",
  },
  {
    "": "1275",
    time: "1637709653.8698437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-83.984375",
    c3: "-18.5546875",
    c4: "-20.5078125",
  },
  {
    "": "1276",
    time: "1637709653.87375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-52.734375",
    c3: "-10.25390625",
    c4: "-72.75390625",
  },
  {
    "": "1277",
    time: "1637709653.8776562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-19.04296875",
    c3: "-48.33984375",
    c4: "-59.5703125",
  },
  {
    "": "1278",
    time: "1637709653.8815625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-30.2734375",
    c3: "-73.2421875",
    c4: "12.20703125",
  },
  {
    "": "1279",
    time: "1637709653.8854687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-27.83203125",
    c3: "-11.71875",
    c4: "12.6953125",
  },
  {
    "": "1280",
    time: "1637709653.889375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-38.0859375",
    c3: "23.92578125",
    c4: "-58.59375",
  },
  {
    "": "1281",
    time: "1637709653.8932812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-53.22265625",
    c3: "-1.46484375",
    c4: "-63.96484375",
  },
  {
    "": "1282",
    time: "1637709653.8971875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-29.296875",
    c3: "-21.97265625",
    c4: "-10.7421875",
  },
  {
    "": "1283",
    time: "1637709653.9010937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-4.8828125",
    c3: "7.32421875",
    c4: "4.39453125",
  },
  {
    "": "1284",
    time: "1637709653.919125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-14.6484375",
    c3: "0.9765625",
    c4: "-34.66796875",
  },
  {
    "": "1285",
    time: "1637709653.9230313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-22.94921875",
    c3: "-30.76171875",
    c4: "-73.2421875",
  },
  {
    "": "1286",
    time: "1637709653.9269376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-38.57421875",
    c3: "4.8828125",
    c4: "-39.0625",
  },
  {
    "": "1287",
    time: "1637709653.9308438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-57.6171875",
    c3: "15.625",
    c4: "4.8828125",
  },
  {
    "": "1288",
    time: "1637709653.93475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-26.3671875",
    c3: "4.39453125",
    c4: "-12.20703125",
  },
  {
    "": "1289",
    time: "1637709653.9386563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "3.90625",
    c3: "5.37109375",
    c4: "-50.78125",
  },
  {
    "": "1290",
    time: "1637709653.9425626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-16.6015625",
    c3: "-4.39453125",
    c4: "-58.10546875",
  },
  {
    "": "1291",
    time: "1637709653.9464688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-39.0625",
    c3: "-16.11328125",
    c4: "-10.7421875",
  },
  {
    "": "1292",
    time: "1637709653.950375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-33.203125",
    c3: "-0.48828125",
    c4: "-1.953125",
  },
  {
    "": "1293",
    time: "1637709653.9542813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-26.85546875",
    c3: "9.27734375",
    c4: "-51.7578125",
  },
  {
    "": "1294",
    time: "1637709653.9581876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-44.43359375",
    c3: "19.53125",
    c4: "-61.5234375",
  },
  {
    "": "1295",
    time: "1637709653.9620938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-100.09765625",
    c3: "33.203125",
    c4: "-12.6953125",
  },
  {
    "": "1296",
    time: "1637709653.964125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-64.94140625",
    c3: "20.5078125",
    c4: "0.0",
  },
  {
    "": "1297",
    time: "1637709653.9680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-15.625",
    c3: "6.34765625",
    c4: "-49.31640625",
  },
  {
    "": "1298",
    time: "1637709653.9719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-32.71484375",
    c3: "-10.25390625",
    c4: "-58.10546875",
  },
  {
    "": "1299",
    time: "1637709653.9758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-20.01953125",
    c3: "-48.33984375",
    c4: "-8.30078125",
  },
  {
    "": "1300",
    time: "1637709653.97975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-26.3671875",
    c3: "-16.11328125",
    c4: "40.0390625",
  },
  {
    "": "1301",
    time: "1637709653.9836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-80.078125",
    c3: "33.203125",
    c4: "1.46484375",
  },
  {
    "": "1302",
    time: "1637709653.9875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-62.98828125",
    c3: "41.015625",
    c4: "-73.2421875",
  },
  {
    "": "1303",
    time: "1637709653.9914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "5.37109375",
    c3: "49.8046875",
    c4: "-50.78125",
  },
  {
    "": "1304",
    time: "1637709653.995375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "0.48828125",
    c3: "21.97265625",
    c4: "-3.90625",
  },
  {
    "": "1305",
    time: "1637709653.9992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-18.06640625",
    c3: "15.13671875",
    c4: "-28.3203125",
  },
  {
    "": "1306",
    time: "1637709654.0031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-13.671875",
    c3: "34.66796875",
    c4: "-87.40234375",
  },
  {
    "": "1307",
    time: "1637709654.0070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-75.1953125",
    c2: "-24.4140625",
    c3: "17.08984375",
    c4: "-75.1953125",
  },
  {
    "": "1308",
    time: "1637709654.009125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-35.64453125",
    c3: "14.16015625",
    c4: "-10.25390625",
  },
  {
    "": "1309",
    time: "1637709654.0130312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-38.57421875",
    c3: "12.20703125",
    c4: "8.30078125",
  },
  {
    "": "1310",
    time: "1637709654.0169375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-34.66796875",
    c3: "16.6015625",
    c4: "-50.29296875",
  },
  {
    "": "1311",
    time: "1637709654.0208437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-23.4375",
    c3: "39.0625",
    c4: "-87.40234375",
  },
  {
    "": "1312",
    time: "1637709654.02475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-20.5078125",
    c3: "38.57421875",
    c4: "-29.78515625",
  },
  {
    "": "1313",
    time: "1637709654.0286562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-30.2734375",
    c3: "28.80859375",
    c4: "-5.37109375",
  },
  {
    "": "1314",
    time: "1637709654.0325625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-32.2265625",
    c3: "16.11328125",
    c4: "-50.78125",
  },
  {
    "": "1315",
    time: "1637709654.0364687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-17.578125",
    c3: "2.9296875",
    c4: "-70.3125",
  },
  {
    "": "1316",
    time: "1637709654.040375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-15.13671875",
    c3: "-30.2734375",
    c4: "-35.15625",
  },
  {
    "": "1317",
    time: "1637709654.0442812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-27.83203125",
    c3: "-37.59765625",
    c4: "14.6484375",
  },
  {
    "": "1318",
    time: "1637709654.0481875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-49.31640625",
    c3: "5.37109375",
    c4: "-20.5078125",
  },
  {
    "": "1319",
    time: "1637709654.0520937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-56.15234375",
    c3: "4.39453125",
    c4: "-67.87109375",
  },
  {
    "": "1320",
    time: "1637709654.053125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-50.29296875",
    c3: "3.41796875",
    c4: "-54.19921875",
  },
  {
    "": "1321",
    time: "1637709654.0570312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-48.33984375",
    c3: "50.29296875",
    c4: "-10.25390625",
  },
  {
    "": "1322",
    time: "1637709654.0609374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-45.41015625",
    c3: "54.6875",
    c4: "-22.94921875",
  },
  {
    "": "1323",
    time: "1637709654.0648437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-50.29296875",
    c3: "-0.9765625",
    c4: "-69.3359375",
  },
  {
    "": "1324",
    time: "1637709654.06875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-31.73828125",
    c3: "-15.13671875",
    c4: "-65.4296875",
  },
  {
    "": "1325",
    time: "1637709654.0726562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-26.3671875",
    c3: "25.390625",
    c4: "-21.484375",
  },
  {
    "": "1326",
    time: "1637709654.0765624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-22.4609375",
    c3: "23.92578125",
    c4: "5.859375",
  },
  {
    "": "1327",
    time: "1637709654.0804687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-20.5078125",
    c3: "-11.23046875",
    c4: "-24.90234375",
  },
  {
    "": "1328",
    time: "1637709654.084375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.73046875",
    c2: "-31.73828125",
    c3: "-23.4375",
    c4: "-57.12890625",
  },
  {
    "": "1329",
    time: "1637709654.0882812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-33.203125",
    c3: "14.16015625",
    c4: "-31.73828125",
  },
  {
    "": "1330",
    time: "1637709654.0921874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-35.15625",
    c3: "31.73828125",
    c4: "-3.41796875",
  },
  {
    "": "1331",
    time: "1637709654.0960937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-46.875",
    c3: "13.18359375",
    c4: "-39.55078125",
  },
  {
    "": "1332",
    time: "1637709654.100125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-48.33984375",
    c3: "-13.18359375",
    c4: "-76.66015625",
  },
  {
    "": "1333",
    time: "1637709654.1040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-52.24609375",
    c3: "-6.8359375",
    c4: "-57.12890625",
  },
  {
    "": "1334",
    time: "1637709654.1079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-47.36328125",
    c3: "-10.7421875",
    c4: "-9.27734375",
  },
  {
    "": "1335",
    time: "1637709654.1118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-34.66796875",
    c3: "-10.7421875",
    c4: "-17.08984375",
  },
  {
    "": "1336",
    time: "1637709654.11575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-30.2734375",
    c3: "21.97265625",
    c4: "-62.98828125",
  },
  {
    "": "1337",
    time: "1637709654.1196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-19.04296875",
    c3: "10.25390625",
    c4: "-49.8046875",
  },
  {
    "": "1338",
    time: "1637709654.1235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-15.13671875",
    c3: "-9.765625",
    c4: "-4.39453125",
  },
  {
    "": "1339",
    time: "1637709654.1274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-20.5078125",
    c3: "-2.44140625",
    c4: "8.7890625",
  },
  {
    "": "1340",
    time: "1637709654.131375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-29.78515625",
    c3: "19.04296875",
    c4: "-30.76171875",
  },
  {
    "": "1341",
    time: "1637709654.1352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-35.15625",
    c3: "8.7890625",
    c4: "-60.546875",
  },
  {
    "": "1342",
    time: "1637709654.1391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-32.71484375",
    c3: "-24.4140625",
    c4: "-11.71875",
  },
  {
    "": "1343",
    time: "1637709654.1430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-28.3203125",
    c3: "-4.39453125",
    c4: "19.53125",
  },
  {
    "": "1344",
    time: "1637709654.145125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-31.73828125",
    c3: "7.32421875",
    c4: "-25.87890625",
  },
  {
    "": "1345",
    time: "1637709654.1490312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-19.53125",
    c3: "6.8359375",
    c4: "-63.4765625",
  },
  {
    "": "1346",
    time: "1637709654.1529374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "1.46484375",
    c3: "6.34765625",
    c4: "-15.13671875",
  },
  {
    "": "1347",
    time: "1637709654.1568437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-10.25390625",
    c3: "-8.7890625",
    c4: "34.66796875",
  },
  {
    "": "1348",
    time: "1637709654.16075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-44.921875",
    c3: "-8.7890625",
    c4: "-12.6953125",
  },
  {
    "": "1349",
    time: "1637709654.1646562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-53.7109375",
    c3: "-18.06640625",
    c4: "-72.265625",
  },
  {
    "": "1350",
    time: "1637709654.1685624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-24.90234375",
    c3: "-33.203125",
    c4: "-47.36328125",
  },
  {
    "": "1351",
    time: "1637709654.1724687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-32.71484375",
    c3: "-66.40625",
    c4: "13.671875",
  },
  {
    "": "1352",
    time: "1637709654.176375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-32.71484375",
    c3: "-39.55078125",
    c4: "-2.9296875",
  },
  {
    "": "1353",
    time: "1637709654.1802812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-48.33984375",
    c3: "-2.44140625",
    c4: "-56.640625",
  },
  {
    "": "1354",
    time: "1637709654.1841874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-59.5703125",
    c3: "-17.08984375",
    c4: "-56.15234375",
  },
  {
    "": "1355",
    time: "1637709654.1880937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-26.85546875",
    c3: "-1.46484375",
    c4: "-17.578125",
  },
  {
    "": "1356",
    time: "1637709654.190125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-9.27734375",
    c3: "26.85546875",
    c4: "0.48828125",
  },
  {
    "": "1357",
    time: "1637709654.1940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-16.11328125",
    c3: "-0.9765625",
    c4: "-39.0625",
  },
  {
    "": "1358",
    time: "1637709654.1979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-32.71484375",
    c3: "-11.71875",
    c4: "-57.6171875",
  },
  {
    "": "1359",
    time: "1637709654.2018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-35.15625",
    c3: "-3.41796875",
    c4: "-14.16015625",
  },
  {
    "": "1360",
    time: "1637709654.20575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.30078125",
    c2: "-20.5078125",
    c3: "-9.27734375",
    c4: "0.9765625",
  },
  {
    "": "1361",
    time: "1637709654.2096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-24.90234375",
    c3: "-15.625",
    c4: "-51.7578125",
  },
  {
    "": "1362",
    time: "1637709654.2135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-46.38671875",
    c3: "-58.59375",
    c4: "-65.4296875",
  },
  {
    "": "1363",
    time: "1637709654.2174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-47.36328125",
    c3: "-47.36328125",
    c4: "-22.4609375",
  },
  {
    "": "1364",
    time: "1637709654.221375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-40.52734375",
    c3: "0.0",
    c4: "-10.25390625",
  },
  {
    "": "1365",
    time: "1637709654.2252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-28.80859375",
    c3: "-24.90234375",
    c4: "-33.203125",
  },
  {
    "": "1366",
    time: "1637709654.2291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-13.671875",
    c3: "-32.2265625",
    c4: "-62.5",
  },
  {
    "": "1367",
    time: "1637709654.2330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-4.8828125",
    c3: "-14.6484375",
    c4: "-62.98828125",
  },
  {
    "": "1368",
    time: "1637709654.233125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-8.30078125",
    c3: "-20.5078125",
    c4: "-28.80859375",
  },
  {
    "": "1369",
    time: "1637709654.2370312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-33.69140625",
    c3: "-17.08984375",
    c4: "-26.3671875",
  },
  {
    "": "1370",
    time: "1637709654.2409375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-48.828125",
    c3: "-2.9296875",
    c4: "-68.359375",
  },
  {
    "": "1371",
    time: "1637709654.2448437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-45.8984375",
    c3: "-55.17578125",
    c4: "-78.61328125",
  },
  {
    "": "1372",
    time: "1637709654.24875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-32.71484375",
    c3: "-61.5234375",
    c4: "-32.71484375",
  },
  {
    "": "1373",
    time: "1637709654.2526562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "23.4375",
    c2: "-36.1328125",
    c3: "-17.578125",
    c4: "2.9296875",
  },
  {
    "": "1374",
    time: "1637709654.2565625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-40.52734375",
    c3: "-38.0859375",
    c4: "-43.45703125",
  },
  {
    "": "1375",
    time: "1637709654.2604687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-34.1796875",
    c3: "-11.23046875",
    c4: "-100.09765625",
  },
  {
    "": "1376",
    time: "1637709654.264375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-34.1796875",
    c3: "5.37109375",
    c4: "-54.19921875",
  },
  {
    "": "1377",
    time: "1637709654.2682812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "27.83203125",
    c2: "-17.578125",
    c3: "-36.62109375",
    c4: "2.44140625",
  },
  {
    "": "1378",
    time: "1637709654.2721875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-36.1328125",
    c3: "-42.96875",
    c4: "-47.36328125",
  },
  {
    "": "1379",
    time: "1637709654.2760937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-72.75390625",
    c3: "-15.13671875",
    c4: "-81.0546875",
  },
  {
    "": "1380",
    time: "1637709654.280125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-41.50390625",
    c3: "-11.71875",
    c4: "-31.73828125",
  },
  {
    "": "1381",
    time: "1637709654.2840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-0.9765625",
    c3: "-24.4140625",
    c4: "20.5078125",
  },
  {
    "": "1382",
    time: "1637709654.2879374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "15.13671875",
    c3: "-19.53125",
    c4: "1.953125",
  },
  {
    "": "1383",
    time: "1637709654.2918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-7.8125",
    c3: "-10.7421875",
    c4: "-59.08203125",
  },
  {
    "": "1384",
    time: "1637709654.29575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-14.16015625",
    c3: "-1.46484375",
    c4: "-40.52734375",
  },
  {
    "": "1385",
    time: "1637709654.2996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "18.06640625",
    c2: "-0.48828125",
    c3: "-17.578125",
    c4: "24.90234375",
  },
  {
    "": "1386",
    time: "1637709654.3035624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "8.7890625",
    c2: "-20.5078125",
    c3: "-33.203125",
    c4: "25.390625",
  },
  {
    "": "1387",
    time: "1637709654.3074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-25.390625",
    c3: "-35.15625",
    c4: "-30.2734375",
  },
  {
    "": "1388",
    time: "1637709654.311375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-20.01953125",
    c3: "-54.6875",
    c4: "-58.59375",
  },
  {
    "": "1389",
    time: "1637709654.3152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-27.34375",
    c3: "-46.875",
    c4: "-19.04296875",
  },
  {
    "": "1390",
    time: "1637709654.3191874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-34.1796875",
    c3: "-13.18359375",
    c4: "-1.46484375",
  },
  {
    "": "1391",
    time: "1637709654.3230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-30.76171875",
    c3: "-26.3671875",
    c4: "-50.29296875",
  },
  {
    "": "1392",
    time: "1637709654.339125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-42.96875",
    c3: "-50.78125",
    c4: "-66.89453125",
  },
  {
    "": "1393",
    time: "1637709654.3430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-47.36328125",
    c3: "-21.484375",
    c4: "-10.7421875",
  },
  {
    "": "1394",
    time: "1637709654.3469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "21.97265625",
    c2: "-20.01953125",
    c3: "4.8828125",
    c4: "9.765625",
  },
  {
    "": "1395",
    time: "1637709654.3508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-19.04296875",
    c3: "-25.390625",
    c4: "-40.0390625",
  },
  {
    "": "1396",
    time: "1637709654.35475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-40.52734375",
    c3: "-83.984375",
    c4: "-53.22265625",
  },
  {
    "": "1397",
    time: "1637709654.3586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-25.87890625",
    c3: "-62.5",
    c4: "-24.4140625",
  },
  {
    "": "1398",
    time: "1637709654.3625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-24.4140625",
    c3: "1.953125",
    c4: "14.6484375",
  },
  {
    "": "1399",
    time: "1637709654.3664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-59.08203125",
    c3: "1.46484375",
    c4: "-6.34765625",
  },
  {
    "": "1400",
    time: "1637709654.370375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-55.6640625",
    c3: "-49.8046875",
    c4: "-60.05859375",
  },
  {
    "": "1401",
    time: "1637709654.3742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-22.4609375",
    c3: "-41.50390625",
    c4: "-50.29296875",
  },
  {
    "": "1402",
    time: "1637709654.3781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-7.32421875",
    c3: "11.71875",
    c4: "-5.37109375",
  },
  {
    "": "1403",
    time: "1637709654.3820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-0.48828125",
    c3: "7.32421875",
    c4: "4.8828125",
  },
  {
    "": "1404",
    time: "1637709654.385125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-9.27734375",
    c3: "-33.69140625",
    c4: "-36.62109375",
  },
  {
    "": "1405",
    time: "1637709654.3890312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-21.484375",
    c3: "-78.61328125",
    c4: "-38.0859375",
  },
  {
    "": "1406",
    time: "1637709654.3929374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-13.671875",
    c3: "-45.8984375",
    c4: "-2.44140625",
  },
  {
    "": "1407",
    time: "1637709654.3968437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-23.4375",
    c3: "5.859375",
    c4: "-8.7890625",
  },
  {
    "": "1408",
    time: "1637709654.40075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-36.62109375",
    c3: "-8.7890625",
    c4: "-46.875",
  },
  {
    "": "1409",
    time: "1637709654.4046562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-25.87890625",
    c3: "-30.76171875",
    c4: "-73.73046875",
  },
  {
    "": "1410",
    time: "1637709654.4085624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-41.50390625",
    c3: "-29.78515625",
    c4: "-46.38671875",
  },
  {
    "": "1411",
    time: "1637709654.4124687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-44.921875",
    c3: "0.9765625",
    c4: "-3.90625",
  },
  {
    "": "1412",
    time: "1637709654.416375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-33.203125",
    c3: "-24.90234375",
    c4: "0.9765625",
  },
  {
    "": "1413",
    time: "1637709654.4202812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-42.96875",
    c3: "-60.546875",
    c4: "-53.7109375",
  },
  {
    "": "1414",
    time: "1637709654.4241874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-16.11328125",
    c3: "-24.90234375",
    c4: "-64.94140625",
  },
  {
    "": "1415",
    time: "1637709654.4280937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-7.8125",
    c3: "-6.34765625",
    c4: "-2.44140625",
  },
  {
    "": "1416",
    time: "1637709654.428125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-18.06640625",
    c3: "-2.9296875",
    c4: "-3.41796875",
  },
  {
    "": "1417",
    time: "1637709654.4320312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-16.6015625",
    c3: "-12.6953125",
    c4: "-56.15234375",
  },
  {
    "": "1418",
    time: "1637709654.4359374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-32.71484375",
    c3: "-25.87890625",
    c4: "-72.75390625",
  },
  {
    "": "1419",
    time: "1637709654.4398437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-34.66796875",
    c3: "-35.15625",
    c4: "-6.34765625",
  },
  {
    "": "1420",
    time: "1637709654.44375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-30.76171875",
    c3: "-45.8984375",
    c4: "7.8125",
  },
  {
    "": "1421",
    time: "1637709654.4476562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-29.296875",
    c3: "-33.69140625",
    c4: "-50.29296875",
  },
  {
    "": "1422",
    time: "1637709654.4515624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-39.0625",
    c3: "-36.62109375",
    c4: "-56.15234375",
  },
  {
    "": "1423",
    time: "1637709654.4554687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-49.31640625",
    c3: "-72.75390625",
    c4: "-8.7890625",
  },
  {
    "": "1424",
    time: "1637709654.459375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-39.0625",
    c3: "-65.4296875",
    c4: "17.578125",
  },
  {
    "": "1425",
    time: "1637709654.4632812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-30.76171875",
    c3: "-4.39453125",
    c4: "-36.1328125",
  },
  {
    "": "1426",
    time: "1637709654.4671874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-2.9296875",
    c3: "-2.9296875",
    c4: "-84.47265625",
  },
  {
    "": "1427",
    time: "1637709654.4710937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-22.4609375",
    c3: "-13.671875",
    c4: "-57.12890625",
  },
  {
    "": "1428",
    time: "1637709654.475125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-57.12890625",
    c3: "8.7890625",
    c4: "-10.25390625",
  },
  {
    "": "1429",
    time: "1637709654.4790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-40.52734375",
    c3: "4.39453125",
    c4: "-26.3671875",
  },
  {
    "": "1430",
    time: "1637709654.4829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-27.83203125",
    c3: "-22.94921875",
    c4: "-62.5",
  },
  {
    "": "1431",
    time: "1637709654.4868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-21.97265625",
    c3: "-31.73828125",
    c4: "-48.33984375",
  },
  {
    "": "1432",
    time: "1637709654.49075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-32.71484375",
    c3: "-36.62109375",
    c4: "0.48828125",
  },
  {
    "": "1433",
    time: "1637709654.4946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-43.9453125",
    c3: "-73.2421875",
    c4: "-11.71875",
  },
  {
    "": "1434",
    time: "1637709654.4985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-42.48046875",
    c3: "-34.1796875",
    c4: "-62.5",
  },
  {
    "": "1435",
    time: "1637709654.5024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-34.66796875",
    c3: "-43.9453125",
    c4: "-59.08203125",
  },
  {
    "": "1436",
    time: "1637709654.506375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-31.25",
    c3: "-39.0625",
    c4: "-17.08984375",
  },
  {
    "": "1437",
    time: "1637709654.5102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-37.59765625",
    c3: "13.671875",
    c4: "-10.7421875",
  },
  {
    "": "1438",
    time: "1637709654.5141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-42.96875",
    c3: "-19.53125",
    c4: "-62.5",
  },
  {
    "": "1439",
    time: "1637709654.5180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-30.2734375",
    c3: "-21.97265625",
    c4: "-92.28515625",
  },
  {
    "": "1440",
    time: "1637709654.518125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-19.04296875",
    c3: "-39.55078125",
    c4: "-41.50390625",
  },
  {
    "": "1441",
    time: "1637709654.5220313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-11.23046875",
    c3: "-49.8046875",
    c4: "1.46484375",
  },
  {
    "": "1442",
    time: "1637709654.5259376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-12.20703125",
    c3: "-21.97265625",
    c4: "-29.78515625",
  },
  {
    "": "1443",
    time: "1637709654.5298438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-33.69140625",
    c3: "-26.3671875",
    c4: "-64.94140625",
  },
  {
    "": "1444",
    time: "1637709654.53375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-36.1328125",
    c3: "-20.5078125",
    c4: "-39.55078125",
  },
  {
    "": "1445",
    time: "1637709654.5376563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-25.390625",
    c3: "-7.8125",
    c4: "10.25390625",
  },
  {
    "": "1446",
    time: "1637709654.5415626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-46.38671875",
    c3: "-32.71484375",
    c4: "-18.06640625",
  },
  {
    "": "1447",
    time: "1637709654.5454688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-82.51953125",
    c3: "-79.1015625",
    c4: "-62.5",
  },
  {
    "": "1448",
    time: "1637709654.549375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-66.89453125",
    c3: "-41.015625",
    c4: "-46.38671875",
  },
  {
    "": "1449",
    time: "1637709654.5532813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-20.99609375",
    c3: "-10.7421875",
    c4: "-1.46484375",
  },
  {
    "": "1450",
    time: "1637709654.5571876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-27.83203125",
    c3: "-34.66796875",
    c4: "-4.39453125",
  },
  {
    "": "1451",
    time: "1637709654.5610938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-44.43359375",
    c3: "-30.76171875",
    c4: "-53.7109375",
  },
  {
    "": "1452",
    time: "1637709654.565125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-45.41015625",
    c3: "-7.32421875",
    c4: "-56.640625",
  },
  {
    "": "1453",
    time: "1637709654.5690312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-49.8046875",
    c3: "5.859375",
    c4: "3.90625",
  },
  {
    "": "1454",
    time: "1637709654.5729375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-37.109375",
    c3: "-7.8125",
    c4: "26.3671875",
  },
  {
    "": "1455",
    time: "1637709654.5768437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-29.78515625",
    c3: "-19.53125",
    c4: "-27.34375",
  },
  {
    "": "1456",
    time: "1637709654.58075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-25.390625",
    c3: "-20.99609375",
    c4: "-67.87109375",
  },
  {
    "": "1457",
    time: "1637709654.5846562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-22.4609375",
    c3: "-51.26953125",
    c4: "-31.25",
  },
  {
    "": "1458",
    time: "1637709654.5885625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-41.50390625",
    c3: "-72.265625",
    c4: "13.18359375",
  },
  {
    "": "1459",
    time: "1637709654.5924687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-61.5234375",
    c3: "-33.203125",
    c4: "-35.64453125",
  },
  {
    "": "1460",
    time: "1637709654.596375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-45.41015625",
    c3: "-12.6953125",
    c4: "-79.1015625",
  },
  {
    "": "1461",
    time: "1637709654.6002812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-25.87890625",
    c3: "-14.16015625",
    c4: "-47.8515625",
  },
  {
    "": "1462",
    time: "1637709654.6041875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-54.6875",
    c3: "2.9296875",
    c4: "2.44140625",
  },
  {
    "": "1463",
    time: "1637709654.6080937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-49.8046875",
    c3: "-7.8125",
    c4: "-18.06640625",
  },
  {
    "": "1464",
    time: "1637709654.610125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-19.04296875",
    c3: "-25.87890625",
    c4: "-65.91796875",
  },
  {
    "": "1465",
    time: "1637709654.6140313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-27.83203125",
    c3: "-31.73828125",
    c4: "-54.19921875",
  },
  {
    "": "1466",
    time: "1637709654.6179376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-48.33984375",
    c3: "-34.1796875",
    c4: "-11.71875",
  },
  {
    "": "1467",
    time: "1637709654.6218438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-50.78125",
    c3: "-25.390625",
    c4: "1.46484375",
  },
  {
    "": "1468",
    time: "1637709654.62575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-30.2734375",
    c3: "-11.23046875",
    c4: "-38.0859375",
  },
  {
    "": "1469",
    time: "1637709654.6296563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-33.69140625",
    c3: "-26.85546875",
    c4: "-53.22265625",
  },
  {
    "": "1470",
    time: "1637709654.6335626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-43.45703125",
    c3: "-44.43359375",
    c4: "-10.7421875",
  },
  {
    "": "1471",
    time: "1637709654.6374688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-32.71484375",
    c3: "-5.859375",
    c4: "-7.32421875",
  },
  {
    "": "1472",
    time: "1637709654.641375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-53.22265625",
    c3: "-13.18359375",
    c4: "-39.55078125",
  },
  {
    "": "1473",
    time: "1637709654.6452813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-68.84765625",
    c3: "-50.78125",
    c4: "-61.5234375",
  },
  {
    "": "1474",
    time: "1637709654.6491876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-36.1328125",
    c3: "-30.2734375",
    c4: "-45.8984375",
  },
  {
    "": "1475",
    time: "1637709654.6530938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-46.875",
    c3: "-15.13671875",
    c4: "-6.8359375",
  },
  {
    "": "1476",
    time: "1637709654.655125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-43.45703125",
    c3: "-37.109375",
    c4: "-17.578125",
  },
  {
    "": "1477",
    time: "1637709654.6590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-4.39453125",
    c3: "-39.55078125",
    c4: "-52.734375",
  },
  {
    "": "1478",
    time: "1637709654.6629374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-2.44140625",
    c3: "-14.6484375",
    c4: "-45.8984375",
  },
  {
    "": "1479",
    time: "1637709654.6668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-20.01953125",
    c3: "-5.37109375",
    c4: "9.765625",
  },
  {
    "": "1480",
    time: "1637709654.67075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-39.55078125",
    c3: "-30.2734375",
    c4: "1.953125",
  },
  {
    "": "1481",
    time: "1637709654.6746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-48.33984375",
    c3: "-81.54296875",
    c4: "-40.0390625",
  },
  {
    "": "1482",
    time: "1637709654.6785624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-29.296875",
    c3: "-56.640625",
    c4: "-45.41015625",
  },
  {
    "": "1483",
    time: "1637709654.6824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-13.671875",
    c3: "0.48828125",
    c4: "-24.90234375",
  },
  {
    "": "1484",
    time: "1637709654.686375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-15.625",
    c3: "-8.7890625",
    c4: "-24.4140625",
  },
  {
    "": "1485",
    time: "1637709654.6902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-13.671875",
    c3: "-37.59765625",
    c4: "-48.33984375",
  },
  {
    "": "1486",
    time: "1637709654.6941874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-26.3671875",
    c3: "-40.52734375",
    c4: "-51.7578125",
  },
  {
    "": "1487",
    time: "1637709654.6980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-41.50390625",
    c3: "-14.6484375",
    c4: "-18.06640625",
  },
  {
    "": "1488",
    time: "1637709654.713125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-46.38671875",
    c3: "-15.625",
    c4: "-0.48828125",
  },
  {
    "": "1489",
    time: "1637709654.7170312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-55.17578125",
    c3: "-39.0625",
    c4: "-33.69140625",
  },
  {
    "": "1490",
    time: "1637709654.7209375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-37.59765625",
    c3: "-33.69140625",
    c4: "-48.33984375",
  },
  {
    "": "1491",
    time: "1637709654.7248437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-7.8125",
    c3: "-29.78515625",
    c4: "-16.11328125",
  },
  {
    "": "1492",
    time: "1637709654.72875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-5.859375",
    c3: "-37.59765625",
    c4: "17.08984375",
  },
  {
    "": "1493",
    time: "1637709654.7326562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-15.625",
    c3: "-50.29296875",
    c4: "0.9765625",
  },
  {
    "": "1494",
    time: "1637709654.7365625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-38.0859375",
    c3: "-69.3359375",
    c4: "-41.015625",
  },
  {
    "": "1495",
    time: "1637709654.7404687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-57.12890625",
    c3: "-36.62109375",
    c4: "-44.921875",
  },
  {
    "": "1496",
    time: "1637709654.744375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-56.15234375",
    c3: "-17.08984375",
    c4: "-5.37109375",
  },
  {
    "": "1497",
    time: "1637709654.7482812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-57.12890625",
    c3: "-31.25",
    c4: "9.765625",
  },
  {
    "": "1498",
    time: "1637709654.7521875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-40.0390625",
    c3: "-2.9296875",
    c4: "-49.8046875",
  },
  {
    "": "1499",
    time: "1637709654.7560937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-21.97265625",
    c3: "-16.6015625",
    c4: "-62.5",
  },
  {
    "": "1500",
    time: "1637709654.759125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-41.9921875",
    c3: "-29.78515625",
    c4: "-19.04296875",
  },
  {
    "": "1501",
    time: "1637709654.7630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-36.1328125",
    c3: "-13.18359375",
    c4: "-9.765625",
  },
  {
    "": "1502",
    time: "1637709654.7669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-18.06640625",
    c3: "-18.5546875",
    c4: "-47.36328125",
  },
  {
    "": "1503",
    time: "1637709654.7708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-3.90625",
    c3: "-37.59765625",
    c4: "-61.5234375",
  },
  {
    "": "1504",
    time: "1637709654.77475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-31.73828125",
    c3: "-44.921875",
    c4: "-28.3203125",
  },
  {
    "": "1505",
    time: "1637709654.7786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-44.43359375",
    c3: "-45.41015625",
    c4: "0.48828125",
  },
  {
    "": "1506",
    time: "1637709654.7825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-6.8359375",
    c3: "-37.59765625",
    c4: "-32.71484375",
  },
  {
    "": "1507",
    time: "1637709654.7864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.89453125",
    c2: "0.9765625",
    c3: "-22.4609375",
    c4: "-73.73046875",
  },
  {
    "": "1508",
    time: "1637709654.790375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-26.3671875",
    c3: "-24.4140625",
    c4: "-27.34375",
  },
  {
    "": "1509",
    time: "1637709654.7942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-54.19921875",
    c3: "-9.27734375",
    c4: "9.765625",
  },
  {
    "": "1510",
    time: "1637709654.7981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-43.9453125",
    c3: "3.90625",
    c4: "-22.4609375",
  },
  {
    "": "1511",
    time: "1637709654.8020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-26.85546875",
    c3: "-42.96875",
    c4: "-45.41015625",
  },
  {
    "": "1512",
    time: "1637709654.803125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-29.78515625",
    c3: "-66.40625",
    c4: "-37.59765625",
  },
  {
    "": "1513",
    time: "1637709654.8070312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-62.5",
    c3: "-6.8359375",
    c4: "10.25390625",
  },
  {
    "": "1514",
    time: "1637709654.8109374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-48.33984375",
    c3: "20.5078125",
    c4: "23.4375",
  },
  {
    "": "1515",
    time: "1637709654.8148437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-4.8828125",
    c3: "-43.45703125",
    c4: "-19.04296875",
  },
  {
    "": "1516",
    time: "1637709654.81875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-24.90234375",
    c3: "-83.0078125",
    c4: "-38.57421875",
  },
  {
    "": "1517",
    time: "1637709654.8226562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-34.66796875",
    c3: "-43.45703125",
    c4: "-16.11328125",
  },
  {
    "": "1518",
    time: "1637709654.8265624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-23.92578125",
    c3: "-5.859375",
    c4: "-7.32421875",
  },
  {
    "": "1519",
    time: "1637709654.8304687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-24.90234375",
    c3: "-30.2734375",
    c4: "-35.64453125",
  },
  {
    "": "1520",
    time: "1637709654.834375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-25.390625",
    c3: "-50.78125",
    c4: "-44.43359375",
  },
  {
    "": "1521",
    time: "1637709654.8382812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-22.4609375",
    c3: "-0.48828125",
    c4: "-18.06640625",
  },
  {
    "": "1522",
    time: "1637709654.8421874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-27.83203125",
    c3: "0.0",
    c4: "22.94921875",
  },
  {
    "": "1523",
    time: "1637709654.8460937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-31.25",
    c3: "-29.296875",
    c4: "-6.8359375",
  },
  {
    "": "1524",
    time: "1637709654.852125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-24.4140625",
    c3: "-26.3671875",
    c4: "-49.8046875",
  },
  {
    "": "1525",
    time: "1637709654.8560312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-18.5546875",
    c3: "0.48828125",
    c4: "-25.87890625",
  },
  {
    "": "1526",
    time: "1637709654.8599374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-20.99609375",
    c3: "-27.83203125",
    c4: "10.25390625",
  },
  {
    "": "1527",
    time: "1637709654.8638437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-16.6015625",
    c3: "-74.70703125",
    c4: "-6.34765625",
  },
  {
    "": "1528",
    time: "1637709654.86775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-13.18359375",
    c3: "-39.55078125",
    c4: "-51.26953125",
  },
  {
    "": "1529",
    time: "1637709654.8716562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-3.41796875",
    c3: "-27.83203125",
    c4: "-42.96875",
  },
  {
    "": "1530",
    time: "1637709654.8755624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-6.34765625",
    c3: "-27.83203125",
    c4: "-1.46484375",
  },
  {
    "": "1531",
    time: "1637709654.8794687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-22.4609375",
    c3: "-26.85546875",
    c4: "10.25390625",
  },
  {
    "": "1532",
    time: "1637709654.883375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-33.69140625",
    c3: "-20.01953125",
    c4: "-37.59765625",
  },
  {
    "": "1533",
    time: "1637709654.8872812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-41.015625",
    c3: "-14.6484375",
    c4: "-58.59375",
  },
  {
    "": "1534",
    time: "1637709654.8911874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-44.43359375",
    c3: "-29.78515625",
    c4: "-19.04296875",
  },
  {
    "": "1535",
    time: "1637709654.8950937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-33.69140625",
    c3: "-30.76171875",
    c4: "-11.71875",
  },
  {
    "": "1536",
    time: "1637709654.893125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-6.34765625",
    c3: "-28.80859375",
    c4: "-32.2265625",
  },
  {
    "": "1537",
    time: "1637709654.8970313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-17.578125",
    c3: "-45.8984375",
    c4: "-36.62109375",
  },
  {
    "": "1538",
    time: "1637709654.9009376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-29.78515625",
    c3: "-35.15625",
    c4: "-15.625",
  },
  {
    "": "1539",
    time: "1637709654.9048438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-31.25",
    c3: "-3.90625",
    c4: "0.0",
  },
  {
    "": "1540",
    time: "1637709654.90875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-41.9921875",
    c3: "-5.859375",
    c4: "-22.4609375",
  },
  {
    "": "1541",
    time: "1637709654.9126563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-49.8046875",
    c3: "-40.52734375",
    c4: "-54.19921875",
  },
  {
    "": "1542",
    time: "1637709654.9165626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-42.96875",
    c3: "-62.98828125",
    c4: "-41.9921875",
  },
  {
    "": "1543",
    time: "1637709654.9204688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-51.7578125",
    c3: "-62.98828125",
    c4: "20.5078125",
  },
  {
    "": "1544",
    time: "1637709654.924375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-43.45703125",
    c3: "-35.15625",
    c4: "10.25390625",
  },
  {
    "": "1545",
    time: "1637709654.9282813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "3.90625",
    c3: "-13.671875",
    c4: "-50.78125",
  },
  {
    "": "1546",
    time: "1637709654.9321876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "14.16015625",
    c3: "-37.59765625",
    c4: "-54.6875",
  },
  {
    "": "1547",
    time: "1637709654.9360938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-5.37109375",
    c3: "-12.6953125",
    c4: "-2.9296875",
  },
  {
    "": "1548",
    time: "1637709654.940125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-13.671875",
    c3: "6.34765625",
    c4: "18.5546875",
  },
  {
    "": "1549",
    time: "1637709654.9440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-25.87890625",
    c3: "-25.87890625",
    c4: "-20.01953125",
  },
  {
    "": "1550",
    time: "1637709654.9479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-51.7578125",
    c3: "-57.6171875",
    c4: "-43.45703125",
  },
  {
    "": "1551",
    time: "1637709654.9518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-40.52734375",
    c3: "-30.76171875",
    c4: "0.48828125",
  },
  {
    "": "1552",
    time: "1637709654.95575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-18.5546875",
    c3: "-0.48828125",
    c4: "35.64453125",
  },
  {
    "": "1553",
    time: "1637709654.9596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-20.01953125",
    c3: "-33.203125",
    c4: "-14.16015625",
  },
  {
    "": "1554",
    time: "1637709654.9635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-29.296875",
    c3: "-78.125",
    c4: "-47.36328125",
  },
  {
    "": "1555",
    time: "1637709654.9674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-42.48046875",
    c3: "-52.24609375",
    c4: "-40.0390625",
  },
  {
    "": "1556",
    time: "1637709654.971375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-33.203125",
    c3: "-1.953125",
    c4: "-11.23046875",
  },
  {
    "": "1557",
    time: "1637709654.9752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-28.80859375",
    c3: "-2.44140625",
    c4: "3.90625",
  },
  {
    "": "1558",
    time: "1637709654.9791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-28.3203125",
    c3: "-13.18359375",
    c4: "-25.87890625",
  },
  {
    "": "1559",
    time: "1637709654.9830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-25.390625",
    c3: "0.48828125",
    c4: "-30.76171875",
  },
  {
    "": "1560",
    time: "1637709654.983125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-19.53125",
    c3: "-2.9296875",
    c4: "12.6953125",
  },
  {
    "": "1561",
    time: "1637709654.9870312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-12.6953125",
    c3: "-31.73828125",
    c4: "8.7890625",
  },
  {
    "": "1562",
    time: "1637709654.9909375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-28.3203125",
    c3: "-22.4609375",
    c4: "-36.1328125",
  },
  {
    "": "1563",
    time: "1637709654.9948437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-48.33984375",
    c3: "-32.2265625",
    c4: "-35.15625",
  },
  {
    "": "1564",
    time: "1637709654.99875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-52.734375",
    c3: "-29.78515625",
    c4: "12.6953125",
  },
  {
    "": "1565",
    time: "1637709655.0026562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-35.64453125",
    c3: "-23.92578125",
    c4: "24.90234375",
  },
  {
    "": "1566",
    time: "1637709655.0065625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-41.9921875",
    c3: "-60.05859375",
    c4: "-20.99609375",
  },
  {
    "": "1567",
    time: "1637709655.0104687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "-39.55078125",
    c3: "-25.390625",
    c4: "-67.87109375",
  },
  {
    "": "1568",
    time: "1637709655.014375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-28.3203125",
    c3: "-0.48828125",
    c4: "-34.66796875",
  },
  {
    "": "1569",
    time: "1637709655.0182812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-30.2734375",
    c3: "-34.1796875",
    c4: "5.37109375",
  },
  {
    "": "1570",
    time: "1637709655.0221875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-29.78515625",
    c3: "-22.4609375",
    c4: "-12.6953125",
  },
  {
    "": "1571",
    time: "1637709655.0260937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-32.71484375",
    c3: "-18.06640625",
    c4: "-53.22265625",
  },
  {
    "": "1572",
    time: "1637709655.030125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-26.3671875",
    c3: "-52.734375",
    c4: "-42.48046875",
  },
  {
    "": "1573",
    time: "1637709655.0340312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-31.25",
    c3: "-34.1796875",
    c4: "-2.44140625",
  },
  {
    "": "1574",
    time: "1637709655.0379374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-24.90234375",
    c3: "-7.8125",
    c4: "-30.2734375",
  },
  {
    "": "1575",
    time: "1637709655.0418437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-27.83203125",
    c3: "-2.44140625",
    c4: "-76.171875",
  },
  {
    "": "1576",
    time: "1637709655.04575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-29.296875",
    c3: "-11.71875",
    c4: "-54.19921875",
  },
  {
    "": "1577",
    time: "1637709655.0496562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-33.203125",
    c3: "-23.92578125",
    c4: "4.39453125",
  },
  {
    "": "1578",
    time: "1637709655.0535624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-48.828125",
    c3: "-32.71484375",
    c4: "6.8359375",
  },
  {
    "": "1579",
    time: "1637709655.0574687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-50.29296875",
    c3: "-20.01953125",
    c4: "-40.52734375",
  },
  {
    "": "1580",
    time: "1637709655.061375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-35.64453125",
    c3: "-3.41796875",
    c4: "-60.05859375",
  },
  {
    "": "1581",
    time: "1637709655.0652812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-48.33984375",
    c3: "-25.390625",
    c4: "-12.6953125",
  },
  {
    "": "1582",
    time: "1637709655.0691874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-51.26953125",
    c3: "-30.2734375",
    c4: "8.30078125",
  },
  {
    "": "1583",
    time: "1637709655.0730937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-31.73828125",
    c3: "-34.1796875",
    c4: "-35.15625",
  },
  {
    "": "1584",
    time: "1637709655.103125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-57.6171875",
    c3: "-81.54296875",
    c4: "-57.12890625",
  },
  {
    "": "1585",
    time: "1637709655.1070313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-57.6171875",
    c3: "-64.94140625",
    c4: "-20.5078125",
  },
  {
    "": "1586",
    time: "1637709655.1109376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-16.11328125",
    c3: "-4.39453125",
    c4: "11.23046875",
  },
  {
    "": "1587",
    time: "1637709655.1148438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-48.828125",
    c3: "-7.8125",
    c4: "-22.4609375",
  },
  {
    "": "1588",
    time: "1637709655.11875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-45.41015625",
    c3: "-26.85546875",
    c4: "-56.640625",
  },
  {
    "": "1589",
    time: "1637709655.1226563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-3.41796875",
    c3: "-56.15234375",
    c4: "-24.90234375",
  },
  {
    "": "1590",
    time: "1637709655.1265626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-12.6953125",
    c3: "-36.62109375",
    c4: "15.625",
  },
  {
    "": "1591",
    time: "1637709655.1304688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-11.71875",
    c3: "-11.23046875",
    c4: "-4.8828125",
  },
  {
    "": "1592",
    time: "1637709655.134375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-9.27734375",
    c3: "-41.50390625",
    c4: "-48.828125",
  },
  {
    "": "1593",
    time: "1637709655.1382813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-18.06640625",
    c3: "-41.50390625",
    c4: "-53.7109375",
  },
  {
    "": "1594",
    time: "1637709655.1421876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-18.5546875",
    c3: "4.8828125",
    c4: "-18.06640625",
  },
  {
    "": "1595",
    time: "1637709655.1460938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-33.203125",
    c3: "-0.48828125",
    c4: "-7.32421875",
  },
  {
    "": "1596",
    time: "1637709655.134125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-39.0625",
    c3: "-54.19921875",
    c4: "-32.71484375",
  },
  {
    "": "1597",
    time: "1637709655.1380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-35.15625",
    c3: "-49.31640625",
    c4: "-39.55078125",
  },
  {
    "": "1598",
    time: "1637709655.1419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-40.0390625",
    c3: "-26.3671875",
    c4: "2.9296875",
  },
  {
    "": "1599",
    time: "1637709655.1458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "23.4375",
    c2: "-28.80859375",
    c3: "-27.34375",
    c4: "22.94921875",
  },
  {
    "": "1600",
    time: "1637709655.14975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-38.0859375",
    c3: "-18.5546875",
    c4: "-16.11328125",
  },
  {
    "": "1601",
    time: "1637709655.1536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-45.41015625",
    c3: "-12.6953125",
    c4: "-53.22265625",
  },
  {
    "": "1602",
    time: "1637709655.1575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-15.625",
    c3: "-10.7421875",
    c4: "-32.2265625",
  },
  {
    "": "1603",
    time: "1637709655.1614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-17.578125",
    c3: "-3.41796875",
    c4: "11.71875",
  },
  {
    "": "1604",
    time: "1637709655.165375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-37.59765625",
    c3: "-39.55078125",
    c4: "-5.859375",
  },
  {
    "": "1605",
    time: "1637709655.1692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-37.109375",
    c3: "-51.26953125",
    c4: "-63.4765625",
  },
  {
    "": "1606",
    time: "1637709655.1731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-43.45703125",
    c3: "-22.94921875",
    c4: "-59.08203125",
  },
  {
    "": "1607",
    time: "1637709655.1770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-42.96875",
    c3: "-26.3671875",
    c4: "7.8125",
  },
  {
    "": "1608",
    time: "1637709655.178125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-32.2265625",
    c3: "-22.4609375",
    c4: "13.18359375",
  },
  {
    "": "1609",
    time: "1637709655.1820312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-59.08203125",
    c3: "-13.18359375",
    c4: "-48.33984375",
  },
  {
    "": "1610",
    time: "1637709655.1859374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-62.5",
    c3: "-31.25",
    c4: "-56.640625",
  },
  {
    "": "1611",
    time: "1637709655.1898437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-62.5",
    c3: "-49.8046875",
    c4: "-0.48828125",
  },
  {
    "": "1612",
    time: "1637709655.19375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-59.5703125",
    c3: "-25.87890625",
    c4: "7.32421875",
  },
  {
    "": "1613",
    time: "1637709655.1976562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-23.4375",
    c3: "-12.20703125",
    c4: "-35.15625",
  },
  {
    "": "1614",
    time: "1637709655.2015624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-9.27734375",
    c3: "-23.4375",
    c4: "-53.22265625",
  },
  {
    "": "1615",
    time: "1637709655.2054687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-14.16015625",
    c3: "-34.66796875",
    c4: "-17.08984375",
  },
  {
    "": "1616",
    time: "1637709655.209375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-28.80859375",
    c3: "-46.875",
    c4: "14.16015625",
  },
  {
    "": "1617",
    time: "1637709655.2132812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-27.83203125",
    c3: "-19.53125",
    c4: "-30.76171875",
  },
  {
    "": "1618",
    time: "1637709655.2171874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-34.1796875",
    c3: "-19.04296875",
    c4: "-48.828125",
  },
  {
    "": "1619",
    time: "1637709655.2210937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-48.828125",
    c3: "-26.3671875",
    c4: "-33.69140625",
  },
  {
    "": "1620",
    time: "1637709655.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-36.62109375",
    c3: "-11.23046875",
    c4: "-1.953125",
  },
  {
    "": "1621",
    time: "1637709655.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-14.16015625",
    c3: "-19.04296875",
    c4: "-3.41796875",
  },
  {
    "": "1622",
    time: "1637709655.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-26.85546875",
    c3: "-20.5078125",
    c4: "-65.4296875",
  },
  {
    "": "1623",
    time: "1637709655.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-39.55078125",
    c3: "-45.8984375",
    c4: "-76.66015625",
  },
  {
    "": "1624",
    time: "1637709655.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-47.36328125",
    c3: "-69.3359375",
    c4: "-34.1796875",
  },
  {
    "": "1625",
    time: "1637709655.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-51.7578125",
    c3: "-53.7109375",
    c4: "-13.671875",
  },
  {
    "": "1626",
    time: "1637709655.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-55.6640625",
    c3: "-27.83203125",
    c4: "-42.96875",
  },
  {
    "": "1627",
    time: "1637709655.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-63.96484375",
    c3: "-34.66796875",
    c4: "-53.22265625",
  },
  {
    "": "1628",
    time: "1637709655.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-60.05859375",
    c3: "-7.32421875",
    c4: "-12.6953125",
  },
  {
    "": "1629",
    time: "1637709655.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-65.4296875",
    c3: "11.71875",
    c4: "-14.6484375",
  },
  {
    "": "1630",
    time: "1637709655.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-48.33984375",
    c3: "-22.94921875",
    c4: "-52.734375",
  },
  {
    "": "1631",
    time: "1637709655.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-25.390625",
    c3: "-17.08984375",
    c4: "-71.77734375",
  },
  {
    "": "1632",
    time: "1637709655.268125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-8.30078125",
    c3: "4.8828125",
    c4: "-36.62109375",
  },
  {
    "": "1633",
    time: "1637709655.2720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-6.8359375",
    c3: "0.48828125",
    c4: "9.27734375",
  },
  {
    "": "1634",
    time: "1637709655.2759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-17.08984375",
    c3: "-29.78515625",
    c4: "-29.296875",
  },
  {
    "": "1635",
    time: "1637709655.2798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-24.90234375",
    c3: "-41.9921875",
    c4: "-73.2421875",
  },
  {
    "": "1636",
    time: "1637709655.28375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-30.76171875",
    c3: "-28.80859375",
    c4: "-42.48046875",
  },
  {
    "": "1637",
    time: "1637709655.2876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-31.73828125",
    c3: "-24.90234375",
    c4: "-4.8828125",
  },
  {
    "": "1638",
    time: "1637709655.2915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-32.2265625",
    c3: "-51.7578125",
    c4: "-31.25",
  },
  {
    "": "1639",
    time: "1637709655.2954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-40.0390625",
    c3: "-102.05078125",
    c4: "-66.40625",
  },
  {
    "": "1640",
    time: "1637709655.299375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-49.31640625",
    c3: "-69.3359375",
    c4: "-64.453125",
  },
  {
    "": "1641",
    time: "1637709655.3032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-44.43359375",
    c3: "-10.7421875",
    c4: "-26.85546875",
  },
  {
    "": "1642",
    time: "1637709655.3071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-30.76171875",
    c3: "-1.46484375",
    c4: "-6.34765625",
  },
  {
    "": "1643",
    time: "1637709655.3110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-22.4609375",
    c3: "-7.32421875",
    c4: "-47.8515625",
  },
  {
    "": "1644",
    time: "1637709655.317125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-24.90234375",
    c3: "-45.41015625",
    c4: "-73.2421875",
  },
  {
    "": "1645",
    time: "1637709655.3210313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-14.6484375",
    c3: "-50.78125",
    c4: "-20.99609375",
  },
  {
    "": "1646",
    time: "1637709655.3249376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-5.859375",
    c3: "-29.78515625",
    c4: "7.32421875",
  },
  {
    "": "1647",
    time: "1637709655.3288438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-12.20703125",
    c3: "-13.18359375",
    c4: "-29.296875",
  },
  {
    "": "1648",
    time: "1637709655.33275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-29.296875",
    c3: "-20.5078125",
    c4: "-62.98828125",
  },
  {
    "": "1649",
    time: "1637709655.3366563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-42.48046875",
    c3: "-21.484375",
    c4: "-30.2734375",
  },
  {
    "": "1650",
    time: "1637709655.3405626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-34.1796875",
    c3: "-33.69140625",
    c4: "13.18359375",
  },
  {
    "": "1651",
    time: "1637709655.3444688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-19.04296875",
    c3: "-62.5",
    c4: "-27.34375",
  },
  {
    "": "1652",
    time: "1637709655.348375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-10.25390625",
    c3: "-44.43359375",
    c4: "-61.5234375",
  },
  {
    "": "1653",
    time: "1637709655.3522813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-19.53125",
    c3: "-32.71484375",
    c4: "-38.0859375",
  },
  {
    "": "1654",
    time: "1637709655.3561876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-28.3203125",
    c3: "-24.90234375",
    c4: "-0.9765625",
  },
  {
    "": "1655",
    time: "1637709655.3600938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-38.0859375",
    c3: "1.953125",
    c4: "-8.7890625",
  },
  {
    "": "1656",
    time: "1637709655.358125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-60.05859375",
    c3: "0.9765625",
    c4: "-41.9921875",
  },
  {
    "": "1657",
    time: "1637709655.3620312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-38.0859375",
    c3: "-31.25",
    c4: "-40.0390625",
  },
  {
    "": "1658",
    time: "1637709655.3659375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-3.41796875",
    c3: "-29.78515625",
    c4: "-3.90625",
  },
  {
    "": "1659",
    time: "1637709655.3698437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-13.671875",
    c3: "-35.64453125",
    c4: "-8.7890625",
  },
  {
    "": "1660",
    time: "1637709655.37375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-21.484375",
    c3: "-42.48046875",
    c4: "-47.36328125",
  },
  {
    "": "1661",
    time: "1637709655.3776562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-22.94921875",
    c3: "-26.85546875",
    c4: "-57.12890625",
  },
  {
    "": "1662",
    time: "1637709655.3815625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-38.57421875",
    c3: "-62.98828125",
    c4: "-14.6484375",
  },
  {
    "": "1663",
    time: "1637709655.3854687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-37.109375",
    c3: "-62.98828125",
    c4: "-7.8125",
  },
  {
    "": "1664",
    time: "1637709655.389375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-27.83203125",
    c3: "-27.34375",
    c4: "-56.640625",
  },
  {
    "": "1665",
    time: "1637709655.3932812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-35.64453125",
    c3: "-32.71484375",
    c4: "-75.1953125",
  },
  {
    "": "1666",
    time: "1637709655.3971875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-30.2734375",
    c3: "-25.87890625",
    c4: "-48.33984375",
  },
  {
    "": "1667",
    time: "1637709655.4010937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-20.5078125",
    c3: "-8.7890625",
    c4: "-3.41796875",
  },
  {
    "": "1668",
    time: "1637709655.405125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-18.06640625",
    c3: "-10.25390625",
    c4: "-29.296875",
  },
  {
    "": "1669",
    time: "1637709655.4090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-19.53125",
    c3: "-21.97265625",
    c4: "-78.61328125",
  },
  {
    "": "1670",
    time: "1637709655.4129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-39.0625",
    c3: "-20.01953125",
    c4: "-47.36328125",
  },
  {
    "": "1671",
    time: "1637709655.4168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-60.05859375",
    c3: "-11.23046875",
    c4: "-7.8125",
  },
  {
    "": "1672",
    time: "1637709655.42075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-45.8984375",
    c3: "-38.57421875",
    c4: "-26.85546875",
  },
  {
    "": "1673",
    time: "1637709655.4246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-27.83203125",
    c3: "-55.17578125",
    c4: "-75.1953125",
  },
  {
    "": "1674",
    time: "1637709655.4285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-41.9921875",
    c3: "-41.50390625",
    c4: "-89.35546875",
  },
  {
    "": "1675",
    time: "1637709655.4324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-52.24609375",
    c3: "-33.203125",
    c4: "-34.1796875",
  },
  {
    "": "1676",
    time: "1637709655.436375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-32.71484375",
    c3: "-29.78515625",
    c4: "-10.7421875",
  },
  {
    "": "1677",
    time: "1637709655.4402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-28.80859375",
    c3: "-61.5234375",
    c4: "-49.31640625",
  },
  {
    "": "1678",
    time: "1637709655.4441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.359375",
    c2: "-40.0390625",
    c3: "-53.7109375",
    c4: "-74.21875",
  },
  {
    "": "1679",
    time: "1637709655.4480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-34.66796875",
    c3: "-52.734375",
    c4: "-54.6875",
  },
  {
    "": "1680",
    time: "1637709655.464125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-36.62109375",
    c3: "-60.546875",
    c4: "-26.3671875",
  },
  {
    "": "1681",
    time: "1637709655.4680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-41.50390625",
    c3: "-23.4375",
    c4: "-46.38671875",
  },
  {
    "": "1682",
    time: "1637709655.4719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.63671875",
    c2: "-46.875",
    c3: "-28.3203125",
    c4: "-83.0078125",
  },
  {
    "": "1683",
    time: "1637709655.4758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-57.6171875",
    c3: "-36.62109375",
    c4: "-68.84765625",
  },
  {
    "": "1684",
    time: "1637709655.47975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-53.7109375",
    c3: "-44.43359375",
    c4: "-27.83203125",
  },
  {
    "": "1685",
    time: "1637709655.4836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-23.92578125",
    c3: "-57.6171875",
    c4: "-28.80859375",
  },
  {
    "": "1686",
    time: "1637709655.4875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.73046875",
    c2: "0.9765625",
    c3: "-48.33984375",
    c4: "-77.1484375",
  },
  {
    "": "1687",
    time: "1637709655.4914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-26.85546875",
    c3: "-39.0625",
    c4: "-84.9609375",
  },
  {
    "": "1688",
    time: "1637709655.495375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-64.453125",
    c3: "-46.38671875",
    c4: "-19.53125",
  },
  {
    "": "1689",
    time: "1637709655.4992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-44.921875",
    c3: "-54.19921875",
    c4: "-10.25390625",
  },
  {
    "": "1690",
    time: "1637709655.5031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-25.87890625",
    c3: "-51.26953125",
    c4: "-63.96484375",
  },
  {
    "": "1691",
    time: "1637709655.5070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-14.6484375",
    c3: "-49.8046875",
    c4: "-68.84765625",
  },
  {
    "": "1692",
    time: "1637709655.508125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-5.859375",
    c3: "-55.17578125",
    c4: "-39.0625",
  },
  {
    "": "1693",
    time: "1637709655.5120313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-9.765625",
    c3: "-63.96484375",
    c4: "-17.08984375",
  },
  {
    "": "1694",
    time: "1637709655.5159376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-22.94921875",
    c3: "-83.49609375",
    c4: "-51.7578125",
  },
  {
    "": "1695",
    time: "1637709655.5198438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-42.96875",
    c3: "-97.65625",
    c4: "-83.984375",
  },
  {
    "": "1696",
    time: "1637709655.52375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-43.9453125",
    c3: "-75.1953125",
    c4: "-26.3671875",
  },
  {
    "": "1697",
    time: "1637709655.5276563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-48.828125",
    c3: "-40.52734375",
    c4: "26.85546875",
  },
  {
    "": "1698",
    time: "1637709655.5315626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-43.9453125",
    c3: "-21.97265625",
    c4: "-13.671875",
  },
  {
    "": "1699",
    time: "1637709655.5354688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-37.109375",
    c3: "-39.55078125",
    c4: "-35.15625",
  },
  {
    "": "1700",
    time: "1637709655.539375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-28.3203125",
    c3: "-67.87109375",
    c4: "-20.5078125",
  },
  {
    "": "1701",
    time: "1637709655.5432813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.25390625",
    c2: "-8.7890625",
    c3: "-37.59765625",
    c4: "-2.44140625",
  },
  {
    "": "1702",
    time: "1637709655.5471876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-20.5078125",
    c3: "-6.8359375",
    c4: "-16.11328125",
  },
  {
    "": "1703",
    time: "1637709655.5510938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-45.8984375",
    c3: "-35.64453125",
    c4: "-53.22265625",
  },
  {
    "": "1704",
    time: "1637709655.554125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-50.29296875",
    c3: "-57.6171875",
    c4: "-48.33984375",
  },
  {
    "": "1705",
    time: "1637709655.5580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-21.484375",
    c3: "-33.203125",
    c4: "-4.39453125",
  },
  {
    "": "1706",
    time: "1637709655.5619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-14.6484375",
    c3: "-1.953125",
    c4: "-10.7421875",
  },
  {
    "": "1707",
    time: "1637709655.5658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-25.390625",
    c3: "-31.73828125",
    c4: "-52.734375",
  },
  {
    "": "1708",
    time: "1637709655.56975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-30.76171875",
    c3: "-82.03125",
    c4: "-55.6640625",
  },
  {
    "": "1709",
    time: "1637709655.5736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-42.48046875",
    c3: "-52.734375",
    c4: "-12.6953125",
  },
  {
    "": "1710",
    time: "1637709655.5775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-41.9921875",
    c3: "-23.4375",
    c4: "9.27734375",
  },
  {
    "": "1711",
    time: "1637709655.5814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-22.94921875",
    c3: "-53.22265625",
    c4: "-19.04296875",
  },
  {
    "": "1712",
    time: "1637709655.585375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-31.25",
    c3: "-57.12890625",
    c4: "-55.6640625",
  },
  {
    "": "1713",
    time: "1637709655.5892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-46.38671875",
    c3: "-13.18359375",
    c4: "-49.8046875",
  },
  {
    "": "1714",
    time: "1637709655.5931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.46484375",
    c2: "-43.45703125",
    c3: "-9.27734375",
    c4: "-2.44140625",
  },
  {
    "": "1715",
    time: "1637709655.5970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-25.87890625",
    c3: "-20.5078125",
    c4: "-21.484375",
  },
  {
    "": "1716",
    time: "1637709655.600125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-23.92578125",
    c3: "-56.640625",
    c4: "-61.5234375",
  },
  {
    "": "1717",
    time: "1637709655.6040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-27.34375",
    c3: "-62.01171875",
    c4: "-33.69140625",
  },
  {
    "": "1718",
    time: "1637709655.6079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-19.04296875",
    c3: "-14.6484375",
    c4: "2.9296875",
  },
  {
    "": "1719",
    time: "1637709655.6118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-29.296875",
    c3: "-7.8125",
    c4: "-19.53125",
  },
  {
    "": "1720",
    time: "1637709655.61575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-41.50390625",
    c3: "-18.06640625",
    c4: "-70.80078125",
  },
  {
    "": "1721",
    time: "1637709655.6196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-49.8046875",
    c3: "-37.59765625",
    c4: "-73.73046875",
  },
  {
    "": "1722",
    time: "1637709655.6235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-37.109375",
    c3: "-34.1796875",
    c4: "-17.08984375",
  },
  {
    "": "1723",
    time: "1637709655.6274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-16.11328125",
    c3: "-49.31640625",
    c4: "-4.8828125",
  },
  {
    "": "1724",
    time: "1637709655.631375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-20.5078125",
    c3: "-55.6640625",
    c4: "-60.05859375",
  },
  {
    "": "1725",
    time: "1637709655.6352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.70703125",
    c2: "-30.2734375",
    c3: "-25.87890625",
    c4: "-78.61328125",
  },
  {
    "": "1726",
    time: "1637709655.6391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-35.15625",
    c3: "-29.296875",
    c4: "-34.66796875",
  },
  {
    "": "1727",
    time: "1637709655.6430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-39.0625",
    c3: "-31.25",
    c4: "-2.44140625",
  },
  {
    "": "1728",
    time: "1637709655.643125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-42.96875",
    c3: "-28.80859375",
    c4: "-45.41015625",
  },
  {
    "": "1729",
    time: "1637709655.6470313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-63.4765625",
    c3: "-20.5078125",
    c4: "-64.94140625",
  },
  {
    "": "1730",
    time: "1637709655.6509376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-81.0546875",
    c3: "-38.57421875",
    c4: "-24.90234375",
  },
  {
    "": "1731",
    time: "1637709655.6548438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-50.29296875",
    c3: "-46.38671875",
    c4: "-5.859375",
  },
  {
    "": "1732",
    time: "1637709655.65875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-24.4140625",
    c3: "-19.53125",
    c4: "-16.6015625",
  },
  {
    "": "1733",
    time: "1637709655.6626563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-21.97265625",
    c3: "-48.828125",
    c4: "-50.29296875",
  },
  {
    "": "1734",
    time: "1637709655.6665626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-28.80859375",
    c3: "-71.77734375",
    c4: "-59.5703125",
  },
  {
    "": "1735",
    time: "1637709655.6704688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-48.33984375",
    c3: "-75.1953125",
    c4: "13.671875",
  },
  {
    "": "1736",
    time: "1637709655.674375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-45.8984375",
    c3: "-62.01171875",
    c4: "11.71875",
  },
  {
    "": "1737",
    time: "1637709655.6782813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-22.4609375",
    c3: "-12.20703125",
    c4: "-46.38671875",
  },
  {
    "": "1738",
    time: "1637709655.6821876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-21.97265625",
    c3: "-17.08984375",
    c4: "-52.734375",
  },
  {
    "": "1739",
    time: "1637709655.6860938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-32.71484375",
    c3: "-40.0390625",
    c4: "-29.78515625",
  },
  {
    "": "1740",
    time: "1637709655.690125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-35.64453125",
    c3: "-55.6640625",
    c4: "-3.41796875",
  },
  {
    "": "1741",
    time: "1637709655.6940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-33.69140625",
    c3: "-86.9140625",
    c4: "-41.015625",
  },
  {
    "": "1742",
    time: "1637709655.6979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-15.625",
    c3: "-133.7890625",
    c4: "-65.91796875",
  },
  {
    "": "1743",
    time: "1637709655.7018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-28.80859375",
    c3: "-125.9765625",
    c4: "-34.1796875",
  },
  {
    "": "1744",
    time: "1637709655.70575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-52.24609375",
    c3: "-109.375",
    c4: "-0.48828125",
  },
  {
    "": "1745",
    time: "1637709655.7096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-40.0390625",
    c3: "-160.15625",
    c4: "-12.20703125",
  },
  {
    "": "1746",
    time: "1637709655.7135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-51.26953125",
    c3: "-206.54296875",
    c4: "-35.64453125",
  },
  {
    "": "1747",
    time: "1637709655.7174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-59.5703125",
    c3: "-179.6875",
    c4: "-35.64453125",
  },
  {
    "": "1748",
    time: "1637709655.721375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-41.9921875",
    c3: "-145.5078125",
    c4: "-2.44140625",
  },
  {
    "": "1749",
    time: "1637709655.7252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-30.2734375",
    c3: "-187.98828125",
    c4: "22.94921875",
  },
  {
    "": "1750",
    time: "1637709655.7291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-23.4375",
    c3: "-246.58203125",
    c4: "-25.87890625",
  },
  {
    "": "1751",
    time: "1637709655.7330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-25.390625",
    c3: "-224.609375",
    c4: "-60.05859375",
  },
  {
    "": "1752",
    time: "1637709655.734125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-30.76171875",
    c3: "-161.1328125",
    c4: "-0.48828125",
  },
  {
    "": "1753",
    time: "1637709655.7380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-30.2734375",
    c3: "-140.13671875",
    c4: "17.08984375",
  },
  {
    "": "1754",
    time: "1637709655.7419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-24.4140625",
    c3: "-166.015625",
    c4: "-40.52734375",
  },
  {
    "": "1755",
    time: "1637709655.7458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-17.08984375",
    c3: "-201.171875",
    c4: "-55.17578125",
  },
  {
    "": "1756",
    time: "1637709655.74975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-18.5546875",
    c3: "-177.734375",
    c4: "-12.6953125",
  },
  {
    "": "1757",
    time: "1637709655.7536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "11.23046875",
    c2: "-16.11328125",
    c3: "-189.94140625",
    c4: "9.765625",
  },
  {
    "": "1758",
    time: "1637709655.7575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-29.296875",
    c3: "-219.23828125",
    c4: "-13.18359375",
  },
  {
    "": "1759",
    time: "1637709655.7614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-29.296875",
    c3: "-157.71484375",
    c4: "-44.921875",
  },
  {
    "": "1760",
    time: "1637709655.765375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-15.625",
    c3: "-131.8359375",
    c4: "-26.3671875",
  },
  {
    "": "1761",
    time: "1637709655.7692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-39.55078125",
    c3: "-139.16015625",
    c4: "23.4375",
  },
  {
    "": "1762",
    time: "1637709655.7731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-43.45703125",
    c3: "-126.953125",
    c4: "3.41796875",
  },
  {
    "": "1763",
    time: "1637709655.7770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-24.4140625",
    c3: "-145.5078125",
    c4: "-58.59375",
  },
  {
    "": "1764",
    time: "1637709655.782125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-13.18359375",
    c3: "-175.29296875",
    c4: "-49.31640625",
  },
  {
    "": "1765",
    time: "1637709655.7860312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-28.80859375",
    c3: "-169.921875",
    c4: "12.6953125",
  },
  {
    "": "1766",
    time: "1637709655.7899375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-33.203125",
    c3: "-129.8828125",
    c4: "15.625",
  },
  {
    "": "1767",
    time: "1637709655.7938437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-36.62109375",
    c3: "-114.2578125",
    c4: "-40.52734375",
  },
  {
    "": "1768",
    time: "1637709655.79775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-34.1796875",
    c3: "-153.3203125",
    c4: "-50.78125",
  },
  {
    "": "1769",
    time: "1637709655.8016562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-25.390625",
    c3: "-185.546875",
    c4: "-9.27734375",
  },
  {
    "": "1770",
    time: "1637709655.8055625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-41.9921875",
    c3: "-122.55859375",
    c4: "11.23046875",
  },
  {
    "": "1771",
    time: "1637709655.8094687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-35.15625",
    c3: "-105.46875",
    c4: "-25.390625",
  },
  {
    "": "1772",
    time: "1637709655.813375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-36.1328125",
    c3: "-162.59765625",
    c4: "-82.51953125",
  },
  {
    "": "1773",
    time: "1637709655.8172812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-35.64453125",
    c3: "-156.25",
    c4: "-51.26953125",
  },
  {
    "": "1774",
    time: "1637709655.8211875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-37.59765625",
    c3: "-122.0703125",
    c4: "-5.859375",
  },
  {
    "": "1775",
    time: "1637709655.8250937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-34.66796875",
    c3: "-116.2109375",
    c4: "-51.26953125",
  },
  {
    "": "1776",
    time: "1637709655.839125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-35.15625",
    c3: "-143.5546875",
    c4: "-84.47265625",
  },
  {
    "": "1777",
    time: "1637709655.8430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-71.2890625",
    c3: "-144.53125",
    c4: "-28.3203125",
  },
  {
    "": "1778",
    time: "1637709655.8469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-52.734375",
    c3: "-126.46484375",
    c4: "5.37109375",
  },
  {
    "": "1779",
    time: "1637709655.8508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-11.71875",
    c3: "-144.04296875",
    c4: "-33.203125",
  },
  {
    "": "1780",
    time: "1637709655.85475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-14.16015625",
    c3: "-182.6171875",
    c4: "-73.2421875",
  },
  {
    "": "1781",
    time: "1637709655.8586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-26.3671875",
    c3: "-201.171875",
    c4: "-52.24609375",
  },
  {
    "": "1782",
    time: "1637709655.8625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-40.0390625",
    c3: "-146.484375",
    c4: "-8.7890625",
  },
  {
    "": "1783",
    time: "1637709655.8664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-57.12890625",
    c3: "-108.88671875",
    c4: "-21.484375",
  },
  {
    "": "1784",
    time: "1637709655.870375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-37.109375",
    c3: "-145.01953125",
    c4: "-55.6640625",
  },
  {
    "": "1785",
    time: "1637709655.8742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-11.23046875",
    c3: "-173.33984375",
    c4: "-58.59375",
  },
  {
    "": "1786",
    time: "1637709655.8781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-17.578125",
    c3: "-153.80859375",
    c4: "-10.7421875",
  },
  {
    "": "1787",
    time: "1637709655.8820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-35.64453125",
    c3: "-141.11328125",
    c4: "5.37109375",
  },
  {
    "": "1788",
    time: "1637709655.884125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-45.41015625",
    c3: "-176.7578125",
    c4: "-43.45703125",
  },
  {
    "": "1789",
    time: "1637709655.8880312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-31.25",
    c3: "-192.87109375",
    c4: "-82.51953125",
  },
  {
    "": "1790",
    time: "1637709655.8919375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-28.80859375",
    c3: "-150.87890625",
    c4: "-40.0390625",
  },
  {
    "": "1791",
    time: "1637709655.8958437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-42.96875",
    c3: "-145.99609375",
    c4: "-5.859375",
  },
  {
    "": "1792",
    time: "1637709655.89975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-52.24609375",
    c3: "-157.71484375",
    c4: "-34.66796875",
  },
  {
    "": "1793",
    time: "1637709655.9036562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-64.453125",
    c3: "-163.57421875",
    c4: "-70.80078125",
  },
  {
    "": "1794",
    time: "1637709655.9075625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-31.73828125",
    c3: "-165.52734375",
    c4: "-49.31640625",
  },
  {
    "": "1795",
    time: "1637709655.9114687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-2.44140625",
    c3: "-137.20703125",
    c4: "17.08984375",
  },
  {
    "": "1796",
    time: "1637709655.915375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-28.3203125",
    c3: "-165.0390625",
    c4: "-6.34765625",
  },
  {
    "": "1797",
    time: "1637709655.9192812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-33.69140625",
    c3: "-172.36328125",
    c4: "-69.82421875",
  },
  {
    "": "1798",
    time: "1637709655.9231875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-26.85546875",
    c3: "-124.0234375",
    c4: "-64.453125",
  },
  {
    "": "1799",
    time: "1637709655.9270937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-41.9921875",
    c3: "-126.953125",
    c4: "-19.04296875",
  },
  {
    "": "1800",
    time: "1637709655.928125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-44.43359375",
    c3: "-156.73828125",
    c4: "-9.765625",
  },
  {
    "": "1801",
    time: "1637709655.9320312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-22.4609375",
    c3: "-163.57421875",
    c4: "-54.19921875",
  },
  {
    "": "1802",
    time: "1637709655.9359374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-1.953125",
    c3: "-146.484375",
    c4: "-67.87109375",
  },
  {
    "": "1803",
    time: "1637709655.9398437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-23.4375",
    c3: "-149.90234375",
    c4: "-20.99609375",
  },
  {
    "": "1804",
    time: "1637709655.94375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-31.25",
    c3: "-160.64453125",
    c4: "-6.8359375",
  },
  {
    "": "1805",
    time: "1637709655.9476562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-16.6015625",
    c3: "-145.99609375",
    c4: "-57.12890625",
  },
  {
    "": "1806",
    time: "1637709655.9515624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-20.01953125",
    c3: "-143.06640625",
    c4: "-88.8671875",
  },
  {
    "": "1807",
    time: "1637709655.9554687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-39.0625",
    c3: "-167.48046875",
    c4: "-49.31640625",
  },
  {
    "": "1808",
    time: "1637709655.959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-49.31640625",
    c3: "-147.4609375",
    c4: "-0.9765625",
  },
  {
    "": "1809",
    time: "1637709655.9632812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-49.31640625",
    c3: "-110.3515625",
    c4: "-38.0859375",
  },
  {
    "": "1810",
    time: "1637709655.9671874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-56.15234375",
    c3: "-139.16015625",
    c4: "-92.28515625",
  },
  {
    "": "1811",
    time: "1637709655.9710937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-41.015625",
    c3: "-174.31640625",
    c4: "-58.59375",
  },
  {
    "": "1812",
    time: "1637709655.975125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-13.18359375",
    c3: "-132.32421875",
    c4: "-2.9296875",
  },
  {
    "": "1813",
    time: "1637709655.9790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-28.3203125",
    c3: "-126.953125",
    c4: "-20.99609375",
  },
  {
    "": "1814",
    time: "1637709655.9829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-51.7578125",
    c3: "-159.66796875",
    c4: "-47.8515625",
  },
  {
    "": "1815",
    time: "1637709655.9868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-42.48046875",
    c3: "-151.3671875",
    c4: "-44.921875",
  },
  {
    "": "1816",
    time: "1637709655.99075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-7.32421875",
    c3: "-155.76171875",
    c4: "-13.18359375",
  },
  {
    "": "1817",
    time: "1637709655.9946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-6.8359375",
    c3: "-135.7421875",
    c4: "-12.6953125",
  },
  {
    "": "1818",
    time: "1637709655.9985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-23.4375",
    c3: "-130.37109375",
    c4: "-68.84765625",
  },
  {
    "": "1819",
    time: "1637709656.0024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.42578125",
    c2: "-16.6015625",
    c3: "-168.9453125",
    c4: "-71.77734375",
  },
  {
    "": "1820",
    time: "1637709656.006375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-15.13671875",
    c3: "-141.6015625",
    c4: "-29.78515625",
  },
  {
    "": "1821",
    time: "1637709656.0102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-19.04296875",
    c3: "-90.33203125",
    c4: "-13.671875",
  },
  {
    "": "1822",
    time: "1637709656.0141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-38.57421875",
    c3: "-115.234375",
    c4: "-46.875",
  },
  {
    "": "1823",
    time: "1637709656.0180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-34.66796875",
    c3: "-153.3203125",
    c4: "-97.16796875",
  },
  {
    "": "1824",
    time: "1637709656.020125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-26.3671875",
    c3: "-165.52734375",
    c4: "-51.26953125",
  },
  {
    "": "1825",
    time: "1637709656.0240312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-21.484375",
    c3: "-137.20703125",
    c4: "5.37109375",
  },
  {
    "": "1826",
    time: "1637709656.0279374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-12.20703125",
    c3: "-133.30078125",
    c4: "-46.875",
  },
  {
    "": "1827",
    time: "1637709656.0318437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-21.97265625",
    c3: "-172.36328125",
    c4: "-79.58984375",
  },
  {
    "": "1828",
    time: "1637709656.03575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-35.15625",
    c3: "-159.66796875",
    c4: "-50.78125",
  },
  {
    "": "1829",
    time: "1637709656.0396562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-49.31640625",
    c3: "-136.23046875",
    c4: "-10.25390625",
  },
  {
    "": "1830",
    time: "1637709656.0435624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-50.78125",
    c3: "-153.3203125",
    c4: "-12.20703125",
  },
  {
    "": "1831",
    time: "1637709656.0474687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-24.90234375",
    c3: "-162.109375",
    c4: "-50.29296875",
  },
  {
    "": "1832",
    time: "1637709656.051375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.1484375",
    c2: "-13.18359375",
    c3: "-111.81640625",
    c4: "-67.3828125",
  },
  {
    "": "1833",
    time: "1637709656.0552812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-14.16015625",
    c3: "-93.26171875",
    c4: "-21.97265625",
  },
  {
    "": "1834",
    time: "1637709656.0591874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-31.25",
    c3: "-106.93359375",
    c4: "-1.46484375",
  },
  {
    "": "1835",
    time: "1637709656.0630937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-51.26953125",
    c3: "-111.328125",
    c4: "-45.41015625",
  },
  {
    "": "1836",
    time: "1637709656.066125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-43.45703125",
    c3: "-118.1640625",
    c4: "-75.1953125",
  },
  {
    "": "1837",
    time: "1637709656.0700312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-42.48046875",
    c3: "-112.3046875",
    c4: "-24.90234375",
  },
  {
    "": "1838",
    time: "1637709656.0739374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-60.05859375",
    c3: "-129.8828125",
    c4: "16.6015625",
  },
  {
    "": "1839",
    time: "1637709656.0778437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-47.36328125",
    c3: "-147.94921875",
    c4: "-22.94921875",
  },
  {
    "": "1840",
    time: "1637709656.08175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-35.15625",
    c3: "-141.6015625",
    c4: "-81.54296875",
  },
  {
    "": "1841",
    time: "1637709656.0856562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-35.15625",
    c3: "-152.34375",
    c4: "-68.359375",
  },
  {
    "": "1842",
    time: "1637709656.0895624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-16.6015625",
    c3: "-168.45703125",
    c4: "3.90625",
  },
  {
    "": "1843",
    time: "1637709656.0934687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-15.625",
    c3: "-121.58203125",
    c4: "-13.671875",
  },
  {
    "": "1844",
    time: "1637709656.097375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-15.13671875",
    c3: "-71.77734375",
    c4: "-81.54296875",
  },
  {
    "": "1845",
    time: "1637709656.1012812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-11.71875",
    c3: "-109.375",
    c4: "-85.9375",
  },
  {
    "": "1846",
    time: "1637709656.1051874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-23.92578125",
    c3: "-113.76953125",
    c4: "-35.64453125",
  },
  {
    "": "1847",
    time: "1637709656.1090937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-36.1328125",
    c3: "-101.5625",
    c4: "-17.578125",
  },
  {
    "": "1848",
    time: "1637709656.109125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-16.11328125",
    c3: "-105.46875",
    c4: "-54.19921875",
  },
  {
    "": "1849",
    time: "1637709656.1130311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-11.23046875",
    c3: "-106.93359375",
    c4: "-61.03515625",
  },
  {
    "": "1850",
    time: "1637709656.1169374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-19.53125",
    c3: "-102.05078125",
    c4: "-17.578125",
  },
  {
    "": "1851",
    time: "1637709656.1208436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-28.3203125",
    c3: "-114.74609375",
    c4: "15.13671875",
  },
  {
    "": "1852",
    time: "1637709656.12475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-57.12890625",
    c3: "-142.08984375",
    c4: "-37.59765625",
  },
  {
    "": "1853",
    time: "1637709656.1286561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-63.96484375",
    c3: "-139.16015625",
    c4: "-69.3359375",
  },
  {
    "": "1854",
    time: "1637709656.1325624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-40.0390625",
    c3: "-131.8359375",
    c4: "-11.71875",
  },
  {
    "": "1855",
    time: "1637709656.1364686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-15.13671875",
    c3: "-94.23828125",
    c4: "20.5078125",
  },
  {
    "": "1856",
    time: "1637709656.140375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-15.13671875",
    c3: "-70.80078125",
    c4: "-26.85546875",
  },
  {
    "": "1857",
    time: "1637709656.1442811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-22.94921875",
    c3: "-91.796875",
    c4: "-65.4296875",
  },
  {
    "": "1858",
    time: "1637709656.1481874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-21.97265625",
    c3: "-84.47265625",
    c4: "-27.34375",
  },
  {
    "": "1859",
    time: "1637709656.1520936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-26.3671875",
    c3: "-70.3125",
    c4: "7.8125",
  },
  {
    "": "1860",
    time: "1637709656.155125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-44.921875",
    c3: "-102.05078125",
    c4: "-16.6015625",
  },
  {
    "": "1861",
    time: "1637709656.1590312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-71.77734375",
    c3: "-102.5390625",
    c4: "-61.03515625",
  },
  {
    "": "1862",
    time: "1637709656.1629374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-60.05859375",
    c3: "-64.94140625",
    c4: "-56.640625",
  },
  {
    "": "1863",
    time: "1637709656.1668437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-33.203125",
    c3: "-70.3125",
    c4: "-0.48828125",
  },
  {
    "": "1864",
    time: "1637709656.17075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-52.24609375",
    c3: "-71.77734375",
    c4: "5.859375",
  },
  {
    "": "1865",
    time: "1637709656.1746562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-50.29296875",
    c3: "-73.73046875",
    c4: "-37.109375",
  },
  {
    "": "1866",
    time: "1637709656.1785624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-45.8984375",
    c3: "-83.984375",
    c4: "-58.10546875",
  },
  {
    "": "1867",
    time: "1637709656.1824687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-60.546875",
    c3: "-65.4296875",
    c4: "-25.390625",
  },
  {
    "": "1868",
    time: "1637709656.186375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-54.6875",
    c3: "-29.296875",
    c4: "-2.9296875",
  },
  {
    "": "1869",
    time: "1637709656.1902812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-55.17578125",
    c3: "-44.921875",
    c4: "-40.0390625",
  },
  {
    "": "1870",
    time: "1637709656.1941874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-57.6171875",
    c3: "-33.203125",
    c4: "-56.640625",
  },
  {
    "": "1871",
    time: "1637709656.1980937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-36.62109375",
    c3: "-9.765625",
    c4: "-23.92578125",
  },
  {
    "": "1872",
    time: "1637709656.214125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-24.4140625",
    c3: "-22.94921875",
    c4: "17.08984375",
  },
  {
    "": "1873",
    time: "1637709656.2180312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-43.45703125",
    c3: "-14.6484375",
    c4: "-14.6484375",
  },
  {
    "": "1874",
    time: "1637709656.2219374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-57.12890625",
    c3: "-13.671875",
    c4: "-66.40625",
  },
  {
    "": "1875",
    time: "1637709656.2258437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-47.36328125",
    c3: "-24.4140625",
    c4: "-47.36328125",
  },
  {
    "": "1876",
    time: "1637709656.22975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-53.22265625",
    c3: "-35.15625",
    c4: "8.7890625",
  },
  {
    "": "1877",
    time: "1637709656.2336562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-49.31640625",
    c3: "-73.73046875",
    c4: "13.18359375",
  },
  {
    "": "1878",
    time: "1637709656.2375624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.5",
    c2: "-38.57421875",
    c3: "-42.48046875",
    c4: "-38.0859375",
  },
  {
    "": "1879",
    time: "1637709656.2414687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-54.19921875",
    c3: "-23.92578125",
    c4: "-41.015625",
  },
  {
    "": "1880",
    time: "1637709656.245375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-46.875",
    c3: "-66.40625",
    c4: "21.97265625",
  },
  {
    "": "1881",
    time: "1637709656.2492812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.203125",
    c2: "-33.69140625",
    c3: "-51.26953125",
    c4: "8.7890625",
  },
  {
    "": "1882",
    time: "1637709656.2531874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-32.71484375",
    c3: "-9.765625",
    c4: "-50.29296875",
  },
  {
    "": "1883",
    time: "1637709656.2570937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-29.296875",
    c3: "-12.6953125",
    c4: "-52.734375",
  },
  {
    "": "1884",
    time: "1637709656.261125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-64.453125",
    c3: "-22.4609375",
    c4: "-1.953125",
  },
  {
    "": "1885",
    time: "1637709656.2650313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-63.96484375",
    c3: "-6.8359375",
    c4: "16.6015625",
  },
  {
    "": "1886",
    time: "1637709656.2689376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-20.01953125",
    c3: "-5.859375",
    c4: "-34.66796875",
  },
  {
    "": "1887",
    time: "1637709656.2728438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-17.08984375",
    c3: "-14.16015625",
    c4: "-62.5",
  },
  {
    "": "1888",
    time: "1637709656.27675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-29.296875",
    c3: "-11.71875",
    c4: "-40.0390625",
  },
  {
    "": "1889",
    time: "1637709656.2806563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-31.25",
    c3: "-24.4140625",
    c4: "-7.8125",
  },
  {
    "": "1890",
    time: "1637709656.2845626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-34.1796875",
    c3: "-31.73828125",
    c4: "-45.41015625",
  },
  {
    "": "1891",
    time: "1637709656.2884688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-52.24609375",
    c3: "-26.85546875",
    c4: "-87.890625",
  },
  {
    "": "1892",
    time: "1637709656.292375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-65.4296875",
    c3: "-46.875",
    c4: "-52.734375",
  },
  {
    "": "1893",
    time: "1637709656.2962813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-46.38671875",
    c3: "-32.2265625",
    c4: "-5.859375",
  },
  {
    "": "1894",
    time: "1637709656.3001876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-33.203125",
    c3: "-5.859375",
    c4: "-6.8359375",
  },
  {
    "": "1895",
    time: "1637709656.3040938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-28.3203125",
    c3: "5.859375",
    c4: "-47.36328125",
  },
  {
    "": "1896",
    time: "1637709656.303125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-36.1328125",
    c3: "-3.90625",
    c4: "-71.2890625",
  },
  {
    "": "1897",
    time: "1637709656.3070312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-32.71484375",
    c3: "-9.765625",
    c4: "-31.25",
  },
  {
    "": "1898",
    time: "1637709656.3109374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-14.16015625",
    c3: "-9.27734375",
    c4: "-10.7421875",
  },
  {
    "": "1899",
    time: "1637709656.3148437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-18.06640625",
    c3: "-33.203125",
    c4: "-59.5703125",
  },
  {
    "": "1900",
    time: "1637709656.31875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-32.2265625",
    c3: "-33.69140625",
    c4: "-65.4296875",
  },
  {
    "": "1901",
    time: "1637709656.3226562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-34.1796875",
    c3: "-24.4140625",
    c4: "-11.23046875",
  },
  {
    "": "1902",
    time: "1637709656.3265624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-16.11328125",
    c3: "-7.8125",
    c4: "5.859375",
  },
  {
    "": "1903",
    time: "1637709656.3304687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-1.46484375",
    c3: "-12.6953125",
    c4: "-12.20703125",
  },
  {
    "": "1904",
    time: "1637709656.334375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-8.7890625",
    c3: "-60.05859375",
    c4: "-47.36328125",
  },
  {
    "": "1905",
    time: "1637709656.3382812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-34.1796875",
    c3: "-20.5078125",
    c4: "-41.9921875",
  },
  {
    "": "1906",
    time: "1637709656.3421874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-46.38671875",
    c3: "24.90234375",
    c4: "0.48828125",
  },
  {
    "": "1907",
    time: "1637709656.3460937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-37.59765625",
    c3: "-1.953125",
    c4: "-14.6484375",
  },
  {
    "": "1908",
    time: "1637709656.350125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-45.41015625",
    c3: "-17.578125",
    c4: "-65.4296875",
  },
  {
    "": "1909",
    time: "1637709656.3540313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-58.10546875",
    c3: "-8.30078125",
    c4: "-67.3828125",
  },
  {
    "": "1910",
    time: "1637709656.3579376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-45.8984375",
    c3: "-10.7421875",
    c4: "-18.06640625",
  },
  {
    "": "1911",
    time: "1637709656.3618438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-37.109375",
    c3: "0.48828125",
    c4: "-6.34765625",
  },
  {
    "": "1912",
    time: "1637709656.36575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-43.45703125",
    c3: "-4.8828125",
    c4: "-65.91796875",
  },
  {
    "": "1913",
    time: "1637709656.3696563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-43.9453125",
    c3: "-38.57421875",
    c4: "-69.3359375",
  },
  {
    "": "1914",
    time: "1637709656.3735626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-38.57421875",
    c3: "-22.94921875",
    c4: "-0.9765625",
  },
  {
    "": "1915",
    time: "1637709656.3774688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-47.8515625",
    c3: "-24.4140625",
    c4: "36.62109375",
  },
  {
    "": "1916",
    time: "1637709656.381375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-55.6640625",
    c3: "-12.20703125",
    c4: "-15.625",
  },
  {
    "": "1917",
    time: "1637709656.3852813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-39.55078125",
    c3: "15.13671875",
    c4: "-54.19921875",
  },
  {
    "": "1918",
    time: "1637709656.3891876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-27.34375",
    c3: "-20.5078125",
    c4: "-8.7890625",
  },
  {
    "": "1919",
    time: "1637709656.3930938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-27.34375",
    c3: "-37.109375",
    c4: "14.16015625",
  },
  {
    "": "1920",
    time: "1637709656.394125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-34.1796875",
    c3: "-16.6015625",
    c4: "-15.625",
  },
  {
    "": "1921",
    time: "1637709656.3980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.75390625",
    c2: "-43.9453125",
    c3: "18.5546875",
    c4: "-66.40625",
  },
  {
    "": "1922",
    time: "1637709656.4019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-38.0859375",
    c3: "5.859375",
    c4: "-40.52734375",
  },
  {
    "": "1923",
    time: "1637709656.4058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-50.78125",
    c3: "1.46484375",
    c4: "21.484375",
  },
  {
    "": "1924",
    time: "1637709656.40975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-81.54296875",
    c3: "7.8125",
    c4: "-13.18359375",
  },
  {
    "": "1925",
    time: "1637709656.4136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-60.546875",
    c3: "-24.4140625",
    c4: "-66.40625",
  },
  {
    "": "1926",
    time: "1637709656.4175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-18.5546875",
    c3: "-47.8515625",
    c4: "-51.26953125",
  },
  {
    "": "1927",
    time: "1637709656.4214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-15.13671875",
    c3: "-43.45703125",
    c4: "20.99609375",
  },
  {
    "": "1928",
    time: "1637709656.425375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-43.9453125",
    c3: "-8.30078125",
    c4: "20.5078125",
  },
  {
    "": "1929",
    time: "1637709656.4292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-77.1484375",
    c3: "-10.25390625",
    c4: "-45.8984375",
  },
  {
    "": "1930",
    time: "1637709656.4331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-68.359375",
    c3: "-30.76171875",
    c4: "-44.43359375",
  },
  {
    "": "1931",
    time: "1637709656.4370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-30.2734375",
    c3: "-16.11328125",
    c4: "-4.8828125",
  },
  {
    "": "1932",
    time: "1637709656.440125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-17.08984375",
    c3: "-1.46484375",
    c4: "7.32421875",
  },
  {
    "": "1933",
    time: "1637709656.4440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-32.2265625",
    c3: "1.953125",
    c4: "-27.83203125",
  },
  {
    "": "1934",
    time: "1637709656.4479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.70703125",
    c2: "-32.2265625",
    c3: "-5.859375",
    c4: "-52.24609375",
  },
  {
    "": "1935",
    time: "1637709656.4518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-22.94921875",
    c3: "3.41796875",
    c4: "-23.92578125",
  },
  {
    "": "1936",
    time: "1637709656.45575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.37109375",
    c2: "-40.0390625",
    c3: "28.80859375",
    c4: "9.765625",
  },
  {
    "": "1937",
    time: "1637709656.4596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-58.10546875",
    c3: "13.671875",
    c4: "-9.765625",
  },
  {
    "": "1938",
    time: "1637709656.4635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-56.15234375",
    c3: "-16.6015625",
    c4: "-58.59375",
  },
  {
    "": "1939",
    time: "1637709656.4674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-57.6171875",
    c3: "-8.30078125",
    c4: "-55.17578125",
  },
  {
    "": "1940",
    time: "1637709656.471375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-44.921875",
    c3: "2.9296875",
    c4: "-0.48828125",
  },
  {
    "": "1941",
    time: "1637709656.4752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-47.36328125",
    c3: "-17.578125",
    c4: "-2.9296875",
  },
  {
    "": "1942",
    time: "1637709656.4791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-58.59375",
    c3: "-16.11328125",
    c4: "-41.015625",
  },
  {
    "": "1943",
    time: "1637709656.4830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-37.109375",
    c3: "-9.765625",
    c4: "-39.55078125",
  },
  {
    "": "1944",
    time: "1637709656.485125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-18.5546875",
    c3: "8.7890625",
    c4: "1.953125",
  },
  {
    "": "1945",
    time: "1637709656.4890313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-12.20703125",
    c3: "20.99609375",
    c4: "8.7890625",
  },
  {
    "": "1946",
    time: "1637709656.4929376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-26.85546875",
    c3: "-25.87890625",
    c4: "-37.59765625",
  },
  {
    "": "1947",
    time: "1637709656.4968438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-39.0625",
    c3: "-46.875",
    c4: "-48.828125",
  },
  {
    "": "1948",
    time: "1637709656.50075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-26.3671875",
    c3: "-15.13671875",
    c4: "-7.8125",
  },
  {
    "": "1949",
    time: "1637709656.5046563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.7890625",
    c2: "-29.78515625",
    c3: "-1.953125",
    c4: "21.97265625",
  },
  {
    "": "1950",
    time: "1637709656.5085626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-51.7578125",
    c3: "-30.2734375",
    c4: "-20.5078125",
  },
  {
    "": "1951",
    time: "1637709656.5124688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-30.76171875",
    c3: "-16.6015625",
    c4: "-55.17578125",
  },
  {
    "": "1952",
    time: "1637709656.516375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-27.83203125",
    c3: "6.34765625",
    c4: "-33.69140625",
  },
  {
    "": "1953",
    time: "1637709656.5202813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-49.8046875",
    c3: "0.9765625",
    c4: "-2.44140625",
  },
  {
    "": "1954",
    time: "1637709656.5241876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-29.78515625",
    c3: "13.671875",
    c4: "-18.06640625",
  },
  {
    "": "1955",
    time: "1637709656.5280938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-19.04296875",
    c3: "26.85546875",
    c4: "-70.3125",
  },
  {
    "": "1956",
    time: "1637709656.530125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-28.80859375",
    c3: "-0.48828125",
    c4: "-56.640625",
  },
  {
    "": "1957",
    time: "1637709656.5340312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.671875",
    c2: "-25.390625",
    c3: "-6.8359375",
    c4: "17.08984375",
  },
  {
    "": "1958",
    time: "1637709656.5379374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-40.52734375",
    c3: "1.46484375",
    c4: "25.87890625",
  },
  {
    "": "1959",
    time: "1637709656.5418437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-43.45703125",
    c3: "15.625",
    c4: "-25.87890625",
  },
  {
    "": "1960",
    time: "1637709656.54575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-8.7890625",
    c3: "24.4140625",
    c4: "-50.29296875",
  },
  {
    "": "1961",
    time: "1637709656.5496562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-8.7890625",
    c3: "-27.34375",
    c4: "0.48828125",
  },
  {
    "": "1962",
    time: "1637709656.5535624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-30.2734375",
    c3: "-17.578125",
    c4: "16.11328125",
  },
  {
    "": "1963",
    time: "1637709656.5574687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-35.15625",
    c3: "30.76171875",
    c4: "-42.48046875",
  },
  {
    "": "1964",
    time: "1637709656.561375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-30.76171875",
    c3: "-9.27734375",
    c4: "-78.61328125",
  },
  {
    "": "1965",
    time: "1637709656.5652812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-35.64453125",
    c3: "-22.94921875",
    c4: "-43.45703125",
  },
  {
    "": "1966",
    time: "1637709656.5691874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-33.69140625",
    c3: "11.23046875",
    c4: "-6.34765625",
  },
  {
    "": "1967",
    time: "1637709656.5730937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-32.2265625",
    c3: "16.6015625",
    c4: "-35.15625",
  },
  {
    "": "1968",
    time: "1637709656.588125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-13.18359375",
    c3: "-4.39453125",
    c4: "-65.91796875",
  },
  {
    "": "1969",
    time: "1637709656.5920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-9.27734375",
    c3: "-9.765625",
    c4: "-36.1328125",
  },
  {
    "": "1970",
    time: "1637709656.5959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-29.296875",
    c3: "10.25390625",
    c4: "1.953125",
  },
  {
    "": "1971",
    time: "1637709656.5998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-33.69140625",
    c3: "20.5078125",
    c4: "-18.5546875",
  },
  {
    "": "1972",
    time: "1637709656.60375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-47.8515625",
    c3: "-22.4609375",
    c4: "-68.359375",
  },
  {
    "": "1973",
    time: "1637709656.6076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-46.875",
    c3: "-56.15234375",
    c4: "-80.56640625",
  },
  {
    "": "1974",
    time: "1637709656.6115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-21.484375",
    c3: "-7.32421875",
    c4: "-36.1328125",
  },
  {
    "": "1975",
    time: "1637709656.6154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-13.18359375",
    c3: "23.4375",
    c4: "-27.83203125",
  },
  {
    "": "1976",
    time: "1637709656.619375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-35.15625",
    c3: "-18.06640625",
    c4: "-57.6171875",
  },
  {
    "": "1977",
    time: "1637709656.6232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-44.921875",
    c3: "-39.0625",
    c4: "-53.22265625",
  },
  {
    "": "1978",
    time: "1637709656.6271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-70.80078125",
    c3: "21.484375",
    c4: "-25.87890625",
  },
  {
    "": "1979",
    time: "1637709656.6310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-60.546875",
    c3: "38.0859375",
    c4: "-13.671875",
  },
  {
    "": "1980",
    time: "1637709656.634125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-17.578125",
    c3: "12.20703125",
    c4: "-60.05859375",
  },
  {
    "": "1981",
    time: "1637709656.6380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-15.13671875",
    c3: "17.578125",
    c4: "-78.125",
  },
  {
    "": "1982",
    time: "1637709656.6419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-24.90234375",
    c3: "-1.953125",
    c4: "-40.52734375",
  },
  {
    "": "1983",
    time: "1637709656.6458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-21.484375",
    c3: "-42.96875",
    c4: "-3.90625",
  },
  {
    "": "1984",
    time: "1637709656.64975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-20.01953125",
    c3: "-29.78515625",
    c4: "-23.92578125",
  },
  {
    "": "1985",
    time: "1637709656.6536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-49.31640625",
    c3: "-0.9765625",
    c4: "-65.4296875",
  },
  {
    "": "1986",
    time: "1637709656.6575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-58.10546875",
    c3: "3.41796875",
    c4: "-56.15234375",
  },
  {
    "": "1987",
    time: "1637709656.6614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-57.12890625",
    c3: "11.23046875",
    c4: "-0.9765625",
  },
  {
    "": "1988",
    time: "1637709656.665375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-38.0859375",
    c3: "-11.23046875",
    c4: "1.46484375",
  },
  {
    "": "1989",
    time: "1637709656.6692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-4.8828125",
    c3: "-5.859375",
    c4: "-44.921875",
  },
  {
    "": "1990",
    time: "1637709656.6731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-5.859375",
    c3: "14.16015625",
    c4: "-40.0390625",
  },
  {
    "": "1991",
    time: "1637709656.6770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-44.43359375",
    c3: "2.9296875",
    c4: "14.6484375",
  },
  {
    "": "1992",
    time: "1637709656.679125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-50.78125",
    c3: "6.8359375",
    c4: "26.3671875",
  },
  {
    "": "1993",
    time: "1637709656.6830313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-13.671875",
    c3: "21.97265625",
    c4: "-22.4609375",
  },
  {
    "": "1994",
    time: "1637709656.6869376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-19.53125",
    c3: "6.34765625",
    c4: "-64.94140625",
  },
  {
    "": "1995",
    time: "1637709656.6908438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-30.76171875",
    c3: "-52.24609375",
    c4: "-18.5546875",
  },
  {
    "": "1996",
    time: "1637709656.69475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.8828125",
    c2: "-18.5546875",
    c3: "-51.26953125",
    c4: "34.1796875",
  },
  {
    "": "1997",
    time: "1637709656.6986563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-43.9453125",
    c3: "-21.484375",
    c4: "-11.23046875",
  },
  {
    "": "1998",
    time: "1637709656.7025626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-43.45703125",
    c3: "-20.5078125",
    c4: "-59.08203125",
  },
  {
    "": "1999",
    time: "1637709656.7064688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-11.71875",
    c3: "-32.2265625",
    c4: "-20.01953125",
  },
  {
    "": "2000",
    time: "1637709656.710375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-19.53125",
    c3: "-14.6484375",
    c4: "25.390625",
  },
  {
    "": "2001",
    time: "1637709656.7142813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-15.13671875",
    c3: "27.83203125",
    c4: "0.48828125",
  },
  {
    "": "2002",
    time: "1637709656.7181876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-46.875",
    c3: "-2.44140625",
    c4: "-37.59765625",
  },
  {
    "": "2003",
    time: "1637709656.7220938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-75.68359375",
    c3: "-26.85546875",
    c4: "-32.2265625",
  },
  {
    "": "2004",
    time: "1637709656.726125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-4.39453125",
    c2: "-35.64453125",
    c3: "-0.9765625",
    c4: "17.578125",
  },
  {
    "": "2005",
    time: "1637709656.7300313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-4.39453125",
    c3: "14.16015625",
    c4: "0.0",
  },
  {
    "": "2006",
    time: "1637709656.7339375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-3.90625",
    c3: "-10.25390625",
    c4: "-65.4296875",
  },
  {
    "": "2007",
    time: "1637709656.7378438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-17.08984375",
    c3: "-38.0859375",
    c4: "-41.50390625",
  },
  {
    "": "2008",
    time: "1637709656.74175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-45.41015625",
    c3: "-9.27734375",
    c4: "14.16015625",
  },
  {
    "": "2009",
    time: "1637709656.7456563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-47.8515625",
    c3: "-1.953125",
    c4: "3.41796875",
  },
  {
    "": "2010",
    time: "1637709656.7495625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-35.15625",
    c3: "-18.5546875",
    c4: "-48.33984375",
  },
  {
    "": "2011",
    time: "1637709656.7534688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-29.296875",
    c3: "-43.45703125",
    c4: "-60.05859375",
  },
  {
    "": "2012",
    time: "1637709656.757375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-21.97265625",
    c3: "-33.69140625",
    c4: "-18.06640625",
  },
  {
    "": "2013",
    time: "1637709656.7612813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-23.92578125",
    c3: "8.7890625",
    c4: "10.7421875",
  },
  {
    "": "2014",
    time: "1637709656.7651875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-34.66796875",
    c3: "-13.671875",
    c4: "-21.97265625",
  },
  {
    "": "2015",
    time: "1637709656.7690938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-56.15234375",
    c3: "-28.3203125",
    c4: "-59.5703125",
  },
  {
    "": "2016",
    time: "1637709656.772125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-57.6171875",
    c3: "0.48828125",
    c4: "-41.9921875",
  },
  {
    "": "2017",
    time: "1637709656.7760313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-28.80859375",
    c3: "0.9765625",
    c4: "-4.39453125",
  },
  {
    "": "2018",
    time: "1637709656.7799375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-53.7109375",
    c3: "-13.671875",
    c4: "-13.671875",
  },
  {
    "": "2019",
    time: "1637709656.7838438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-69.3359375",
    c3: "-26.85546875",
    c4: "-55.17578125",
  },
  {
    "": "2020",
    time: "1637709656.78775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-22.4609375",
    c3: "-33.69140625",
    c4: "-50.29296875",
  },
  {
    "": "2021",
    time: "1637709656.7916563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.9765625",
    c2: "-9.27734375",
    c3: "-23.4375",
    c4: "0.0",
  },
  {
    "": "2022",
    time: "1637709656.7955625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-17.08984375",
    c3: "-7.8125",
    c4: "9.27734375",
  },
  {
    "": "2023",
    time: "1637709656.7994688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-18.5546875",
    c3: "-30.2734375",
    c4: "-17.08984375",
  },
  {
    "": "2024",
    time: "1637709656.803375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-16.6015625",
    c3: "-11.71875",
    c4: "-31.25",
  },
  {
    "": "2025",
    time: "1637709656.8072813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-26.3671875",
    c3: "17.08984375",
    c4: "-5.37109375",
  },
  {
    "": "2026",
    time: "1637709656.8111875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-36.62109375",
    c3: "0.9765625",
    c4: "7.32421875",
  },
  {
    "": "2027",
    time: "1637709656.8150938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-48.828125",
    c3: "-7.8125",
    c4: "-53.7109375",
  },
  {
    "": "2028",
    time: "1637709656.829125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-63.4765625",
    c3: "-4.8828125",
    c4: "-79.58984375",
  },
  {
    "": "2029",
    time: "1637709656.8330312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.71875",
    c2: "-52.24609375",
    c3: "11.71875",
    c4: "-15.625",
  },
  {
    "": "2030",
    time: "1637709656.8369374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-54.19921875",
    c3: "9.765625",
    c4: "16.6015625",
  },
  {
    "": "2031",
    time: "1637709656.8408437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-50.29296875",
    c3: "-8.7890625",
    c4: "-30.76171875",
  },
  {
    "": "2032",
    time: "1637709656.84475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-30.2734375",
    c3: "-7.32421875",
    c4: "-48.33984375",
  },
  {
    "": "2033",
    time: "1637709656.8486562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-31.25",
    c3: "-8.7890625",
    c4: "-15.625",
  },
  {
    "": "2034",
    time: "1637709656.8525624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-30.2734375",
    c3: "-30.2734375",
    c4: "25.390625",
  },
  {
    "": "2035",
    time: "1637709656.8564687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "10.7421875",
    c2: "-30.76171875",
    c3: "-10.7421875",
    c4: "4.39453125",
  },
  {
    "": "2036",
    time: "1637709656.860375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-44.921875",
    c3: "-3.41796875",
    c4: "-46.38671875",
  },
  {
    "": "2037",
    time: "1637709656.8642812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.80078125",
    c2: "-38.0859375",
    c3: "-37.59765625",
    c4: "-42.48046875",
  },
  {
    "": "2038",
    time: "1637709656.8681874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-24.90234375",
    c3: "-28.80859375",
    c4: "1.46484375",
  },
  {
    "": "2039",
    time: "1637709656.8720937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "1.953125",
    c2: "-30.2734375",
    c3: "-6.8359375",
    c4: "8.30078125",
  },
  {
    "": "2040",
    time: "1637709656.858125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-47.8515625",
    c3: "-2.44140625",
    c4: "-38.0859375",
  },
  {
    "": "2041",
    time: "1637709656.8620312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-52.734375",
    c3: "-10.25390625",
    c4: "-71.77734375",
  },
  {
    "": "2042",
    time: "1637709656.8659375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-40.52734375",
    c3: "-23.92578125",
    c4: "-50.29296875",
  },
  {
    "": "2043",
    time: "1637709656.8698437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-43.9453125",
    c3: "-17.08984375",
    c4: "-4.8828125",
  },
  {
    "": "2044",
    time: "1637709656.87375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-46.38671875",
    c3: "-7.8125",
    c4: "-32.2265625",
  },
  {
    "": "2045",
    time: "1637709656.8776562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-52.734375",
    c3: "-32.2265625",
    c4: "-65.4296875",
  },
  {
    "": "2046",
    time: "1637709656.8815625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-52.734375",
    c3: "-19.04296875",
    c4: "-21.97265625",
  },
  {
    "": "2047",
    time: "1637709656.8854687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-28.3203125",
    c3: "27.83203125",
    c4: "17.578125",
  },
  {
    "": "2048",
    time: "1637709656.889375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-30.2734375",
    c3: "13.671875",
    c4: "-6.34765625",
  },
  {
    "": "2049",
    time: "1637709656.8932812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-44.921875",
    c3: "-34.1796875",
    c4: "-34.1796875",
  },
  {
    "": "2050",
    time: "1637709656.8971875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-54.19921875",
    c3: "-46.875",
    c4: "-21.97265625",
  },
  {
    "": "2051",
    time: "1637709656.9010937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-62.5",
    c3: "1.953125",
    c4: "4.8828125",
  },
  {
    "": "2052",
    time: "1637709656.905125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-36.62109375",
    c3: "14.6484375",
    c4: "-2.9296875",
  },
  {
    "": "2053",
    time: "1637709656.9090312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-24.4140625",
    c3: "-21.97265625",
    c4: "-44.921875",
  },
  {
    "": "2054",
    time: "1637709656.9129374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-22.4609375",
    c3: "-14.6484375",
    c4: "-58.59375",
  },
  {
    "": "2055",
    time: "1637709656.9168437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-16.11328125",
    c3: "-4.8828125",
    c4: "-14.6484375",
  },
  {
    "": "2056",
    time: "1637709656.92075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.8125",
    c2: "-41.9921875",
    c3: "-23.92578125",
    c4: "15.13671875",
  },
  {
    "": "2057",
    time: "1637709656.9246562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-43.45703125",
    c3: "-15.625",
    c4: "-13.18359375",
  },
  {
    "": "2058",
    time: "1637709656.9285624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-19.04296875",
    c3: "5.37109375",
    c4: "-46.38671875",
  },
  {
    "": "2059",
    time: "1637709656.9324687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-12.20703125",
    c3: "20.99609375",
    c4: "-5.37109375",
  },
  {
    "": "2060",
    time: "1637709656.936375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-17.08984375",
    c3: "14.6484375",
    c4: "22.4609375",
  },
  {
    "": "2061",
    time: "1637709656.9402812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-23.4375",
    c3: "-23.92578125",
    c4: "-4.39453125",
  },
  {
    "": "2062",
    time: "1637709656.9441874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-20.99609375",
    c3: "-32.2265625",
    c4: "-42.48046875",
  },
  {
    "": "2063",
    time: "1637709656.9480937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.5078125",
    c2: "-11.71875",
    c3: "-11.23046875",
    c4: "-26.3671875",
  },
  {
    "": "2064",
    time: "1637709656.964125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "0.9765625",
    c3: "-6.34765625",
    c4: "31.73828125",
  },
  {
    "": "2065",
    time: "1637709656.9680312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-11.71875",
    c3: "6.34765625",
    c4: "-3.90625",
  },
  {
    "": "2066",
    time: "1637709656.9719374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-35.15625",
    c3: "25.87890625",
    c4: "-57.12890625",
  },
  {
    "": "2067",
    time: "1637709656.9758437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-24.4140625",
    c3: "-1.953125",
    c4: "-50.29296875",
  },
  {
    "": "2068",
    time: "1637709656.97975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-23.4375",
    c3: "-62.98828125",
    c4: "-4.39453125",
  },
  {
    "": "2069",
    time: "1637709656.9836562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-23.92578125",
    c3: "-56.15234375",
    c4: "6.34765625",
  },
  {
    "": "2070",
    time: "1637709656.9875624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.390625",
    c2: "-25.87890625",
    c3: "-1.953125",
    c4: "-54.19921875",
  },
  {
    "": "2071",
    time: "1637709656.9914687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-26.85546875",
    c3: "14.6484375",
    c4: "-71.2890625",
  },
  {
    "": "2072",
    time: "1637709656.995375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-10.7421875",
    c3: "-11.23046875",
    c4: "0.0",
  },
  {
    "": "2073",
    time: "1637709656.9992812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.8359375",
    c2: "-40.0390625",
    c3: "-35.15625",
    c4: "32.71484375",
  },
  {
    "": "2074",
    time: "1637709657.0031874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-51.26953125",
    c3: "-4.39453125",
    c4: "-22.94921875",
  },
  {
    "": "2075",
    time: "1637709657.0070937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-42.96875",
    c3: "-3.41796875",
    c4: "-50.29296875",
  },
  {
    "": "2076",
    time: "1637709657.008125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-40.0390625",
    c3: "-5.859375",
    c4: "-21.97265625",
  },
  {
    "": "2077",
    time: "1637709657.0120313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-36.1328125",
    c3: "-1.46484375",
    c4: "15.625",
  },
  {
    "": "2078",
    time: "1637709657.0159376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-37.109375",
    c3: "-20.99609375",
    c4: "-5.859375",
  },
  {
    "": "2079",
    time: "1637709657.0198438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-40.52734375",
    c3: "-25.390625",
    c4: "-51.7578125",
  },
  {
    "": "2080",
    time: "1637709657.02375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-58.10546875",
    c3: "-26.85546875",
    c4: "-35.64453125",
  },
  {
    "": "2081",
    time: "1637709657.0276563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.11328125",
    c2: "-62.98828125",
    c3: "-19.53125",
    c4: "13.671875",
  },
  {
    "": "2082",
    time: "1637709657.0315626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-78.125",
    c3: "-22.4609375",
    c4: "1.46484375",
  },
  {
    "": "2083",
    time: "1637709657.0354688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.91796875",
    c2: "-89.84375",
    c3: "-35.64453125",
    c4: "-68.84765625",
  },
  {
    "": "2084",
    time: "1637709657.039375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-56.640625",
    c3: "-32.71484375",
    c4: "-68.359375",
  },
  {
    "": "2085",
    time: "1637709657.0432813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-12.20703125",
    c3: "-35.64453125",
    c4: "-8.30078125",
  },
  {
    "": "2086",
    time: "1637709657.0471876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-14.6484375",
    c3: "-20.99609375",
    c4: "-18.5546875",
  },
  {
    "": "2087",
    time: "1637709657.0510938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-44.43359375",
    c3: "-22.94921875",
    c4: "-52.734375",
  },
  {
    "": "2088",
    time: "1637709657.053125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-51.7578125",
    c3: "-17.578125",
    c4: "-51.7578125",
  },
  {
    "": "2089",
    time: "1637709657.0570312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-33.69140625",
    c3: "3.90625",
    c4: "-20.5078125",
  },
  {
    "": "2090",
    time: "1637709657.0609374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-24.90234375",
    c3: "-1.953125",
    c4: "3.41796875",
  },
  {
    "": "2091",
    time: "1637709657.0648437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-36.62109375",
    c3: "-31.73828125",
    c4: "-40.0390625",
  },
  {
    "": "2092",
    time: "1637709657.06875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-41.50390625",
    c3: "-50.78125",
    c4: "-58.10546875",
  },
  {
    "": "2093",
    time: "1637709657.0726562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-36.62109375",
    c3: "-38.0859375",
    c4: "-13.18359375",
  },
  {
    "": "2094",
    time: "1637709657.0765624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-52.734375",
    c3: "-24.90234375",
    c4: "7.8125",
  },
  {
    "": "2095",
    time: "1637709657.0804687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-56.15234375",
    c3: "-28.3203125",
    c4: "-36.1328125",
  },
  {
    "": "2096",
    time: "1637709657.084375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.61328125",
    c2: "-41.50390625",
    c3: "-40.52734375",
    c4: "-69.82421875",
  },
  {
    "": "2097",
    time: "1637709657.0882812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-29.78515625",
    c3: "-5.859375",
    c4: "-54.19921875",
  },
  {
    "": "2098",
    time: "1637709657.0921874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-21.484375",
    c3: "-22.94921875",
    c4: "-5.37109375",
  },
  {
    "": "2099",
    time: "1637709657.0960937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-32.2265625",
    c3: "-47.8515625",
    c4: "-10.25390625",
  },
  {
    "": "2100",
    time: "1637709657.100125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-38.57421875",
    c3: "-9.27734375",
    c4: "-59.5703125",
  },
  {
    "": "2101",
    time: "1637709657.1040313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-39.0625",
    c3: "-7.8125",
    c4: "-42.48046875",
  },
  {
    "": "2102",
    time: "1637709657.1079376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.7578125",
    c2: "-40.0390625",
    c3: "-17.08984375",
    c4: "-0.48828125",
  },
  {
    "": "2103",
    time: "1637709657.1118438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-47.36328125",
    c3: "-2.44140625",
    c4: "2.44140625",
  },
  {
    "": "2104",
    time: "1637709657.11575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-48.828125",
    c3: "4.8828125",
    c4: "-35.64453125",
  },
  {
    "": "2105",
    time: "1637709657.1196563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-60.05859375",
    c3: "-19.04296875",
    c4: "-50.78125",
  },
  {
    "": "2106",
    time: "1637709657.1235626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-81.54296875",
    c3: "-38.57421875",
    c4: "-8.7890625",
  },
  {
    "": "2107",
    time: "1637709657.1274688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-74.21875",
    c3: "-44.43359375",
    c4: "6.34765625",
  },
  {
    "": "2108",
    time: "1637709657.131375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-41.50390625",
    c3: "-25.87890625",
    c4: "-28.80859375",
  },
  {
    "": "2109",
    time: "1637709657.1352813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-17.08984375",
    c3: "-0.48828125",
    c4: "-56.15234375",
  },
  {
    "": "2110",
    time: "1637709657.1391876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-4.39453125",
    c3: "-16.11328125",
    c4: "-32.2265625",
  },
  {
    "": "2111",
    time: "1637709657.1430938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-1.953125",
    c3: "-31.73828125",
    c4: "6.34765625",
  },
  {
    "": "2112",
    time: "1637709657.143125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-10.25390625",
    c3: "-18.06640625",
    c4: "-20.01953125",
  },
  {
    "": "2113",
    time: "1637709657.1470313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-14.16015625",
    c3: "0.0",
    c4: "-65.91796875",
  },
  {
    "": "2114",
    time: "1637709657.1509376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-24.4140625",
    c3: "-22.4609375",
    c4: "-50.29296875",
  },
  {
    "": "2115",
    time: "1637709657.1548438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-22.94921875",
    c3: "-55.6640625",
    c4: "-1.953125",
  },
  {
    "": "2116",
    time: "1637709657.15875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-20.01953125",
    c3: "-28.80859375",
    c4: "-2.44140625",
  },
  {
    "": "2117",
    time: "1637709657.1626563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-31.25",
    c3: "-23.4375",
    c4: "-45.41015625",
  },
  {
    "": "2118",
    time: "1637709657.1665626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-78.61328125",
    c2: "-61.5234375",
    c3: "-63.4765625",
    c4: "-53.7109375",
  },
  {
    "": "2119",
    time: "1637709657.1704688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-80.56640625",
    c3: "-53.7109375",
    c4: "-9.27734375",
  },
  {
    "": "2120",
    time: "1637709657.174375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-39.55078125",
    c3: "0.0",
    c4: "0.9765625",
  },
  {
    "": "2121",
    time: "1637709657.1782813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-25.390625",
    c3: "17.578125",
    c4: "-56.640625",
  },
  {
    "": "2122",
    time: "1637709657.1821876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-34.66796875",
    c3: "-13.671875",
    c4: "-69.82421875",
  },
  {
    "": "2123",
    time: "1637709657.1860938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-27.34375",
    c3: "-26.3671875",
    c4: "-18.5546875",
  },
  {
    "": "2124",
    time: "1637709657.192125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-29.296875",
    c3: "-4.39453125",
    c4: "-7.32421875",
  },
  {
    "": "2125",
    time: "1637709657.1960313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-33.69140625",
    c3: "5.859375",
    c4: "-29.78515625",
  },
  {
    "": "2126",
    time: "1637709657.1999376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-42.96875",
    c3: "-38.0859375",
    c4: "-45.8984375",
  },
  {
    "": "2127",
    time: "1637709657.2038438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-53.7109375",
    c3: "-44.921875",
    c4: "-41.015625",
  },
  {
    "": "2128",
    time: "1637709657.20775",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-33.69140625",
    c3: "-9.27734375",
    c4: "-15.13671875",
  },
  {
    "": "2129",
    time: "1637709657.2116563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-22.4609375",
    c3: "-16.11328125",
    c4: "-25.390625",
  },
  {
    "": "2130",
    time: "1637709657.2155626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-50.29296875",
    c3: "-63.96484375",
    c4: "-69.3359375",
  },
  {
    "": "2131",
    time: "1637709657.2194688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-77.1484375",
    c2: "-61.03515625",
    c3: "-69.82421875",
    c4: "-77.63671875",
  },
  {
    "": "2132",
    time: "1637709657.223375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-50.78125",
    c3: "-28.80859375",
    c4: "-39.55078125",
  },
  {
    "": "2133",
    time: "1637709657.2272813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-70.80078125",
    c3: "-20.99609375",
    c4: "-33.203125",
  },
  {
    "": "2134",
    time: "1637709657.2311876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-81.0546875",
    c3: "-31.25",
    c4: "-79.58984375",
  },
  {
    "": "2135",
    time: "1637709657.2350938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-39.0625",
    c3: "-21.97265625",
    c4: "-96.19140625",
  },
  {
    "": "2136",
    time: "1637709657.233125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "2.44140625",
    c3: "-9.27734375",
    c4: "-45.8984375",
  },
  {
    "": "2137",
    time: "1637709657.2370312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "2.9296875",
    c3: "-14.6484375",
    c4: "-11.71875",
  },
  {
    "": "2138",
    time: "1637709657.2409375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-7.32421875",
    c3: "-30.76171875",
    c4: "-55.6640625",
  },
  {
    "": "2139",
    time: "1637709657.2448437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-25.390625",
    c3: "-41.015625",
    c4: "-97.16796875",
  },
  {
    "": "2140",
    time: "1637709657.24875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-37.59765625",
    c3: "-30.2734375",
    c4: "-68.359375",
  },
  {
    "": "2141",
    time: "1637709657.2526562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-45.8984375",
    c3: "-52.24609375",
    c4: "-9.27734375",
  },
  {
    "": "2142",
    time: "1637709657.2565625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-50.78125",
    c3: "-100.09765625",
    c4: "-18.06640625",
  },
  {
    "": "2143",
    time: "1637709657.2604687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-34.66796875",
    c3: "-41.015625",
    c4: "-53.22265625",
  },
  {
    "": "2144",
    time: "1637709657.264375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-22.94921875",
    c3: "24.4140625",
    c4: "-52.734375",
  },
  {
    "": "2145",
    time: "1637709657.2682812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-36.62109375",
    c3: "7.8125",
    c4: "1.953125",
  },
  {
    "": "2146",
    time: "1637709657.2721875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-54.6875",
    c3: "-0.9765625",
    c4: "12.6953125",
  },
  {
    "": "2147",
    time: "1637709657.2760937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-49.31640625",
    c3: "5.859375",
    c4: "-43.45703125",
  },
  {
    "": "2148",
    time: "1637709657.280125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-58.59375",
    c3: "-9.27734375",
    c4: "-43.9453125",
  },
  {
    "": "2149",
    time: "1637709657.2840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-53.7109375",
    c3: "-30.2734375",
    c4: "-0.9765625",
  },
  {
    "": "2150",
    time: "1637709657.2879374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-18.06640625",
    c3: "-30.2734375",
    c4: "-1.953125",
  },
  {
    "": "2151",
    time: "1637709657.2918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-9.27734375",
    c3: "-33.203125",
    c4: "-43.9453125",
  },
  {
    "": "2152",
    time: "1637709657.29575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-16.11328125",
    c3: "-26.3671875",
    c4: "-57.12890625",
  },
  {
    "": "2153",
    time: "1637709657.2996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-46.875",
    c3: "-21.484375",
    c4: "-4.8828125",
  },
  {
    "": "2154",
    time: "1637709657.3035624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-57.12890625",
    c3: "-5.859375",
    c4: "11.23046875",
  },
  {
    "": "2155",
    time: "1637709657.3074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-38.57421875",
    c3: "2.9296875",
    c4: "-26.85546875",
  },
  {
    "": "2156",
    time: "1637709657.311375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "-34.66796875",
    c3: "-16.6015625",
    c4: "-53.7109375",
  },
  {
    "": "2157",
    time: "1637709657.3152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-52.734375",
    c3: "-43.45703125",
    c4: "-26.85546875",
  },
  {
    "": "2158",
    time: "1637709657.3191874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-43.9453125",
    c3: "-18.5546875",
    c4: "4.39453125",
  },
  {
    "": "2159",
    time: "1637709657.3230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-26.3671875",
    c3: "4.8828125",
    c4: "-30.2734375",
  },
  {
    "": "2160",
    time: "1637709657.339125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-70.80078125",
    c3: "-17.08984375",
    c4: "-77.63671875",
  },
  {
    "": "2161",
    time: "1637709657.3430312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-91.796875",
    c3: "-17.578125",
    c4: "-62.01171875",
  },
  {
    "": "2162",
    time: "1637709657.3469374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-46.875",
    c3: "-34.66796875",
    c4: "-5.37109375",
  },
  {
    "": "2163",
    time: "1637709657.3508437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-42.96875",
    c3: "-46.38671875",
    c4: "-3.90625",
  },
  {
    "": "2164",
    time: "1637709657.35475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.546875",
    c2: "-53.22265625",
    c3: "-29.78515625",
    c4: "-27.83203125",
  },
  {
    "": "2165",
    time: "1637709657.3586562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-18.5546875",
    c3: "-23.4375",
    c4: "-43.9453125",
  },
  {
    "": "2166",
    time: "1637709657.3625624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "5.859375",
    c3: "-5.859375",
    c4: "-16.11328125",
  },
  {
    "": "2167",
    time: "1637709657.3664687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-1.953125",
    c3: "13.671875",
    c4: "-6.34765625",
  },
  {
    "": "2168",
    time: "1637709657.370375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-38.0859375",
    c3: "-27.83203125",
    c4: "-36.1328125",
  },
  {
    "": "2169",
    time: "1637709657.3742812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-42.48046875",
    c3: "-57.6171875",
    c4: "-64.94140625",
  },
  {
    "": "2170",
    time: "1637709657.3781874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-27.83203125",
    c3: "-1.46484375",
    c4: "-31.73828125",
  },
  {
    "": "2171",
    time: "1637709657.3820937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-27.34375",
    c3: "2.9296875",
    c4: "11.23046875",
  },
  {
    "": "2172",
    time: "1637709657.383125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-36.1328125",
    c3: "-12.6953125",
    c4: "-47.8515625",
  },
  {
    "": "2173",
    time: "1637709657.3870313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-63.4765625",
    c3: "-10.25390625",
    c4: "-83.49609375",
  },
  {
    "": "2174",
    time: "1637709657.3909376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-58.10546875",
    c3: "-23.92578125",
    c4: "-44.43359375",
  },
  {
    "": "2175",
    time: "1637709657.3948438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-50.78125",
    c3: "-20.01953125",
    c4: "0.48828125",
  },
  {
    "": "2176",
    time: "1637709657.39875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-51.7578125",
    c3: "-16.6015625",
    c4: "-20.01953125",
  },
  {
    "": "2177",
    time: "1637709657.4026563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-44.43359375",
    c3: "-39.0625",
    c4: "-78.125",
  },
  {
    "": "2178",
    time: "1637709657.4065626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-40.52734375",
    c3: "-20.01953125",
    c4: "-62.5",
  },
  {
    "": "2179",
    time: "1637709657.4104688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-35.64453125",
    c3: "7.32421875",
    c4: "-10.7421875",
  },
  {
    "": "2180",
    time: "1637709657.414375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-28.3203125",
    c3: "-47.8515625",
    c4: "9.765625",
  },
  {
    "": "2181",
    time: "1637709657.4182813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.5703125",
    c2: "-20.5078125",
    c3: "-31.25",
    c4: "-30.76171875",
  },
  {
    "": "2182",
    time: "1637709657.4221876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-19.53125",
    c3: "-5.37109375",
    c4: "-54.6875",
  },
  {
    "": "2183",
    time: "1637709657.4260938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-32.71484375",
    c3: "-20.01953125",
    c4: "1.953125",
  },
  {
    "": "2184",
    time: "1637709657.429125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-42.96875",
    c3: "4.8828125",
    c4: "18.06640625",
  },
  {
    "": "2185",
    time: "1637709657.4330313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-40.0390625",
    c3: "8.7890625",
    c4: "-33.203125",
  },
  {
    "": "2186",
    time: "1637709657.4369376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-85.9375",
    c3: "-8.7890625",
    c4: "-59.08203125",
  },
  {
    "": "2187",
    time: "1637709657.4408438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-98.14453125",
    c3: "-20.5078125",
    c4: "-12.6953125",
  },
  {
    "": "2188",
    time: "1637709657.44475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.27734375",
    c2: "-41.50390625",
    c3: "-21.97265625",
    c4: "39.0625",
  },
  {
    "": "2189",
    time: "1637709657.4486563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-1.46484375",
    c3: "-24.4140625",
    c4: "3.90625",
  },
  {
    "": "2190",
    time: "1637709657.4525626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-11.23046875",
    c3: "-21.484375",
    c4: "-61.03515625",
  },
  {
    "": "2191",
    time: "1637709657.4564688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-50.29296875",
    c3: "-35.15625",
    c4: "-35.15625",
  },
  {
    "": "2192",
    time: "1637709657.460375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.44140625",
    c2: "-54.6875",
    c3: "-30.76171875",
    c4: "21.97265625",
  },
  {
    "": "2193",
    time: "1637709657.4642813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-31.73828125",
    c3: "7.32421875",
    c4: "-3.41796875",
  },
  {
    "": "2194",
    time: "1637709657.4681876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-14.16015625",
    c3: "-5.37109375",
    c4: "-53.7109375",
  },
  {
    "": "2195",
    time: "1637709657.4720938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-22.94921875",
    c3: "-17.08984375",
    c4: "-54.6875",
  },
  {
    "": "2196",
    time: "1637709657.475125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-41.50390625",
    c3: "8.30078125",
    c4: "-1.953125",
  },
  {
    "": "2197",
    time: "1637709657.4790313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.6484375",
    c2: "-28.80859375",
    c3: "35.64453125",
    c4: "23.92578125",
  },
  {
    "": "2198",
    time: "1637709657.4829376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-26.3671875",
    c3: "-0.48828125",
    c4: "-20.5078125",
  },
  {
    "": "2199",
    time: "1637709657.4868438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-53.7109375",
    c3: "-43.45703125",
    c4: "-34.66796875",
  },
  {
    "": "2200",
    time: "1637709657.49075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-51.7578125",
    c3: "-23.4375",
    c4: "20.01953125",
  },
  {
    "": "2201",
    time: "1637709657.4946563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.90625",
    c2: "-42.96875",
    c3: "-5.37109375",
    c4: "33.203125",
  },
  {
    "": "2202",
    time: "1637709657.4985626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-40.0390625",
    c3: "-6.34765625",
    c4: "-11.23046875",
  },
  {
    "": "2203",
    time: "1637709657.5024688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.015625",
    c2: "-29.296875",
    c3: "-48.828125",
    c4: "-34.66796875",
  },
  {
    "": "2204",
    time: "1637709657.506375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-34.66796875",
    c3: "-38.0859375",
    c4: "-14.6484375",
  },
  {
    "": "2205",
    time: "1637709657.5102813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-38.0859375",
    c3: "17.08984375",
    c4: "21.484375",
  },
  {
    "": "2206",
    time: "1637709657.5141876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-10.7421875",
    c3: "8.30078125",
    c4: "-0.9765625",
  },
  {
    "": "2207",
    time: "1637709657.5180938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-26.85546875",
    c3: "-16.6015625",
    c4: "-44.43359375",
  },
  {
    "": "2208",
    time: "1637709657.519125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-62.01171875",
    c3: "-14.6484375",
    c4: "-26.85546875",
  },
  {
    "": "2209",
    time: "1637709657.5230312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-65.91796875",
    c3: "0.48828125",
    c4: "23.4375",
  },
  {
    "": "2210",
    time: "1637709657.5269375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-64.94140625",
    c3: "-6.8359375",
    c4: "20.5078125",
  },
  {
    "": "2211",
    time: "1637709657.5308437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-46.38671875",
    c3: "-63.4765625",
    c4: "-18.5546875",
  },
  {
    "": "2212",
    time: "1637709657.53475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.0625",
    c2: "-12.6953125",
    c3: "-54.6875",
    c4: "-28.80859375",
  },
  {
    "": "2213",
    time: "1637709657.5386562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-6.8359375",
    c3: "9.27734375",
    c4: "1.46484375",
  },
  {
    "": "2214",
    time: "1637709657.5425625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.90625",
    c2: "-8.7890625",
    c3: "5.37109375",
    c4: "15.13671875",
  },
  {
    "": "2215",
    time: "1637709657.5464687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-24.4140625",
    c3: "-50.78125",
    c4: "-14.16015625",
  },
  {
    "": "2216",
    time: "1637709657.550375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-29.296875",
    c3: "-38.0859375",
    c4: "-33.203125",
  },
  {
    "": "2217",
    time: "1637709657.5542812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-36.1328125",
    c3: "0.48828125",
    c4: "-9.27734375",
  },
  {
    "": "2218",
    time: "1637709657.5581875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-55.6640625",
    c3: "-2.9296875",
    c4: "18.5546875",
  },
  {
    "": "2219",
    time: "1637709657.5620937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-43.9453125",
    c3: "2.44140625",
    c4: "-11.71875",
  },
  {
    "": "2220",
    time: "1637709657.579125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-14.6484375",
    c3: "13.671875",
    c4: "-61.5234375",
  },
  {
    "": "2221",
    time: "1637709657.5830312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-21.484375",
    c3: "3.90625",
    c4: "-20.01953125",
  },
  {
    "": "2222",
    time: "1637709657.5869374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-58.59375",
    c3: "-6.8359375",
    c4: "26.3671875",
  },
  {
    "": "2223",
    time: "1637709657.5908437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-67.3828125",
    c3: "-10.7421875",
    c4: "4.39453125",
  },
  {
    "": "2224",
    time: "1637709657.59475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-27.83203125",
    c3: "-3.41796875",
    c4: "-26.3671875",
  },
  {
    "": "2225",
    time: "1637709657.5986562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.6640625",
    c2: "-20.5078125",
    c3: "-26.3671875",
    c4: "-40.52734375",
  },
  {
    "": "2226",
    time: "1637709657.6025624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-35.64453125",
    c3: "-36.1328125",
    c4: "3.90625",
  },
  {
    "": "2227",
    time: "1637709657.6064687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-25.390625",
    c3: "4.39453125",
    c4: "-2.44140625",
  },
  {
    "": "2228",
    time: "1637709657.610375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-35.15625",
    c3: "-13.671875",
    c4: "-59.5703125",
  },
  {
    "": "2229",
    time: "1637709657.6142812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-54.19921875",
    c3: "-37.59765625",
    c4: "-72.265625",
  },
  {
    "": "2230",
    time: "1637709657.6181874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-54.19921875",
    c3: "-9.27734375",
    c4: "-36.1328125",
  },
  {
    "": "2231",
    time: "1637709657.6220937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-43.9453125",
    c3: "15.13671875",
    c4: "-17.08984375",
  },
  {
    "": "2232",
    time: "1637709657.608125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-43.9453125",
    c3: "4.39453125",
    c4: "-46.875",
  },
  {
    "": "2233",
    time: "1637709657.6120312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-43.9453125",
    c3: "-29.296875",
    c4: "-46.38671875",
  },
  {
    "": "2234",
    time: "1637709657.6159375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-56.640625",
    c3: "-30.2734375",
    c4: "-12.20703125",
  },
  {
    "": "2235",
    time: "1637709657.6198437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-52.24609375",
    c3: "-2.44140625",
    c4: "24.90234375",
  },
  {
    "": "2236",
    time: "1637709657.62375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-49.31640625",
    c3: "3.90625",
    c4: "-1.46484375",
  },
  {
    "": "2237",
    time: "1637709657.6276562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-55.17578125",
    c3: "-34.66796875",
    c4: "-54.19921875",
  },
  {
    "": "2238",
    time: "1637709657.6315625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-55.17578125",
    c3: "-39.55078125",
    c4: "-26.85546875",
  },
  {
    "": "2239",
    time: "1637709657.6354687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-41.50390625",
    c3: "-16.11328125",
    c4: "25.390625",
  },
  {
    "": "2240",
    time: "1637709657.639375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-37.59765625",
    c3: "-22.4609375",
    c4: "-15.625",
  },
  {
    "": "2241",
    time: "1637709657.6432812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-48.828125",
    c3: "-28.3203125",
    c4: "-67.3828125",
  },
  {
    "": "2242",
    time: "1637709657.6471875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-52.734375",
    c3: "-38.0859375",
    c4: "-39.55078125",
  },
  {
    "": "2243",
    time: "1637709657.6510937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-59.08203125",
    c3: "-7.8125",
    c4: "15.13671875",
  },
  {
    "": "2244",
    time: "1637709657.657125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-41.50390625",
    c3: "6.34765625",
    c4: "13.671875",
  },
  {
    "": "2245",
    time: "1637709657.6610312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-47.36328125",
    c3: "-6.8359375",
    c4: "-23.92578125",
  },
  {
    "": "2246",
    time: "1637709657.6649375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-46.38671875",
    c3: "-11.71875",
    c4: "-22.4609375",
  },
  {
    "": "2247",
    time: "1637709657.6688437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-34.1796875",
    c3: "-7.32421875",
    c4: "14.6484375",
  },
  {
    "": "2248",
    time: "1637709657.67275",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-48.33984375",
    c3: "-0.9765625",
    c4: "34.1796875",
  },
  {
    "": "2249",
    time: "1637709657.6766562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-31.25",
    c3: "-16.6015625",
    c4: "0.0",
  },
  {
    "": "2250",
    time: "1637709657.6805625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-10.25390625",
    c3: "-30.2734375",
    c4: "-54.19921875",
  },
  {
    "": "2251",
    time: "1637709657.6844687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-15.625",
    c3: "-7.32421875",
    c4: "-34.66796875",
  },
  {
    "": "2252",
    time: "1637709657.688375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "14.16015625",
    c2: "-16.6015625",
    c3: "-15.13671875",
    c4: "29.296875",
  },
  {
    "": "2253",
    time: "1637709657.6922812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-30.2734375",
    c3: "-47.8515625",
    c4: "0.0",
  },
  {
    "": "2254",
    time: "1637709657.6961875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-73.2421875",
    c3: "-29.78515625",
    c4: "-56.640625",
  },
  {
    "": "2255",
    time: "1637709657.7000937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-52.24609375",
    c3: "-14.6484375",
    c4: "-33.69140625",
  },
  {
    "": "2256",
    time: "1637709657.713125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-19.53125",
    c3: "-21.97265625",
    c4: "16.6015625",
  },
  {
    "": "2257",
    time: "1637709657.7170312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.9296875",
    c2: "-7.32421875",
    c3: "-37.109375",
    c4: "5.37109375",
  },
  {
    "": "2258",
    time: "1637709657.7209375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-11.23046875",
    c3: "-41.50390625",
    c4: "-41.9921875",
  },
  {
    "": "2259",
    time: "1637709657.7248437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-42.48046875",
    c3: "-12.20703125",
    c4: "-49.31640625",
  },
  {
    "": "2260",
    time: "1637709657.72875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.765625",
    c2: "-40.52734375",
    c3: "5.37109375",
    c4: "16.6015625",
  },
  {
    "": "2261",
    time: "1637709657.7326562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "25.390625",
    c2: "-24.4140625",
    c3: "-50.29296875",
    c4: "47.8515625",
  },
  {
    "": "2262",
    time: "1637709657.7365625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-32.2265625",
    c3: "-57.12890625",
    c4: "-20.01953125",
  },
  {
    "": "2263",
    time: "1637709657.7404687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-41.50390625",
    c3: "4.39453125",
    c4: "-67.87109375",
  },
  {
    "": "2264",
    time: "1637709657.744375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-46.38671875",
    c3: "-8.30078125",
    c4: "-30.76171875",
  },
  {
    "": "2265",
    time: "1637709657.7482812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "7.32421875",
    c2: "-52.24609375",
    c3: "-15.13671875",
    c4: "25.390625",
  },
  {
    "": "2266",
    time: "1637709657.7521875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.53125",
    c2: "-39.55078125",
    c3: "2.9296875",
    c4: "-10.7421875",
  },
  {
    "": "2267",
    time: "1637709657.7560937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-24.4140625",
    c3: "-10.7421875",
    c4: "-74.21875",
  },
  {
    "": "2268",
    time: "1637709657.759125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-11.23046875",
    c3: "-22.94921875",
    c4: "-31.25",
  },
  {
    "": "2269",
    time: "1637709657.7630312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-6.8359375",
    c3: "8.7890625",
    c4: "35.15625",
  },
  {
    "": "2270",
    time: "1637709657.7669375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "4.39453125",
    c2: "-19.04296875",
    c3: "2.9296875",
    c4: "0.9765625",
  },
  {
    "": "2271",
    time: "1637709657.7708437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-23.92578125",
    c3: "-48.828125",
    c4: "-57.6171875",
  },
  {
    "": "2272",
    time: "1637709657.77475",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-11.23046875",
    c3: "-42.48046875",
    c4: "-40.52734375",
  },
  {
    "": "2273",
    time: "1637709657.7786562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.37109375",
    c2: "-38.57421875",
    c3: "-27.83203125",
    c4: "9.765625",
  },
  {
    "": "2274",
    time: "1637709657.7825625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-90.8203125",
    c3: "-23.92578125",
    c4: "14.6484375",
  },
  {
    "": "2275",
    time: "1637709657.7864687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-87.890625",
    c3: "-8.30078125",
    c4: "-42.48046875",
  },
  {
    "": "2276",
    time: "1637709657.790375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-28.80859375",
    c3: "-39.0625",
    c4: "-57.6171875",
  },
  {
    "": "2277",
    time: "1637709657.7942812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "2.9296875",
    c3: "-44.921875",
    c4: "-12.20703125",
  },
  {
    "": "2278",
    time: "1637709657.7981875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-17.08984375",
    c3: "16.6015625",
    c4: "-2.9296875",
  },
  {
    "": "2279",
    time: "1637709657.8020937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.8515625",
    c2: "-19.04296875",
    c3: "24.4140625",
    c4: "-60.546875",
  },
  {
    "": "2280",
    time: "1637709657.803125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.2890625",
    c2: "-10.7421875",
    c3: "-16.6015625",
    c4: "-94.23828125",
  },
  {
    "": "2281",
    time: "1637709657.8070312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-18.5546875",
    c3: "-20.5078125",
    c4: "-30.76171875",
  },
  {
    "": "2282",
    time: "1637709657.8109374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-46.875",
    c3: "-9.27734375",
    c4: "10.25390625",
  },
  {
    "": "2283",
    time: "1637709657.8148437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-66.40625",
    c3: "-29.78515625",
    c4: "-47.36328125",
  },
  {
    "": "2284",
    time: "1637709657.81875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-38.57421875",
    c3: "-51.7578125",
    c4: "-90.33203125",
  },
  {
    "": "2285",
    time: "1637709657.8226562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-38.0859375",
    c3: "-72.265625",
    c4: "-56.15234375",
  },
  {
    "": "2286",
    time: "1637709657.8265624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-9.765625",
    c2: "-57.12890625",
    c3: "-34.1796875",
    c4: "0.0",
  },
  {
    "": "2287",
    time: "1637709657.8304687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-33.69140625",
    c3: "-4.39453125",
    c4: "-9.27734375",
  },
  {
    "": "2288",
    time: "1637709657.834375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-28.3203125",
    c3: "-37.59765625",
    c4: "-52.24609375",
  },
  {
    "": "2289",
    time: "1637709657.8382812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-57.6171875",
    c3: "-25.390625",
    c4: "-53.7109375",
  },
  {
    "": "2290",
    time: "1637709657.8421874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-78.125",
    c3: "-1.46484375",
    c4: "-6.8359375",
  },
  {
    "": "2291",
    time: "1637709657.8460937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-60.546875",
    c3: "2.9296875",
    c4: "-20.99609375",
  },
  {
    "": "2292",
    time: "1637709657.851125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-71.77734375",
    c2: "-38.57421875",
    c3: "-9.765625",
    c4: "-73.73046875",
  },
  {
    "": "2293",
    time: "1637709657.8550313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-87.890625",
    c2: "-27.83203125",
    c3: "-35.15625",
    c4: "-84.9609375",
  },
  {
    "": "2294",
    time: "1637709657.8589375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-47.8515625",
    c3: "-13.18359375",
    c4: "-41.50390625",
  },
  {
    "": "2295",
    time: "1637709657.8628438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.0859375",
    c2: "-79.1015625",
    c3: "-8.30078125",
    c4: "-18.5546875",
  },
  {
    "": "2296",
    time: "1637709657.86675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-83.0078125",
    c3: "-22.4609375",
    c4: "-36.1328125",
  },
  {
    "": "2297",
    time: "1637709657.8706563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-56.640625",
    c3: "-21.97265625",
    c4: "-57.6171875",
  },
  {
    "": "2298",
    time: "1637709657.8745625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-22.4609375",
    c3: "-34.1796875",
    c4: "-57.12890625",
  },
  {
    "": "2299",
    time: "1637709657.8784688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-25.87890625",
    c3: "-61.03515625",
    c4: "-28.80859375",
  },
  {
    "": "2300",
    time: "1637709657.882375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-36.62109375",
    c3: "-45.41015625",
    c4: "-35.15625",
  },
  {
    "": "2301",
    time: "1637709657.8862813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.265625",
    c2: "-46.38671875",
    c3: "-44.921875",
    c4: "-66.89453125",
  },
  {
    "": "2302",
    time: "1637709657.8901875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-51.7578125",
    c3: "-51.7578125",
    c4: "-45.41015625",
  },
  {
    "": "2303",
    time: "1637709657.8940938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-57.12890625",
    c3: "-19.53125",
    c4: "29.296875",
  },
  {
    "": "2304",
    time: "1637709657.894125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-52.734375",
    c3: "7.32421875",
    c4: "27.34375",
  },
  {
    "": "2305",
    time: "1637709657.8980312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-22.94921875",
    c3: "3.41796875",
    c4: "-41.015625",
  },
  {
    "": "2306",
    time: "1637709657.9019375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-21.97265625",
    c3: "-22.94921875",
    c4: "-54.19921875",
  },
  {
    "": "2307",
    time: "1637709657.9058437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.97265625",
    c2: "-32.2265625",
    c3: "-24.4140625",
    c4: "19.53125",
  },
  {
    "": "2308",
    time: "1637709657.90975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-22.94921875",
    c3: "4.8828125",
    c4: "37.59765625",
  },
  {
    "": "2309",
    time: "1637709657.9136562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-33.69140625",
    c3: "-25.87890625",
    c4: "-33.69140625",
  },
  {
    "": "2310",
    time: "1637709657.9175625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.31640625",
    c2: "-40.52734375",
    c3: "-62.5",
    c4: "-65.91796875",
  },
  {
    "": "2311",
    time: "1637709657.9214687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-22.4609375",
    c3: "-76.66015625",
    c4: "-23.92578125",
  },
  {
    "": "2312",
    time: "1637709657.925375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-10.25390625",
    c3: "-26.3671875",
    c4: "12.20703125",
  },
  {
    "": "2313",
    time: "1637709657.9292812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-4.39453125",
    c3: "17.08984375",
    c4: "-33.69140625",
  },
  {
    "": "2314",
    time: "1637709657.9331875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-10.7421875",
    c3: "-15.13671875",
    c4: "-78.61328125",
  },
  {
    "": "2315",
    time: "1637709657.9370937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-17.578125",
    c3: "-19.04296875",
    c4: "-42.96875",
  },
  {
    "": "2316",
    time: "1637709657.940125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-40.0390625",
    c3: "-4.8828125",
    c4: "10.25390625",
  },
  {
    "": "2317",
    time: "1637709657.9440312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.13671875",
    c2: "-37.109375",
    c3: "-18.06640625",
    c4: "-14.6484375",
  },
  {
    "": "2318",
    time: "1637709657.9479375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-18.5546875",
    c3: "-60.05859375",
    c4: "-71.2890625",
  },
  {
    "": "2319",
    time: "1637709657.9518437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-9.765625",
    c3: "-31.25",
    c4: "-55.6640625",
  },
  {
    "": "2320",
    time: "1637709657.95575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-25.87890625",
    c3: "10.7421875",
    c4: "9.27734375",
  },
  {
    "": "2321",
    time: "1637709657.9596562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-2.9296875",
    c2: "-49.8046875",
    c3: "-0.9765625",
    c4: "7.32421875",
  },
  {
    "": "2322",
    time: "1637709657.9635625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-21.484375",
    c3: "-54.6875",
    c4: "-42.96875",
  },
  {
    "": "2323",
    time: "1637709657.9674687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-12.6953125",
    c3: "-60.05859375",
    c4: "-55.6640625",
  },
  {
    "": "2324",
    time: "1637709657.971375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-26.85546875",
    c3: "-3.41796875",
    c4: "-18.5546875",
  },
  {
    "": "2325",
    time: "1637709657.9752812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-23.92578125",
    c3: "1.46484375",
    c4: "13.18359375",
  },
  {
    "": "2326",
    time: "1637709657.9791875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-31.73828125",
    c3: "-17.08984375",
    c4: "-22.94921875",
  },
  {
    "": "2327",
    time: "1637709657.9830937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.5234375",
    c2: "-30.2734375",
    c3: "-24.4140625",
    c4: "-68.359375",
  },
  {
    "": "2328",
    time: "1637709657.984125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-31.73828125",
    c3: "-9.765625",
    c4: "-17.578125",
  },
  {
    "": "2329",
    time: "1637709657.9880311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-5.859375",
    c2: "-51.26953125",
    c3: "-13.671875",
    c4: "31.25",
  },
  {
    "": "2330",
    time: "1637709657.9919374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.2734375",
    c2: "-87.40234375",
    c3: "-37.109375",
    c4: "-14.6484375",
  },
  {
    "": "2331",
    time: "1637709657.9958436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-57.6171875",
    c3: "-69.3359375",
    c4: "-55.6640625",
  },
  {
    "": "2332",
    time: "1637709657.99975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-10.7421875",
    c3: "-40.0390625",
    c4: "-28.3203125",
  },
  {
    "": "2333",
    time: "1637709658.0036561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.48828125",
    c2: "-39.55078125",
    c3: "0.0",
    c4: "19.04296875",
  },
  {
    "": "2334",
    time: "1637709658.0075624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-40.0390625",
    c3: "-40.52734375",
    c4: "8.7890625",
  },
  {
    "": "2335",
    time: "1637709658.0114686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-19.04296875",
    c3: "-72.265625",
    c4: "-43.45703125",
  },
  {
    "": "2336",
    time: "1637709658.015375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.70703125",
    c2: "-31.25",
    c3: "-59.5703125",
    c4: "-41.9921875",
  },
  {
    "": "2337",
    time: "1637709658.0192811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.99609375",
    c2: "-40.52734375",
    c3: "-22.94921875",
    c4: "12.6953125",
  },
  {
    "": "2338",
    time: "1637709658.0231874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "15.625",
    c2: "-44.921875",
    c3: "7.8125",
    c4: "13.671875",
  },
  {
    "": "2339",
    time: "1637709658.0270936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-41.015625",
    c3: "9.27734375",
    c4: "-27.34375",
  },
  {
    "": "2340",
    time: "1637709658.030125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-31.73828125",
    c3: "-14.16015625",
    c4: "-63.96484375",
  },
  {
    "": "2341",
    time: "1637709658.0340312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-25.390625",
    c3: "-4.8828125",
    c4: "-42.96875",
  },
  {
    "": "2342",
    time: "1637709658.0379374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-23.4375",
    c3: "-3.90625",
    c4: "10.7421875",
  },
  {
    "": "2343",
    time: "1637709658.0418437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-48.828125",
    c3: "-17.08984375",
    c4: "-30.76171875",
  },
  {
    "": "2344",
    time: "1637709658.04575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-53.7109375",
    c3: "-17.578125",
    c4: "-77.1484375",
  },
  {
    "": "2345",
    time: "1637709658.0496562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-42.96875",
    c3: "-21.97265625",
    c4: "-32.71484375",
  },
  {
    "": "2346",
    time: "1637709658.0535624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-53.7109375",
    c3: "-5.859375",
    c4: "18.06640625",
  },
  {
    "": "2347",
    time: "1637709658.0574687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-49.8046875",
    c3: "-7.32421875",
    c4: "-10.7421875",
  },
  {
    "": "2348",
    time: "1637709658.061375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-33.203125",
    c3: "-24.4140625",
    c4: "-59.5703125",
  },
  {
    "": "2349",
    time: "1637709658.0652812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-38.0859375",
    c3: "-40.0390625",
    c4: "-43.9453125",
  },
  {
    "": "2350",
    time: "1637709658.0691874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-55.17578125",
    c3: "-28.3203125",
    c4: "23.92578125",
  },
  {
    "": "2351",
    time: "1637709658.0730937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-8.30078125",
    c2: "-45.41015625",
    c3: "-19.53125",
    c4: "8.7890625",
  },
  {
    "": "2352",
    time: "1637709658.088125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.296875",
    c2: "-29.78515625",
    c3: "-44.921875",
    c4: "-57.12890625",
  },
  {
    "": "2353",
    time: "1637709658.0920312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-62.98828125",
    c3: "-53.7109375",
    c4: "-47.36328125",
  },
  {
    "": "2354",
    time: "1637709658.0959375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-69.3359375",
    c3: "-32.71484375",
    c4: "25.87890625",
  },
  {
    "": "2355",
    time: "1637709658.0998437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "22.94921875",
    c2: "-45.41015625",
    c3: "-11.71875",
    c4: "44.43359375",
  },
  {
    "": "2356",
    time: "1637709658.10375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.08984375",
    c2: "-32.71484375",
    c3: "-28.80859375",
    c4: "-18.5546875",
  },
  {
    "": "2357",
    time: "1637709658.1076562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-27.34375",
    c3: "-51.7578125",
    c4: "-50.78125",
  },
  {
    "": "2358",
    time: "1637709658.1115625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-42.96875",
    c3: "-14.16015625",
    c4: "-8.30078125",
  },
  {
    "": "2359",
    time: "1637709658.1154687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-57.12890625",
    c3: "-2.44140625",
    c4: "22.4609375",
  },
  {
    "": "2360",
    time: "1637709658.119375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-56.15234375",
    c3: "-47.36328125",
    c4: "-12.20703125",
  },
  {
    "": "2361",
    time: "1637709658.1232812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-38.57421875",
    c3: "-41.9921875",
    c4: "-58.10546875",
  },
  {
    "": "2362",
    time: "1637709658.1271875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-20.99609375",
    c3: "-16.6015625",
    c4: "-25.87890625",
  },
  {
    "": "2363",
    time: "1637709658.1310937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "6.34765625",
    c2: "-32.71484375",
    c3: "-19.53125",
    c4: "22.94921875",
  },
  {
    "": "2364",
    time: "1637709658.134125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.953125",
    c2: "-62.5",
    c3: "-35.64453125",
    c4: "3.90625",
  },
  {
    "": "2365",
    time: "1637709658.1380312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-69.82421875",
    c3: "-34.1796875",
    c4: "-37.109375",
  },
  {
    "": "2366",
    time: "1637709658.1419375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-78.61328125",
    c3: "-50.29296875",
    c4: "-53.22265625",
  },
  {
    "": "2367",
    time: "1637709658.1458437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-67.3828125",
    c3: "-62.5",
    c4: "7.8125",
  },
  {
    "": "2368",
    time: "1637709658.14975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-23.92578125",
    c3: "-20.99609375",
    c4: "7.32421875",
  },
  {
    "": "2369",
    time: "1637709658.1536562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.41015625",
    c2: "-22.94921875",
    c3: "-2.9296875",
    c4: "-64.94140625",
  },
  {
    "": "2370",
    time: "1637709658.1575625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-61.03515625",
    c2: "-54.6875",
    c3: "-6.8359375",
    c4: "-59.08203125",
  },
  {
    "": "2371",
    time: "1637709658.1614687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.3203125",
    c2: "-64.453125",
    c3: "-24.90234375",
    c4: "-2.44140625",
  },
  {
    "": "2372",
    time: "1637709658.165375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-43.45703125",
    c3: "-41.9921875",
    c4: "11.23046875",
  },
  {
    "": "2373",
    time: "1637709658.1692812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-55.17578125",
    c2: "-26.85546875",
    c3: "-13.671875",
    c4: "-36.1328125",
  },
  {
    "": "2374",
    time: "1637709658.1731875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.98828125",
    c2: "-19.53125",
    c3: "8.30078125",
    c4: "-88.37890625",
  },
  {
    "": "2375",
    time: "1637709658.1770937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-30.76171875",
    c3: "-4.8828125",
    c4: "-38.57421875",
  },
  {
    "": "2376",
    time: "1637709658.180125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-37.109375",
    c3: "-2.44140625",
    c4: "0.9765625",
  },
  {
    "": "2377",
    time: "1637709658.1840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-41.50390625",
    c3: "-2.9296875",
    c4: "-48.828125",
  },
  {
    "": "2378",
    time: "1637709658.1879375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.1015625",
    c2: "-47.8515625",
    c3: "-26.3671875",
    c4: "-82.03125",
  },
  {
    "": "2379",
    time: "1637709658.1918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-40.0390625",
    c3: "-41.9921875",
    c4: "-53.7109375",
  },
  {
    "": "2380",
    time: "1637709658.19575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.85546875",
    c2: "-56.640625",
    c3: "-60.05859375",
    c4: "-0.48828125",
  },
  {
    "": "2381",
    time: "1637709658.1996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.78125",
    c2: "-57.6171875",
    c3: "-41.015625",
    c4: "-10.25390625",
  },
  {
    "": "2382",
    time: "1637709658.2035625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-99.12109375",
    c2: "-32.71484375",
    c3: "-4.39453125",
    c4: "-70.80078125",
  },
  {
    "": "2383",
    time: "1637709658.2074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-89.84375",
    c2: "-34.66796875",
    c3: "-42.48046875",
    c4: "-68.359375",
  },
  {
    "": "2384",
    time: "1637709658.211375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.734375",
    c2: "-52.734375",
    c3: "-53.22265625",
    c4: "-13.18359375",
  },
  {
    "": "2385",
    time: "1637709658.2152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-43.9453125",
    c3: "6.8359375",
    c4: "-10.7421875",
  },
  {
    "": "2386",
    time: "1637709658.2191875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-54.19921875",
    c3: "-22.4609375",
    c4: "-75.68359375",
  },
  {
    "": "2387",
    time: "1637709658.2230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.9140625",
    c2: "-55.17578125",
    c3: "-76.66015625",
    c4: "-93.26171875",
  },
  {
    "": "2388",
    time: "1637709658.225125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-32.71484375",
    c3: "-39.0625",
    c4: "-23.92578125",
  },
  {
    "": "2389",
    time: "1637709658.2290313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-21.484375",
    c2: "-23.4375",
    c3: "5.859375",
    c4: "7.32421875",
  },
  {
    "": "2390",
    time: "1637709658.2329376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.22265625",
    c2: "-31.73828125",
    c3: "-17.08984375",
    c4: "-45.41015625",
  },
  {
    "": "2391",
    time: "1637709658.2368438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.078125",
    c2: "-44.43359375",
    c3: "-32.2265625",
    c4: "-73.73046875",
  },
  {
    "": "2392",
    time: "1637709658.24075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-29.296875",
    c3: "-6.8359375",
    c4: "-37.109375",
  },
  {
    "": "2393",
    time: "1637709658.2446563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.66796875",
    c2: "-38.57421875",
    c3: "-2.9296875",
    c4: "7.8125",
  },
  {
    "": "2394",
    time: "1637709658.2485626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-58.59375",
    c3: "-20.99609375",
    c4: "-18.5546875",
  },
  {
    "": "2395",
    time: "1637709658.2524688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-85.44921875",
    c2: "-51.26953125",
    c3: "-60.546875",
    c4: "-70.80078125",
  },
  {
    "": "2396",
    time: "1637709658.256375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.66015625",
    c2: "-34.66796875",
    c3: "-57.12890625",
    c4: "-52.24609375",
  },
  {
    "": "2397",
    time: "1637709658.2602813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.52734375",
    c2: "-39.55078125",
    c3: "-4.8828125",
    c4: "-4.8828125",
  },
  {
    "": "2398",
    time: "1637709658.2641876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.06640625",
    c2: "-49.31640625",
    c3: "-2.44140625",
    c4: "-19.53125",
  },
  {
    "": "2399",
    time: "1637709658.2680938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.12890625",
    c2: "-49.8046875",
    c3: "-20.01953125",
    c4: "-88.8671875",
  },
  {
    "": "2400",
    time: "1637709658.268125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-91.30859375",
    c2: "-59.5703125",
    c3: "-29.78515625",
    c4: "-79.58984375",
  },
  {
    "": "2401",
    time: "1637709658.2720313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.38671875",
    c2: "-65.4296875",
    c3: "-17.08984375",
    c4: "-3.90625",
  },
  {
    "": "2402",
    time: "1637709658.2759376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-20.01953125",
    c2: "-57.6171875",
    c3: "-16.11328125",
    c4: "8.30078125",
  },
  {
    "": "2403",
    time: "1637709658.2798438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.73828125",
    c2: "-57.6171875",
    c3: "-39.0625",
    c4: "-47.36328125",
  },
  {
    "": "2404",
    time: "1637709658.28375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-51.7578125",
    c3: "-53.7109375",
    c4: "-69.3359375",
  },
  {
    "": "2405",
    time: "1637709658.2876563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-33.203125",
    c3: "-26.85546875",
    c4: "-8.30078125",
  },
  {
    "": "2406",
    time: "1637709658.2915626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-36.1328125",
    c3: "-29.78515625",
    c4: "41.50390625",
  },
  {
    "": "2407",
    time: "1637709658.2954688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-30.2734375",
    c3: "-99.609375",
    c4: "-17.578125",
  },
  {
    "": "2408",
    time: "1637709658.299375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-24.4140625",
    c3: "-52.734375",
    c4: "-98.6328125",
  },
  {
    "": "2409",
    time: "1637709658.3032813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-60.05859375",
    c2: "-42.96875",
    c3: "1.46484375",
    c4: "-66.40625",
  },
  {
    "": "2410",
    time: "1637709658.3071876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "0.0",
    c2: "-70.3125",
    c3: "-4.39453125",
    c4: "12.6953125",
  },
  {
    "": "2411",
    time: "1637709658.3110938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-93.26171875",
    c3: "3.90625",
    c4: "-0.9765625",
  },
  {
    "": "2412",
    time: "1637709658.315125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.94140625",
    c2: "-68.84765625",
    c3: "-17.578125",
    c4: "-65.91796875",
  },
  {
    "": "2413",
    time: "1637709658.3190312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.96484375",
    c2: "-34.1796875",
    c3: "-26.85546875",
    c4: "-59.5703125",
  },
  {
    "": "2414",
    time: "1637709658.3229375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.64453125",
    c2: "-20.5078125",
    c3: "-17.578125",
    c4: "15.625",
  },
  {
    "": "2415",
    time: "1637709658.3268437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-21.484375",
    c3: "-12.20703125",
    c4: "5.859375",
  },
  {
    "": "2416",
    time: "1637709658.33075",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-46.875",
    c3: "-23.4375",
    c4: "-59.5703125",
  },
  {
    "": "2417",
    time: "1637709658.3346562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-51.26953125",
    c2: "-41.50390625",
    c3: "-26.85546875",
    c4: "-57.6171875",
  },
  {
    "": "2418",
    time: "1637709658.3385625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-23.4375",
    c3: "-32.71484375",
    c4: "7.32421875",
  },
  {
    "": "2419",
    time: "1637709658.3424687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "2.44140625",
    c2: "-30.76171875",
    c3: "-53.7109375",
    c4: "34.66796875",
  },
  {
    "": "2420",
    time: "1637709658.346375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-57.6171875",
    c2: "-11.23046875",
    c3: "-30.76171875",
    c4: "-39.0625",
  },
  {
    "": "2421",
    time: "1637709658.3502812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-70.3125",
    c2: "-24.4140625",
    c3: "-13.18359375",
    c4: "-100.09765625",
  },
  {
    "": "2422",
    time: "1637709658.3541875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.2265625",
    c2: "-67.3828125",
    c3: "-16.11328125",
    c4: "-24.4140625",
  },
  {
    "": "2423",
    time: "1637709658.3580937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-44.921875",
    c3: "-13.18359375",
    c4: "36.1328125",
  },
  {
    "": "2424",
    time: "1637709658.360125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-46.38671875",
    c3: "-40.0390625",
    c4: "-31.25",
  },
  {
    "": "2425",
    time: "1637709658.3640313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-46.875",
    c2: "-36.62109375",
    c3: "-37.59765625",
    c4: "-76.66015625",
  },
  {
    "": "2426",
    time: "1637709658.3679376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-17.08984375",
    c3: "-9.765625",
    c4: "-23.92578125",
  },
  {
    "": "2427",
    time: "1637709658.3718438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-1.46484375",
    c2: "-23.4375",
    c3: "9.27734375",
    c4: "12.6953125",
  },
  {
    "": "2428",
    time: "1637709658.37575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-14.6484375",
    c3: "2.9296875",
    c4: "-37.109375",
  },
  {
    "": "2429",
    time: "1637709658.3796563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.9453125",
    c2: "-44.43359375",
    c3: "-44.43359375",
    c4: "-93.26171875",
  },
  {
    "": "2430",
    time: "1637709658.3835626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-84.47265625",
    c3: "-77.1484375",
    c4: "-63.4765625",
  },
  {
    "": "2431",
    time: "1637709658.3874688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-45.41015625",
    c3: "-2.44140625",
    c4: "26.85546875",
  },
  {
    "": "2432",
    time: "1637709658.391375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "1.46484375",
    c3: "10.7421875",
    c4: "13.671875",
  },
  {
    "": "2433",
    time: "1637709658.3952813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-27.34375",
    c3: "-76.66015625",
    c4: "-78.125",
  },
  {
    "": "2434",
    time: "1637709658.3991876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.33984375",
    c2: "-60.546875",
    c3: "-43.9453125",
    c4: "-95.703125",
  },
  {
    "": "2435",
    time: "1637709658.4030938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-44.921875",
    c3: "17.08984375",
    c4: "-25.87890625",
  },
  {
    "": "2436",
    time: "1637709658.418125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-41.50390625",
    c3: "3.41796875",
    c4: "19.04296875",
  },
  {
    "": "2437",
    time: "1637709658.4220312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.83203125",
    c2: "-59.08203125",
    c3: "-25.87890625",
    c4: "-0.9765625",
  },
  {
    "": "2438",
    time: "1637709658.4259374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-35.15625",
    c2: "-53.7109375",
    c3: "-74.21875",
    c4: "-58.10546875",
  },
  {
    "": "2439",
    time: "1637709658.4298437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-31.25",
    c2: "-35.64453125",
    c3: "-44.43359375",
    c4: "-43.9453125",
  },
  {
    "": "2440",
    time: "1637709658.43375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-45.8984375",
    c3: "40.52734375",
    c4: "13.18359375",
  },
  {
    "": "2441",
    time: "1637709658.4376562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-40.0390625",
    c2: "-40.52734375",
    c3: "-27.34375",
    c4: "-3.41796875",
  },
  {
    "": "2442",
    time: "1637709658.4415624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-74.21875",
    c2: "-18.5546875",
    c3: "-63.4765625",
    c4: "-51.7578125",
  },
  {
    "": "2443",
    time: "1637709658.4454687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-52.24609375",
    c2: "-55.17578125",
    c3: "13.18359375",
    c4: "-37.59765625",
  },
  {
    "": "2444",
    time: "1637709658.449375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-3.41796875",
    c2: "-86.42578125",
    c3: "-42.48046875",
    c4: "33.203125",
  },
  {
    "": "2445",
    time: "1637709658.4532812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.7421875",
    c2: "-77.1484375",
    c3: "-47.8515625",
    c4: "0.9765625",
  },
  {
    "": "2446",
    time: "1637709658.4571874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-68.84765625",
    c2: "-31.25",
    c3: "2.9296875",
    c4: "-76.66015625",
  },
  {
    "": "2447",
    time: "1637709658.4610937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-76.171875",
    c2: "8.7890625",
    c3: "13.18359375",
    c4: "-68.84765625",
  },
  {
    "": "2448",
    time: "1637709658.463125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "1.46484375",
    c3: "10.25390625",
    c4: "-8.7890625",
  },
  {
    "": "2449",
    time: "1637709658.4670312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-19.53125",
    c3: "6.34765625",
    c4: "2.9296875",
  },
  {
    "": "2450",
    time: "1637709658.4709375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-36.1328125",
    c3: "16.11328125",
    c4: "-41.9921875",
  },
  {
    "": "2451",
    time: "1637709658.4748437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-47.36328125",
    c3: "-15.13671875",
    c4: "-54.6875",
  },
  {
    "": "2452",
    time: "1637709658.47875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.4375",
    c2: "-51.7578125",
    c3: "-13.18359375",
    c4: "-16.11328125",
  },
  {
    "": "2453",
    time: "1637709658.4826562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-59.5703125",
    c3: "-12.6953125",
    c4: "17.08984375",
  },
  {
    "": "2454",
    time: "1637709658.4865625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-42.48046875",
    c3: "-7.8125",
    c4: "-20.01953125",
  },
  {
    "": "2455",
    time: "1637709658.4904687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-64.453125",
    c2: "-30.76171875",
    c3: "41.015625",
    c4: "-78.61328125",
  },
  {
    "": "2456",
    time: "1637709658.494375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.19921875",
    c2: "-40.0390625",
    c3: "28.3203125",
    c4: "-39.55078125",
  },
  {
    "": "2457",
    time: "1637709658.4982812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-19.04296875",
    c2: "-52.734375",
    c3: "16.11328125",
    c4: "28.80859375",
  },
  {
    "": "2458",
    time: "1637709658.5021875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-39.55078125",
    c3: "46.875",
    c4: "-19.04296875",
  },
  {
    "": "2459",
    time: "1637709658.5060937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-16.11328125",
    c3: "0.9765625",
    c4: "-89.84375",
  },
  {
    "": "2460",
    time: "1637709658.508125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-21.484375",
    c3: "-13.671875",
    c4: "-58.59375",
  },
  {
    "": "2461",
    time: "1637709658.5120313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-26.3671875",
    c2: "-25.390625",
    c3: "39.0625",
    c4: "2.44140625",
  },
  {
    "": "2462",
    time: "1637709658.5159376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-34.66796875",
    c3: "68.84765625",
    c4: "-21.97265625",
  },
  {
    "": "2463",
    time: "1637709658.5198438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.59375",
    c2: "-37.109375",
    c3: "36.62109375",
    c4: "-70.3125",
  },
  {
    "": "2464",
    time: "1637709658.52375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-37.59765625",
    c3: "10.25390625",
    c4: "-68.359375",
  },
  {
    "": "2465",
    time: "1637709658.5276563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-52.734375",
    c3: "29.296875",
    c4: "2.44140625",
  },
  {
    "": "2466",
    time: "1637709658.5315626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-48.828125",
    c3: "33.203125",
    c4: "11.23046875",
  },
  {
    "": "2467",
    time: "1637709658.5354688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-47.36328125",
    c2: "-48.33984375",
    c3: "20.5078125",
    c4: "-54.19921875",
  },
  {
    "": "2468",
    time: "1637709658.539375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-59.08203125",
    c2: "-78.125",
    c3: "-16.6015625",
    c4: "-61.03515625",
  },
  {
    "": "2469",
    time: "1637709658.5432813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-38.57421875",
    c2: "-91.796875",
    c3: "-10.7421875",
    c4: "-4.39453125",
  },
  {
    "": "2470",
    time: "1637709658.5471876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.109375",
    c2: "-81.0546875",
    c3: "28.3203125",
    c4: "12.6953125",
  },
  {
    "": "2471",
    time: "1637709658.5510938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-63.4765625",
    c2: "-46.38671875",
    c3: "5.37109375",
    c4: "-45.41015625",
  },
  {
    "": "2472",
    time: "1637709658.554125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-80.56640625",
    c2: "-20.01953125",
    c3: "11.23046875",
    c4: "-88.37890625",
  },
  {
    "": "2473",
    time: "1637709658.5580313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-54.6875",
    c2: "-21.484375",
    c3: "49.8046875",
    c4: "-61.03515625",
  },
  {
    "": "2474",
    time: "1637709658.5619376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.94921875",
    c2: "-17.578125",
    c3: "67.3828125",
    c4: "-5.859375",
  },
  {
    "": "2475",
    time: "1637709658.5658438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-27.83203125",
    c3: "40.0390625",
    c4: "-29.78515625",
  },
  {
    "": "2476",
    time: "1637709658.56975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-66.40625",
    c2: "-44.921875",
    c3: "12.20703125",
    c4: "-65.91796875",
  },
  {
    "": "2477",
    time: "1637709658.5736563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-33.69140625",
    c2: "-47.8515625",
    c3: "8.30078125",
    c4: "-29.296875",
  },
  {
    "": "2478",
    time: "1637709658.5775626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.48828125",
    c2: "-41.015625",
    c3: "22.94921875",
    c4: "20.01953125",
  },
  {
    "": "2479",
    time: "1637709658.5814688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-14.16015625",
    c2: "-43.9453125",
    c3: "33.203125",
    c4: "3.90625",
  },
  {
    "": "2480",
    time: "1637709658.585375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.640625",
    c2: "-57.12890625",
    c3: "32.2265625",
    c4: "-55.6640625",
  },
  {
    "": "2481",
    time: "1637709658.5892813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-50.29296875",
    c2: "-47.8515625",
    c3: "46.38671875",
    c4: "-65.4296875",
  },
  {
    "": "2482",
    time: "1637709658.5931876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.6953125",
    c2: "-62.5",
    c3: "32.71484375",
    c4: "5.37109375",
  },
  {
    "": "2483",
    time: "1637709658.5970938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-12.20703125",
    c2: "-66.89453125",
    c3: "10.7421875",
    c4: "36.1328125",
  },
  {
    "": "2484",
    time: "1637709658.601125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.48046875",
    c2: "-41.015625",
    c3: "9.27734375",
    c4: "-30.76171875",
  },
  {
    "": "2485",
    time: "1637709658.6050313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-62.01171875",
    c2: "-50.29296875",
    c3: "19.53125",
    c4: "-81.0546875",
  },
  {
    "": "2486",
    time: "1637709658.6089375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-25.87890625",
    c2: "-47.36328125",
    c3: "6.34765625",
    c4: "-46.875",
  },
  {
    "": "2487",
    time: "1637709658.6128438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-44.43359375",
    c3: "16.11328125",
    c4: "-1.46484375",
  },
  {
    "": "2488",
    time: "1637709658.61675",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.4140625",
    c2: "-47.36328125",
    c3: "18.5546875",
    c4: "-13.18359375",
  },
  {
    "": "2489",
    time: "1637709658.6206563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.3359375",
    c2: "-86.9140625",
    c3: "-31.73828125",
    c4: "-79.1015625",
  },
  {
    "": "2490",
    time: "1637709658.6245625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-91.30859375",
    c3: "1.46484375",
    c4: "-54.6875",
  },
  {
    "": "2491",
    time: "1637709658.6284688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-15.625",
    c2: "-41.015625",
    c3: "26.85546875",
    c4: "18.5546875",
  },
  {
    "": "2492",
    time: "1637709658.632375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-29.78515625",
    c2: "-33.203125",
    c3: "22.4609375",
    c4: "-20.99609375",
  },
  {
    "": "2493",
    time: "1637709658.6362813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-82.03125",
    c2: "-29.296875",
    c3: "41.015625",
    c4: "-76.171875",
  },
  {
    "": "2494",
    time: "1637709658.6401875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-79.58984375",
    c2: "-28.3203125",
    c3: "32.71484375",
    c4: "-57.6171875",
  },
  {
    "": "2495",
    time: "1637709658.6440938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-34.1796875",
    c3: "16.6015625",
    c4: "12.20703125",
  },
  {
    "": "2496",
    time: "1637709658.656125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-38.0859375",
    c3: "8.30078125",
    c4: "22.4609375",
  },
  {
    "": "2497",
    time: "1637709658.6600313",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-28.80859375",
    c2: "-33.69140625",
    c3: "20.99609375",
    c4: "-33.69140625",
  },
  {
    "": "2498",
    time: "1637709658.6639376",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-30.76171875",
    c2: "-48.828125",
    c3: "15.13671875",
    c4: "-43.9453125",
  },
  {
    "": "2499",
    time: "1637709658.6678438",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.921875",
    c2: "-57.6171875",
    c3: "15.625",
    c4: "8.30078125",
  },
  {
    "": "2500",
    time: "1637709658.67175",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-11.23046875",
    c2: "-64.94140625",
    c3: "43.45703125",
    c4: "14.6484375",
  },
  {
    "": "2501",
    time: "1637709658.6756563",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-24.90234375",
    c2: "-47.8515625",
    c3: "24.4140625",
    c4: "-54.19921875",
  },
  {
    "": "2502",
    time: "1637709658.6795626",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-69.82421875",
    c2: "-35.15625",
    c3: "-13.671875",
    c4: "-90.33203125",
  },
  {
    "": "2503",
    time: "1637709658.6834688",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.1328125",
    c2: "-56.640625",
    c3: "-37.109375",
    c4: "-23.4375",
  },
  {
    "": "2504",
    time: "1637709658.687375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "3.41796875",
    c2: "-26.85546875",
    c3: "3.41796875",
    c4: "30.2734375",
  },
  {
    "": "2505",
    time: "1637709658.6912813",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-2.44140625",
    c3: "23.92578125",
    c4: "-20.99609375",
  },
  {
    "": "2506",
    time: "1637709658.6951876",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-72.75390625",
    c2: "-28.80859375",
    c3: "-9.27734375",
    c4: "-89.84375",
  },
  {
    "": "2507",
    time: "1637709658.6990938",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-49.8046875",
    c2: "-39.0625",
    c3: "-23.92578125",
    c4: "-59.5703125",
  },
  {
    "": "2508",
    time: "1637709658.690125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.8125",
    c2: "-33.69140625",
    c3: "-20.01953125",
    c4: "4.39453125",
  },
  {
    "": "2509",
    time: "1637709658.6940312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-27.34375",
    c2: "-49.31640625",
    c3: "-10.25390625",
    c4: "-23.92578125",
  },
  {
    "": "2510",
    time: "1637709658.6979375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-65.4296875",
    c2: "-66.40625",
    c3: "-20.99609375",
    c4: "-70.3125",
  },
  {
    "": "2511",
    time: "1637709658.7018437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-73.2421875",
    c2: "-66.89453125",
    c3: "-3.90625",
    c4: "-73.2421875",
  },
  {
    "": "2512",
    time: "1637709658.70575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.50390625",
    c2: "-66.89453125",
    c3: "15.625",
    c4: "-10.7421875",
  },
  {
    "": "2513",
    time: "1637709658.7096562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-22.4609375",
    c2: "-43.45703125",
    c3: "-0.48828125",
    c4: "2.9296875",
  },
  {
    "": "2514",
    time: "1637709658.7135625",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-53.7109375",
    c2: "-34.1796875",
    c3: "-36.62109375",
    c4: "-52.734375",
  },
  {
    "": "2515",
    time: "1637709658.7174687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.3828125",
    c2: "-40.0390625",
    c3: "-39.0625",
    c4: "-76.171875",
  },
  {
    "": "2516",
    time: "1637709658.721375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-34.1796875",
    c2: "-32.2265625",
    c3: "4.39453125",
    c4: "-15.13671875",
  },
  {
    "": "2517",
    time: "1637709658.7252812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-0.9765625",
    c2: "-24.4140625",
    c3: "-2.9296875",
    c4: "19.53125",
  },
  {
    "": "2518",
    time: "1637709658.7291875",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-34.1796875",
    c3: "-7.32421875",
    c4: "-62.98828125",
  },
  {
    "": "2519",
    time: "1637709658.7330937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-85.9375",
    c2: "-60.546875",
    c3: "12.6953125",
    c4: "-93.75",
  },
  {
    "": "2520",
    time: "1637709658.734125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-48.828125",
    c2: "-55.17578125",
    c3: "13.671875",
    c4: "-44.921875",
  },
  {
    "": "2521",
    time: "1637709658.7380311",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-23.92578125",
    c2: "-42.48046875",
    c3: "11.71875",
    c4: "-18.06640625",
  },
  {
    "": "2522",
    time: "1637709658.7419374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-32.71484375",
    c3: "8.7890625",
    c4: "-28.80859375",
  },
  {
    "": "2523",
    time: "1637709658.7458436",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-82.03125",
    c2: "-17.08984375",
    c3: "-8.30078125",
    c4: "-83.984375",
  },
  {
    "": "2524",
    time: "1637709658.74975",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-56.15234375",
    c2: "-33.203125",
    c3: "-11.71875",
    c4: "-77.63671875",
  },
  {
    "": "2525",
    time: "1637709658.7536561",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-17.578125",
    c2: "-38.57421875",
    c3: "-10.25390625",
    c4: "3.41796875",
  },
  {
    "": "2526",
    time: "1637709658.7575624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-18.5546875",
    c2: "-28.80859375",
    c3: "-38.0859375",
    c4: "8.30078125",
  },
  {
    "": "2527",
    time: "1637709658.7614686",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-58.10546875",
    c2: "-33.69140625",
    c3: "-17.578125",
    c4: "-64.453125",
  },
  {
    "": "2528",
    time: "1637709658.765375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-86.9140625",
    c2: "-33.203125",
    c3: "-12.20703125",
    c4: "-74.70703125",
  },
  {
    "": "2529",
    time: "1637709658.7692811",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-42.96875",
    c2: "-39.55078125",
    c3: "-33.203125",
    c4: "-7.32421875",
  },
  {
    "": "2530",
    time: "1637709658.7731874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-48.828125",
    c3: "3.90625",
    c4: "9.765625",
  },
  {
    "": "2531",
    time: "1637709658.7770936",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-67.87109375",
    c2: "-52.734375",
    c3: "18.5546875",
    c4: "-39.0625",
  },
  {
    "": "2532",
    time: "1637709658.780125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-97.16796875",
    c2: "-49.8046875",
    c3: "-22.4609375",
    c4: "-77.1484375",
  },
  {
    "": "2533",
    time: "1637709658.7840312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-37.59765625",
    c2: "-46.875",
    c3: "-33.69140625",
    c4: "-21.97265625",
  },
  {
    "": "2534",
    time: "1637709658.7879374",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-7.32421875",
    c2: "-36.1328125",
    c3: "-7.8125",
    c4: "29.78515625",
  },
  {
    "": "2535",
    time: "1637709658.7918437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-39.55078125",
    c2: "-17.08984375",
    c3: "17.578125",
    c4: "-31.73828125",
  },
  {
    "": "2536",
    time: "1637709658.79575",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-45.8984375",
    c2: "-16.6015625",
    c3: "17.08984375",
    c4: "-83.0078125",
  },
  {
    "": "2537",
    time: "1637709658.7996562",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.8359375",
    c2: "-25.87890625",
    c3: "-1.46484375",
    c4: "-25.390625",
  },
  {
    "": "2538",
    time: "1637709658.8035624",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "9.27734375",
    c2: "-33.69140625",
    c3: "1.953125",
    c4: "19.04296875",
  },
  {
    "": "2539",
    time: "1637709658.8074687",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-16.6015625",
    c2: "-23.92578125",
    c3: "4.8828125",
    c4: "-24.4140625",
  },
  {
    "": "2540",
    time: "1637709658.811375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-43.45703125",
    c2: "-17.578125",
    c3: "-16.6015625",
    c4: "-59.5703125",
  },
  {
    "": "2541",
    time: "1637709658.8152812",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-41.9921875",
    c2: "-36.62109375",
    c3: "-35.64453125",
    c4: "-24.4140625",
  },
  {
    "": "2542",
    time: "1637709658.8191874",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-10.25390625",
    c2: "-36.1328125",
    c3: "-20.5078125",
    c4: "22.4609375",
  },
  {
    "": "2543",
    time: "1637709658.8230937",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "5.859375",
    c2: "-30.76171875",
    c3: "-0.9765625",
    c4: "0.48828125",
  },
  {
    "": "2544",
    time: "1637709658.838125",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-32.71484375",
    c2: "-33.69140625",
    c3: "-18.06640625",
    c4: "-56.15234375",
  },
  {
    "": "2545",
    time: "1637709658.8420312",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-36.62109375",
    c2: "-42.96875",
    c3: "-42.48046875",
    c4: "-65.4296875",
  },
  {
    "": "2546",
    time: "1637709658.8459375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-6.34765625",
    c2: "-53.7109375",
    c3: "-20.01953125",
    c4: "-5.37109375",
  },
  {
    "": "2547",
    time: "1637709658.8498437",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-13.18359375",
    c2: "-57.12890625",
    c3: "-10.7421875",
    c4: "24.90234375",
  },
  {
    "": "2548",
    time: "1637709658.85375",
    channel1: "",
    channel2: "",
    channel3: "",
    channel4: "",
    c1: "-44.43359375",
    c2: "-35.64453125",
    c3: "-38.0859375",
    c4: "-20.5078125",
  },
];

export default EvaBite;
